{
  "general": {
    "save": "შენახვა",
    "edit": "რედაქტირება",
    "close": "დახურვა",
    "cancel": "გაუქმება",
    "send": "გაგზავნა",
    "input": "ჩაწერე",
    "import": "ატვირთვა",
    "select": "აირჩიე"
  },
  "MALE": "მამრობითი",
  "FEMALE": "მდედრობითი",
  "UNKNOWN": "უცნობი",
  "GEL": "ლარი",
  "NAV": {
    "APPLICATIONS": "მენიუ",
    "DASHBOARDS": "მთავარი გვერდი",
    "user-sources": "მომხმარებლის წყაროები",
    "CASHIER": "სალარო",
    "EXPENCE": "გასავალი",
    "USER_STATUS": "მომხმ. სტატუსები",
    "USER_Loyalty": "ლოიალობის სისტემა",
    "offers": "შეთავაზებები",
    "packages": "პაკეტები",
    "terms": "ვერიფიკაცია",
    "questionary-builder": "EHR კითხვარები",
    "add_expences": "გასავლის გატარება",
    "administration": "ადმინისტრაცია",
    "organizations": "ორგანიზაციები",
    "HR": "HR",
    "users": "თანამშრომლები",
    "salary": "ხელფასები",
    "scheduleOverview": "გრაფიკის მიმოხილვა",
    "services": "პროცედურები",
    "customers": "მომხმარებლები",
    "customer_duplicates": "განმეორებადი ნომრები",
    "calendars": "კალენდარი",
    "calendars_daily": "დღის ფორმა",
    "calendars_daily_new": "დღის ფორმა(new)",
    "calendars_room": "დღის ფორმა(ოთახები)",
    "calendars_canceled": "ჩაწერები",
    "online_booking": "ონლაინ ჩაწერები",
    "stats": "სტატისტიკა",
    "stats_detailed": "დეტალური ძებნა",
    "profit_loss": "მოგება-ზარალი",
    "graphs": "გრაფიკული დიაგრამები",
    "transactions": "ტრანზაქციები",
    "transaction_history": "ისტორია",
    "transaction_deleted": "წაშლილები",
    "communication": "კომუნიკაცია",
    "communication_sms": "კომუნიკაცია",
    "communication_history": "გზავნილების ისტორია",
    "operations": "ოპერაციები",
    "consignations": "კონსიგნაციები",
    "expense_categories": "გასავალის კატეგორიები",
    "visitReminder": "ვიზიტის შეხსენება",
    "ehr": "EHR",
    "ehrTemplate": "EHR შაბლონები",
    "erx": "eRX",
    "organization": "ორგანიზაცია",
    "agreement-templates": "თანხმობის შაბლონები",
    "classification_codes": "კლასიფიკაციის კოდები",
    "patients": "პაციენტები",
    "invoices": "ინვოისები",
    "rooms": "ოთახები",
    "booking-sources": "ჯავშნის წყაროები",
    "reports": "რეპორტები",
    "cash_flow": "ფულადი ნაკადები",
    "employee_income": "თანამშრომლების შემოსავალი",
    "service_analytics": "სერვისების ანალიტიკა",
    "category_analytics": "კატეგორიების ანალიტიკა",
    "client_spending": "კლიენტების დახარჯვა",
    "bookinghub": "BookingHub",
    "onlineCatalog": "ონლაინ კატალოგი",
    "service_packages": "სერვის პაკეტები",
    "communication_config": "SMS კონფიგურაცია",
    "birthdayGreetings": "დაბადების დღეები",
    "birthdayConfig": "დაბადების დღის კონფიგურაცია",
    "productions": "პროდუქცია",
    "products": "სრული სია",
    "realizations": "რეალიზაცია"
  },
  "COLUMNS": {
    "transactionId": "ტრანს. #",
    "name": "დასახელება",
    "deletedAt": "წაშლის თარიღი",
    "deletedBy": "წაშალა",
    "disabledAt": "გაუქმების თარიღი",
    "disabledBy": "გააუქმა",
    "disableReason": "გაუქმების მიზეზი",
    "branch": "ფილიალი",
    "legalForm": "სამართლებრივი ფორმა",
    "legalName": "იურ. სახელი",
    "registrationNumber": "ს/ნ",
    "physicalAddress": "ფიზ. მისამ.",
    "legalAddress": "იურ. მისამ.",
    "director": "დირექტორი",
    "identityNumber": "საიდენტიფიკაცი #",
    "mobilePhone": "მობილურის ნომერი",
    "phone": "ტელეფონი",
    "facebook": "facebook",
    "information": "ინფორმაცია",
    "createdAt": "შექმნილი",
    "cardNo": "ბარათის #",
    "selectUser": "მომხმარებლის შეცვლა",
    "updateUser": "მომხმარებლის რედაქტირება",
    "unknownUser": "უცნობი მომხმარებელი",
    "username": "მომხმარებელი",
    "firstname": "სახელი",
    "lastname": "გვარი",
    "fullName": "სახელი, გვარი",
    "gender": "სქესი",
    "birthDate": "დაბადების თარიღი",
    "position": "პოზიცია",
    "productCategory": "კატეგორია",
    "serviceCategory": "კატეგორია",
    "distributor": "მომწოდებელი",
    "quantity": "რაოდენობა",
    "sum": "ჯამი",
    "grSum": "ჯამი(გრამი)",
    "grPerItem": "გრამი ცალში",
    "pricePerItem": "მისაღები ფასი",
    "avgPricePerItem": "მისაღები ფასი(საშუალო)",
    "salePricePerItem": "გასაყიდი ფასი",
    "buyDate": "შეძენის თარიღი",
    "updateDate": "განახლების თარიღი",
    "transactionType": "ტრანზაქციის ტიპი",
    "employee": "თანამშრომელი",
    "user": "მომხმარებელი",
    "service": "სერვისი",
    "priceSum": "გადახდილი",
    "cash": "ნაღდი",
    "card": "ბარათი",
    "price": "ღირებულება",
    "bankTransfer": "საბანკო ოპერაცია",
    "bookingDate": "ჩაწერის თარიღი",
    "startTime": "დაწყ. დრო",
    "endTime": "დასრ. დრო",
    "salePrice": "ფასდ. ფასი",
    "salePercent": "ფასდ. %",
    "fixedPrice": "ფიქს. ლ",
    "fixedPercent": "ფიქს. %",
    "fixedSpend": "ფიქს. ხარჯი",
    "additionalExpense": "დამატებითი ხარჯი",
    "barcode": "ბარკოდი",
    "productCode": "პროდუქტის კოდი",
    "productName": "პროდუქტის დასახელება",
    "productVolume": "პროდუქტის მოცულობა",
    "peymentType": "გადახდის ტიპი",
    "createdBy": "ვინ შექმნა",
    "status": "სტატუსი",
    "unitGram": "მოცულობა",
    "unitQuantity": "რაოდენობა",
    "minutes": "წუთები",
    "balance": "ბალანსი(₾)",
    "employeePercent": "თანამშრომლის %",
    "employeeSalary": "თანამშრომლის ხელფასი",
    "employeFixedPrice": "ფიქსირებული თანხა",
    "specFixedSpend": "სპეც.პროც. დანახარჯი",
    "time": "დრო",
    "isSpecial": "სპეციალური",
    "autoPriceView": "ფასი ავტომატურად",
    "autoTimeView": "დრო ავტომატურად",
    "provider": "პროვაიდერი",
    "providerPrice": "პროვაიდერის ფასი",
    "color": "ფერი",
    "category": "კატეგორია",
    "room": "ოთახი",
    "whStart": "დაწყ. დრო",
    "whEnd": "დასრ. დრო",
    "description": "აღწერა",
    "comment": "კომენტარი",
    "expenceMainCategory": "გასავლის კატეგორია",
    "expenceCategory": "გასავლის ქვე-კატეგორია",
    "date": "თარიღი",
    "openSum": "გახსნისას",
    "addMoney": "დამატებული",
    "income": "შემოსავალი",
    "incomeCash": "ნაღდი ფული",
    "incomeCard": "უნაღდო",
    "outcome": "გასავალი",
    "outcomeCash": "გას. ნაღდი",
    "outcomeCard": "გას. უნაღდო",
    "expense": "ფიქს. ხარჯი",
    "closeSum": "ჩახურვისას",
    "salarySum": "ხელფასები",
    "expenceSum": "სხვა ხარჯები",
    "profit": "მოგება",
    "profit_expense": "მოგება - ფიქს. ხარჯი",
    "insurance": "პროვაიდერი",
    "contactPerson": "საკონტაქტო პერსონა",
    "contactPhone": "საკონტაქტო ტელეფონი",
    "contactMobile": "საკონტაქტო მობილური",
    "OperationNumber": "#",
    "operationType": "ტიპი",
    "operationSource": "ოპერაციის წყარო",
    "operationDate": "თარიღი",
    "bestBefore": "ვარგისია",
    "avgPrice": "საშუალო ფასი",
    "isSpend": "გასავალში გატარება",
    "senderName": "გამგზავნი",
    "to": "მიმღები",
    "eventType": "SMS ტიპი",
    "eventKey": "შეხს. წყარო",
    "schedulePeriod": "შეხს. პერიოდი",
    "messageTemplate": "შეტყობინება",
    "role": "როლი",
    "icdCode": "ICD კოდი",
    "ehrId": "EHR ID",
    "hospitalizationResult": "ჰოსპიტალიზაციის შედეგი",
    "canSchedule": "შესაძლებელია ონლაინ ჩაწერა"
  },
  "PAYMENTTYPE": {
    "1": "ნაღდი ანგარიშსწორება",
    "2": "საბანკო ბარათი",
    "3": "ნაღდი + საბანკო",
    "4": "წუთები",
    "5": "ბალანსი",
    "6": "ბარტერი",
    "7": "კონსიგნაცია",
    "8": "საბანკო ოპერაცია",
    "9": "შერეული გადახდა",
    "10": "ბარათი",
    "11": "გადახდის გარეშე",
    "12": "ონლაინ (BookingHub)"
  },
  "TRANSACTIONTYPE": {
    "SELL": "გაყიდვა",
    "SPEND": "გახარჯვა",
    "EVENT": "ჩაწერა",
    "SALARY": "ხელფასი",
    "REALIZATION": "რეალიზაცია",
    "EXPENCE": "გასავალი",
    "BUY": "შესყიდვა",
    "BALANCEIN": "ბალანსის შევსება",
    "BALANCEOUT": "ბალანსის გახარჯვა",
    "BALANCERETURN": "ბალანსის დაბრუნება",
    "CONSIGNATION": "კონსიგნაცია",
    "CASHIER": "სალარო",
    "CASHIER_OUT": "თანხის გამოტანა"
  },
  "OPERATION_TYPE": {
    "SELL": "გაყიდვა",
    "SPEND": "გახარჯვა",
    "EVENT": "პროცედურა",
    "EVENT_SPEC": "სპეც. პროცედურა",
    "SALARY": "ხელფასი დარიცხვა",
    "SALARY_OUT": "ხელფასის გაცემა",
    "REALIZATION": "რეალიზაცია",
    "EXPENCE": "გასავალი",
    "BUY": "შესყიდვა",
    "BALANCEIN": "ბალანსის შევსება",
    "BALANCEOUT": "ბალანსის გახარჯვა",
    "BALANCERETURN": "ბალანსის დაბრუნება",
    "CASHIER_ADD": "თანხის დამატება",
    "CASHIER_OUT": "თანხის გამოტანა",
    "CONSIGNATION_PAY": "კონსიგნაციის დაფარვა",
    "PACKAGE_ITEM": "პაკეტის სერვისი"
  },
  "OPERATION_SOURCE": {
    "NONE": "N/A",
    "BOOKING": "ჩაწერა",
    "SALARY": "ხელფასი",
    "REALIZATION": "რეალიზაცია",
    "EXPENCE": "გასავალი",
    "BUY": "შესყიდვა",
    "PURCHASE": "შესყიდვა",
    "BALANCEIN": "ბალანსის შევსება",
    "BALANCE": "ბალანსის შევსება",
    "BALANCERETURN": "ბალანსის დაბრუნება",
    "CASHIER": "სალარო",
    "SERVICE_PACKAGE": "სერვისის პაკეტი"
  },
  "operation": {
    "detailsByBank": "დეტალები ბანკების მიხედვით",
    "noBankInfo": "ბანკის მიხედვით ინფორმაცია არ არის",
    "editComment": "კომენტარის რედაქტირება",
    "commentHistory": "კომენტარის ისტორია",
    "noCommentEdits": "ცვლილებები არ არის",
    "editedBy": "შეცვალა: {{name}}",
    "editCommentFailed": "კომენტარის შენახვა ვერ მოხერხდა"
  },
  "PAGINATION": {
    "page": "გვერდი",
    "pageCount": "სულ"
  },
  "CASHIER": {
    "date": "თარიღი",
    "yesNo": "ნამდვილად გსურთ დღის დახურვა?",
    "start": "დაწყება",
    "finish": "დასრულება",
    "update": "განახლება",
    "edit": "რედაქტირება",
    "page": "გვერდი",
    "openingDay": " დღის გახსნა",
    "addCash": "თანხის დამატება",
    "addSum": "თანხა",
    "comment": "კომენტარი",
    "reOpen": "დახურვის გაუქმება",
    "reOpenConfirm": "ნამდვილად გსურთ დახურვის გაუქმება?",
    "need_open": "სალარო დახურულია",
    "operationType": "ოპერაციის ტიპი",
    "statistic": {
      "edit": "სალაროს გახსნის ცვლილება",
      "addCash": "თანხის დამატება",
      "payoutCash": "თანხის გატანა",
      "openSum": "თანხა დღის გახსნისას",
      "close": "სალაროს დახურვა",
      "open": "სალაროს გახსნა",
      "income": "შემოსავალი",
      "expense": "ფიქს.ხარჯი",
      "additionalExpense": "დამატ.ხარჯი",
      "outcome": "გასავალი",
      "currentSum": "მიმდინარე თანხა"
    },
    "COLUMNS": {
      "date": "თარიღი",
      "openSum": "გახსნისას",
      "addMoney": "დამატებული/გატანილი",
      "income": "შემოსავალი",
      "incomeCash": "ნაღდი ფული",
      "incomeCard": "უნაღდო",
      "incomeBank": "საბანკო",
      "outcome": "გასავალი",
      "outcomeBank": "გას. საბანკო",
      "outcomeCash": "გას. ნაღდი",
      "outcomeCard": "გას. უნაღდო",
      "expense": "პროდუქტების ხარჯი",
      "additionalExpense": "დამატებითი ხარჯი",
      "closeSum": "ჩახურვისას",
      "createdBy": "ვინ გახსნა",
      "comment": "კომენტარი",
      "openedAt": "გახსნის თარიღი",
      "closedAt": "დახურვის თარიღი",
      "closedBy": "ვინ დახურა"
    },
    "advanced": {
      "currentTab": "მიმდინარე სალარო",
      "historyTab": "გასული თარიღის სალაროები",
      "transactions": "ტრანზაქციები",
      "noBank": "ბანკის გარეშე",
      "refresh": "განახლება",
      "export": "ექსპორტი",
      "retry": "თავიდან ცდა",
      "loadFailed": "მონაცემების ჩატვირთვა ვერ მოხერხდა",
      "exportFailed": "ექსპორტი ვერ მოხერხდა",
      "reopen": "ხელახლა გახსნა",
      "reopenConfirm": "დარწმუნებული ხართ, რომ გსურთ სალაროს ხელახლა გახსნა?",
      "clearFilter": "ფილტრის გასუფთავება",
      "time": "დრო",
      "type": "ტიპი",
      "method": "გადახდის მეთოდი",
      "bank": "ბანკი",
      "amount": "თანხა",
      "total": "ჯამი",
      "date": "თარიღი",
      "cash": "ნაღდი",
      "card": "ბარათი",
      "cashInDrawer": "ნაღდი ფული სალაროში",
      "addMoney": "თანხის დამატება",
      "subMoney": "თანხის გატანა",
      "closeDay": "დღის დახურვა",
      "bankTransfer": "საბანკო",
      "openedAt": "გახსნის დრო",
      "openedBy": "გახსნა",
      "tour": {
        "next": "შემდეგი",
        "prev": "წინა",
        "done": "დასრულება",
        "progress": "{{current}} / {{total}}",
        "tabsTitle": "ორი ჩანართი",
        "tabsBody": "„მიმდინარე სალარო“ — დღევანდელი სალარო. „გასული თარიღის სალაროები“ — დახურული დღეების ისტორია.",
        "daySummaryTitle": "დღის შეჯამება",
        "daySummaryBody": "აქ ერთ ბარათზე ჩანს სალაროს მდგომარეობა: ნაშთი, შემოსავალი და გასავალი.",
        "actionsTitle": "სწრაფი მოქმედებები",
        "actionsBody": "თანხის დამატება, გატანა და სხვა მოქმედებები. მიიტანეთ კურსორი ხატულაზე მისი დასახელების სანახავად.",
        "dayStateTitle": "დღის გახსნა და დახურვა",
        "dayStateBody": "სალაროს დღის გახსნა და დახურვა ამ ღილაკით ხდება.",
        "banksTitle": "ბანკების მიხედვით",
        "banksBody": "დააჭირეთ ბანკს და ქვემოთ მხოლოდ ამ ბანკის ტრანზაქციები გამოჩნდება.",
        "bannerTitle": "ვერსიის გადართვა",
        "bannerBody": "26 ოქტომბრამდე აქედან შეგიძლიათ ძველ ვერსიაზე დაბრუნება ან ამ ტურის თავიდან ნახვა.",
        "learnMore": "დეტალური გაცნობა",
        "sectionHelpTitle": "დეტალური გაცნობა",
        "sectionHelpBody": "ყოველ განყოფილებასთან არის ? ღილაკი — დააჭირეთ და ნახავთ ამ ნაწილის დეტალურ ახსნას: ბარათებს, მოქმედებებს, ტრანზაქციებს და დახურულ დღეებს.",
        "sections": {
          "summary": {
            "openCardTitle": "საწყისი ნაშთი",
            "openCardBody": "სალაროში არსებული თანხა დღის გახსნისას.",
            "openMovesTitle": "დამატება და გატანა",
            "openMovesBody": "მწვანე — დღის განმავლობაში დამატებული თანხა, წითელი — გატანილი. მარჯვნივ სალაროს დღის თარიღია.",
            "openedByTitle": "ვინ და როდის გახსნა",
            "openedByBody": "დღის გახსნის დრო და თანამშრომელი, რომელმაც სალარო გახსნა.",
            "incomeCardTitle": "შემოსავალი",
            "incomeCardBody": "დღის მთლიანი შემოსავალი ყველა გადახდის მეთოდით.",
            "incomeMethodsTitle": "გადახდის მეთოდები",
            "incomeMethodsBody": "შემოსავალი დაყოფილია: ნაღდი, ბარათი და საბანკო გადარიცხვა. ბარათისა და გადარიცხვის ქვეშ ჩანს, რომელ ბანკზე რამდენი შევიდა.",
            "incomeExpensesTitle": "ხარჯები",
            "incomeExpensesBody": "პროდუქტის ხარჯი, დამატებითი ხარჯი და მათი ჯამი.",
            "incomeBanksTitle": "შემოსავალი ბანკების მიხედვით",
            "incomeBanksBody": "ბარათით და გადარიცხვით მიღებული თანხა ბანკების მიხედვით. დააჭირეთ ბანკს და ქვემოთ მხოლოდ მისი ტრანზაქციები დარჩება.",
            "outcomeCardTitle": "გასავალი",
            "outcomeCardBody": "დღის მთლიანი გასავალი.",
            "outcomeMethodsTitle": "გასავლის მეთოდები",
            "outcomeMethodsBody": "გასავალი დაყოფილია: ნაღდი, ბარათი და საბანკო გადარიცხვა. ბარათისა და გადარიცხვის ქვეშ ჩანს ბანკების მიხედვით.",
            "outcomeBanksTitle": "გასავალი ბანკების მიხედვით",
            "outcomeBanksBody": "დააჭირეთ ბანკს და ქვემოთ მხოლოდ ამ ბანკის ტრანზაქციები გამოჩნდება.",
            "currentCardTitle": "მიმდინარე ნაშთი",
            "currentCardBody": "ნაღდი თანხა, რომელიც ახლა სალაროში უნდა იყოს."
          },
          "actions": {
            "addTitle": "თანხის დამატება",
            "addBody": "სალაროში ნაღდი თანხის შეტანა, მაგალითად ხურდისთვის.",
            "subTitle": "თანხის გატანა",
            "subBody": "სალაროდან ნაღდი თანხის გატანა.",
            "editOpenTitle": "საწყისი ნაშთის რედაქტირება",
            "editOpenBody": "შეასწორეთ დღის საწყისი ნაშთი, თუ ის არასწორადაა შეყვანილი.",
            "refreshTitle": "განახლება",
            "refreshBody": "სალაროს მონაცემების თავიდან ჩატვირთვა.",
            "dayStateTitle": "დღის გახსნა და დახურვა",
            "dayStateBody": "დღის დასაწყისში გახსენით სალარო, ბოლოს — დახურეთ. ახლახან დახურული დღის ხელახლა გახსნაც აქედან ხდება."
          },
          "transactions": {
            "filtersTitle": "ფილტრები",
            "filtersBody": "გაფილტრეთ ტრანზაქციები ტიპის, გადახდის მეთოდის და ბანკის მიხედვით.",
            "refreshTitle": "განახლება",
            "refreshBody": "ტრანზაქციების სიის თავიდან ჩატვირთვა.",
            "exportTitle": "ექსპორტი",
            "exportBody": "ჩამოტვირთეთ ტრანზაქციები Excel ფაილად.",
            "colTimeTitle": "დრო",
            "colTimeBody": "ტრანზაქციის შესრულების დრო.",
            "colKindTitle": "ტიპი და მეთოდი",
            "colKindBody": "რა ოპერაციაა (მაგ. ვიზიტის გადახდა, თანხის დამატება) და როგორ გადაიხადეს.",
            "colBankTitle": "როგორ გადაიხადეს",
            "colBankBody": "ჯამი დაშლილია გადახდის მეთოდებად: ნაღდი, ბარათი და საბანკო გადარიცხვა. ბარათისა და გადარიცხვის თანხას გვერდით ბანკი უწერია; ნაღდ ფულს ბანკი არ აქვს.",
            "colAmountTitle": "ჯამი",
            "colAmountBody": "ტრანზაქციის სრული თანხა — ნაღდის, ბარათისა და საბანკო გადარიცხვის ჯამი."
          },
          "history": {
            "rangeTitle": "პერიოდი",
            "rangeBody": "აირჩიეთ თარიღები და ნახეთ ამ პერიოდის დახურული დღეები.",
            "refreshTitle": "განახლება",
            "refreshBody": "სიის თავიდან ჩატვირთვა.",
            "exportTitle": "ექსპორტი",
            "exportBody": "ჩამოტვირთეთ დახურული დღეები Excel ფაილად.",
            "colDateTitle": "თარიღი",
            "colDateBody": "სალაროს დღე.",
            "colOpenTitle": "საწყისი ნაშთი და მოძრაობა",
            "colOpenBody": "დღის საწყისი ნაშთი და დღის განმავლობაში დამატებული ან გატანილი თანხა.",
            "colIncomeTitle": "შემოსავალი",
            "colIncomeBody": "მთლიანი შემოსავალი და მისი დაყოფა: ნაღდი, ბარათი, გადარიცხვა. ბარათისა და გადარიცხვის სვეტებში თანხა ბანკების მიხედვითაც ჩანს.",
            "colOutcomeTitle": "გასავალი",
            "colOutcomeBody": "მთლიანი გასავალი და მისი დაყოფა: ნაღდი, ბარათი, გადარიცხვა, ბანკების მიხედვით.",
            "colExpenseTitle": "ხარჯები",
            "colExpenseBody": "პროდუქტის ხარჯი და დამატებითი ხარჯი.",
            "colCloseTitle": "საბოლოო ნაშთი",
            "colCloseBody": "სალაროში დარჩენილი თანხა დღის დახურვისას.",
            "colPeopleTitle": "გახსნა და დახურვა",
            "colPeopleBody": "როდის და ვინ გახსნა და დახურა სალარო.",
            "colCommentTitle": "კომენტარი",
            "colCommentBody": "დღის დახურვისას დატოვებული კომენტარი.",
            "rowActionsTitle": "მოქმედებები",
            "rowActionsBody": "განახლება — დღის თანხების თავიდან დათვლა. რედაქტირება — საწყისი ნაშთის შესწორება."
          }
        }
      }
    },
    "versionSwitch": {
      "oldBanner": "სალაროს განახლებული ვერსია უკვე ხელმისაწვდომია. 26 ოქტომბრამდე შეგიძლიათ სცადოთ და სურვილის შემთხვევაში ძველ ვერსიას დაუბრუნდეთ.",
      "newBanner": "თქვენ იყენებთ სალაროს განახლებულ ვერსიას. 26 ოქტომბრამდე შეგიძლიათ ძველ ვერსიაზე დაბრუნება, ამ თარიღიდან კი მხოლოდ ახალი ვერსია დარჩება.",
      "tryNew": "ახალ ვერსიაზე გადასვლა",
      "backToOld": "ძველ ვერსიაზე დაბრუნება",
      "tour": "გაცნობითი ტური",
      "confirmToNewTitle": "გადავიდეთ სალაროს ახალ ვერსიაზე?",
      "confirmToOldTitle": "დავუბრუნდეთ სალაროს ძველ ვერსიას?",
      "confirmBody": "ცვლილება შეეხება ფილიალის ყველა თანამშრომელს. სალაროს მონაცემები არ შეიცვლება.",
      "failed": "ვერსიის შეცვლა ვერ მოხერხდა. სცადეთ თავიდან."
    }
  },
  "USER": {
    "cardNo": "ბარათის ნომერი",
    "firstname": "სახელი",
    "lastname": "გვარი",
    "mobilePhone": "მობილურის ნომერი",
    "phone": "სახლის ტელეფონი",
    "identityNumber": "პირადი ნომერი",
    "gender": "სქესი",
    "birthDate": "დაბადების თარიღი",
    "email": "ელ.ფოსტა",
    "description": "დამატებითი ინფორმაცია"
  },
  "EMPLOYEE": {
    "cardNo": "ბარათის ნომერი",
    "firstname": "სახელი",
    "lastname": "გვარი",
    "mobilePhone": "მობილურის ნომერი",
    "phone": "სახლის ტელეფონი",
    "identityNumber": "პირადი ნომერი",
    "gender": "სქესი",
    "birthDate": "დაბადების თარიღი",
    "email": "ელ.ფოსტა",
    "description": "დამატებითი ინფორმაცია",
    "workType": "ხელფასის ტიპი",
    "fixedSalary": "ფიქსირებული ხელფასი",
    "outputPercent": "გამომუშავების %",
    "inCalendar": "გამოჩნდეს კალენდარში",
    "visibleInApp": "გამოჩნდეს აპლიკაციაში",
    "workOff": {
      "planDay": "დღის დაგეგმვა",
      "planCalendar": "კალენდრის დაგეგმვა",
      "workHours": "სამუშაო საათები",
      "breakHours": "შესვენება",
      "vacation": "შვებულება",
      "dayOff": "Day Off",
      "download": "გადმოწერა",
      "workStart": "მოსვლა",
      "workEnd": "წასვლა",
      "breakStart": "შესვენების დაწყება",
      "breakEnd": "შესვენების დასრულება",
      "clearDays": "გრაფიკის გაუქმება",
      "selectYear": "აირჩიე წელი",
      "selectMonth": "აირჩიე თვე",
      "selectWeekday": "აირჩიე კვირის დღე",
      "workInterval": "სამუშაო დრო",
      "breakInterval": "შესვენების დრო",
      "addVacation": "შვებულების დამატება",
      "selectDate": "აირჩიე თარიღი",
      "exclamation": "თუ არც ერთი დღე არ არის არჩეული, იგულისმება, რომ არჩეულია ყველა",
      "messageCreatedDayOff": "Day Off წარმატებით დაემატა კალენდარში",
      "messageCreatedVacation": "შვებულების დღეები წარმატებით დაემატა კალენდარში",
      "messagePlannedCalendar": "კალენდრის დაგეგმვა წარმატებით დასრულდა",
      "errorWorkTime": "მოსვლის დრო აღემატება წასვლის დროს",
      "errorBreakTime": "შესვენების დაწყების დრო აღემატება შესვენების დასრულების დროს",
      "planWorkdaysTooltip": "კონკრეტული დღეების დასაგეგმად, აირჩიეთ თარიღი კალენდარზე",
      "clearDataByMonth": "თქვენ აუქმებთ თვის გრაფიკს, ნამდვილად გსურთ გაუქმება?",
      "clearDataByYear": "თქვენ აუქმებთ წლის გრაფიკს, ნამდვილად გსურთ გაუქმება?",
      "clearDataTitle": "გრაფიკის გაუქმება"
    }
  },
  "WORKTYPE": {},
  "HR": {
    "employee": {
      "positions": "პოზიციები",
      "employees": "თანამშრომლები"
    }
  },
  "PAYROLL": {
    "title": "ხელფასების დარიცხვა",
    "periods": "საანგარიშო პერიოდები",
    "year": "წელი",
    "period": "პერიოდი",
    "status": "სტატუსი",
    "total": "ჯამი",
    "open": "გახსნა",
    "calculate": "დაანგარიშება",
    "recalculate": "ხელახლა დაანგარიშება",
    "generateYear": "{{year}} წლის პერიოდების გენერაცია",
    "generated": "პერიოდები დაგენერირდა",
    "back": "პერიოდებზე დაბრუნება",
    "employees": "{{count}} თანამშრომელი",
    "finalSalary": "საბოლოო ხელფასი",
    "formerEmployee": "ყოფილი თანამშრომელი",
    "noLines": "ამ დარიცხვაში ჩანაწერები არ არის.",
    "noPeriodsTitle": "{{year}} წლის საანგარიშო პერიოდები არ არსებობს",
    "noPeriodsHint": "დააგენერირეთ თქვენი კონფიგურირებული ციკლიდან.",
    "retry": "თავიდან ცდა",
    "state": {
      "calculated": "დაანგარიშებული",
      "approved": "დამტკიცებული",
      "ended": "არ არის დაანგარიშებული",
      "inProgress": "მიმდინარე",
      "upcoming": "მომავალი"
    },
    "kind": {
      "FIXED": "ფიქსირებული",
      "COMMISSION": "პროცენტი",
      "ADJUSTMENT": "კორექტირება",
      "CORRECTION": "შესწორება"
    },
    "recalcConfirm": {
      "title": "ხელახლა დაანგარიშდეს ეს პერიოდი?",
      "body": "მიმდინარე მონაცემები წაიშლება და ჩანაცვლდება.",
      "ok": "ხელახლა დაანგარიშება",
      "cancel": "გაუქმება"
    },
    "skipped": {
      "warning": "{{count}} თანამშრომელი გამოტოვებულია",
      "review": "ნახვა",
      "title": "გამოტოვებული თანამშრომლები",
      "setRate": "ანაზღაურების მითითება",
      "reason": {
        "NO_RATE_SLICE": "ანაზღაურება არ არის მითითებული",
        "NOT_EMPLOYED_IN_PERIOD": "ამ პერიოდში არ იყო დასაქმებული"
      }
    },
    "rate": {
      "title": "ანაზღაურების მითითება",
      "fixedSalary": "ფიქსირებული ხელფასი (თვეში)",
      "outputPercent": "პროცენტი (გამომუშავებიდან)",
      "effectiveFrom": "ძალაშია თარიღიდან",
      "save": "შენახვა",
      "cancel": "გაუქმება",
      "saved": "ანაზღაურება შენახულია",
      "recalculateNow": "ახლავე დაანგარიშება",
      "current": "მიმდინარე: {{fixed}} + {{percent}}%",
      "none": "ანაზღაურება არ არის მითითებული",
      "history": {
        "title": "ანაზღაურების ისტორია",
        "current": "მიმდინარე",
        "previous": "წინა",
        "openEnded": "{{from}}-დან",
        "closed": "{{from}} → {{to}}",
        "none": "ადრინდელი ანაზღაურება არ არის"
      }
    },
    "errors": {
      "notEnabled": "ამ ფილიალზე ხელფასების მოდული ჯერ არ არის ჩართული.",
      "forbidden": "ამ მოქმედების უფლება არ გაქვთ.",
      "futurePeriod": "ეს პერიოდი ჯერ არ დაწყებულა.",
      "runConflict": "ამ პერიოდს სხვა ანგარიშობს. სცადეთ ცოტა ხანში.",
      "runNotFound": "ეს დარიცხვა აღარ არსებობს.",
      "periodNotFound": "ეს პერიოდი აღარ არსებობს.",
      "periodBranchMismatch": "ეს პერიოდი სხვა ფილიალს ეკუთვნის.",
      "rateBackdate": "თარიღი მიმდინარე ანაზღაურების დაწყებამდეა. აირჩიეთ გვიანდელი თარიღი.",
      "rateTerminateBeforeStart": "დასრულების თარიღი მიმდინარე ანაზღაურების დაწყებამდეა.",
      "rateNegative": "ხელფასი და პროცენტი უარყოფითი ვერ იქნება.",
      "rateRangeInverted": "დასრულების თარიღი დაწყების თარიღზე ადრეა.",
      "carryForwardSystemOnly": "გადმოტანილი ნაშთი სისტემის მიერ იქმნება და ხელით ვერ დაემატება.",
      "recurUntilNotAllowed": "დასრულების თარიღი მხოლოდ განმეორებად ბონუსს შეიძლება ჰქონდეს.",
      "recurUntilBackward": "დასრულების თარიღი მიმდინარეზე გვიანი უნდა იყოს.",
      "foreignEmployee": "ეს თანამშრომელი თქვენს ორგანიზაციაში არ არის.",
      "adjustmentNotFound": "ეს კორექტირება აღარ არსებობს.",
      "equalSplitWeekly": "თანაბარი გაყოფა ვერ გამოიყენება ყოველკვირეულ ციკლთან.",
      "rangeInverted": "დაწყების თარიღი დასრულების თარიღზე გვიანია.",
      "runAlreadyApproved": "ეს დარიცხვა უკვე დამტკიცებულია.",
      "runNotApproved": "ეს დარიცხვა არ არის დამტკიცებული.",
      "runHasPayouts": "ამ დარიცხვაზე გადახდები უკვე დაფიქსირდა. დამტკიცების გასაუქმებლად ჯერ წაშალეთ ისინი.",
      "nextPeriodMissing": "თანამშრომელს დარჩა დასაბრუნებელი თანხა, შემდეგი პერიოდი კი არ არსებობს. ჯერ შექმენით შემდეგი პერიოდი.",
      "carryForwardConsumed": "მომდევნო დარიცხვამ უკვე გამოიყენა ამ დარიცხვის ნაშთი, ამიტომ დამტკიცების გაუქმება აღარ შეიძლება.",
      "employeeNotInRun": "ეს თანამშრომელი ამ დარიცხვაში არ არის.",
      "lineNotFound": "ეს ხელფასის ჩანაწერი აღარ არსებობს. განაახლეთ დარიცხვა.",
      "payoutExceedsBalance": "ეს თანხა აღემატება დარჩენილ დავალიანებას.",
      "payoutZero": "შეიყვანეთ თანხა.",
      "payoutNotFound": "ეს გადახდა აღარ არსებობს.",
      "runBranchMismatch": "ეს დარიცხვა სხვა ფილიალს ეკუთვნის.",
      "bankIdRequired": "აირჩიეთ ბანკი გადარიცხვისთვის.",
      "bankIdNotAllowedForCash": "ნაღდ ანგარიშსწორებას ბანკი არ სჭირდება.",
      "duplicateTenderMethod": "თითოეული გადახდის მეთოდი ერთ თანამშრომელზე მხოლოდ ერთხელ შეიძლება.",
      "generic": "დაფიქსირდა შეცდომა. სცადეთ თავიდან."
    },
    "pay": {
      "approve": "დამტკიცება",
      "unapprove": "დამტკიცების გაუქმება",
      "approveAndPay": "დამტკიცება და გადახდა",
      "recordPayment": "გადახდის დაფიქსირება",
      "approvedOn": "დამტკიცდა {{date}}",
      "paid": "გადახდილი {{amount}}",
      "remaining": "დარჩენილი {{amount}}",
      "owed": "დასარიცხი {{amount}}",
      "settled": "სრულად გადახდილი",
      "nothingToPay": "გადასახდელი არაფერია",
      "date": "თარიღი",
      "cash": "ნაღდი",
      "bank": "ბანკი",
      "addBank": "ბანკის დამატება",
      "removeLeg": "წაშლა",
      "chooseBank": "ბანკი",
      "summary": "{{count}} თანამშრომელი · {{amount}}",
      "submit": "გადახდა",
      "cancel": "გაუქმება",
      "noPayouts": "გადახდები ჯერ არ დაფიქსირებულა.",
      "history": "გადახდები",
      "void": "გადახდის წაშლა",
      "approveConfirm": {
        "title": "დავამტკიცოთ ეს დარიცხვა?",
        "body": "ამის შემდეგ თანხები იბლოკება და გადათვლა აღარ იქნება შესაძლებელი. სანამ გადახდა არ დაფიქსირდება, დამტკიცების გაუქმება შეგიძლიათ.",
        "ok": "დამტკიცება",
        "cancel": "გაუქმება"
      },
      "unapproveConfirm": {
        "title": "გავაუქმოთ დამტკიცება?",
        "body": "დარიცხვა კვლავ გადათვლადი გახდება.",
        "ok": "გაუქმება",
        "cancel": "დახურვა"
      },
      "voidConfirm": {
        "title": "წავშალოთ ეს გადახდა?",
        "body": "{{amount}} დაუბრუნდება {{name}}-ის დარჩენილ დავალიანებას და სალაროს ჩანაწერი გაუქმდება.",
        "ok": "წაშლა",
        "cancel": "გაუქმება"
      },
      "approved": "დარიცხვა დამტკიცდა.",
      "unapproved": "დამტკიცება გაუქმდა.",
      "recorded": "გადახდა დაფიქსირდა.",
      "voided": "გადახდა წაიშალა.",
      "total": "სულ დარიცხული",
      "paidLabel": "გადახდილი",
      "remainingLabel": "დარჩენილი",
      "payMany": "რამდენიმეს გადახდა",
      "exitBatch": "არჩევის დასრულება",
      "colName": "თანამშრომელი",
      "colOwed": "დარიცხული",
      "colPaid": "გადახდილი",
      "colRemaining": "დარჩენილი",
      "partial": "ნაწილობრივ",
      "due": "გადასახდელი",
      "nothingToPayGroup": "{{count}} თანამშრომელს ამ პერიოდში გადასახდელი არ აქვს",
      "countDue": "{{count}} გადასახდელი",
      "countDone": "{{count}} დასრულდა",
      "colPayment": "გადახდა",
      "people": "{{count}} თანამშრომელი",
      "payThis": "გადახდა…"
    },
    "nav": {
      "periods": "პერიოდები",
      "adjustments": "კორექტირებები",
      "report": "გამომუშავება",
      "settings": "პარამეტრები",
      "audit": "ისტორია"
    },
    "adjust": {
      "title": "კორექტირებები",
      "add": "კორექტირების დამატება",
      "none": "ამ ფილტრებით ჩანაწერი არ მოიძებნა",
      "filterEmployee": "თანამშრომელი",
      "filterType": "ტიპი",
      "allEmployees": "ყველა თანამშრომელი",
      "allTypes": "ყველა ტიპი",
      "systemGenerated": "სისტემის მიერ შექმნილი",
      "recurringSpan": "ყოველთვიურად, {{from}} → {{to}}",
      "recurringOpen": "ყოველთვიურად, {{from}}-დან",
      "unknownEmployee": "უცნობი თანამშრომელი",
      "family": {
        "BONUS": "ბონუსი",
        "PENALTY": "ჯარიმა",
        "CORRECTION": "შესწორება"
      },
      "kind": "სახეობა",
      "employee": "თანამშრომელი",
      "amount": "თანხა",
      "date": "თარიღი",
      "reason": "მიზეზი",
      "recurUntil": "გამეორება თარიღამდე",
      "adds": "ემატება +{{amount}}",
      "deducts": "აკლდება −{{amount}}",
      "save": "შენახვა",
      "cancel": "გაუქმება",
      "saved": "კორექტირება შენახულია",
      "type": {
        "BONUS_ONE_OFF": "ბონუსი",
        "BONUS_RECURRING": "განმეორებადი ბონუსი",
        "BONUS_KPI": "KPI ბონუსი",
        "PENALTY_ABSENCE": "ჯარიმა — გაცდენა",
        "PENALTY_LATENESS": "ჯარიმა — დაგვიანება",
        "PENALTY_DAMAGE": "ჯარიმა — ზიანი",
        "CORRECTION_ADD": "შესწორება (დამატება)",
        "CORRECTION_DEDUCT": "შესწორება (გამოკლება)",
        "CARRY_FORWARD": "გადმოტანილი ნაშთი"
      },
      "endRecurrence": {
        "action": "გამეორების შეწყვეტა",
        "title": "შეწყდეს ეს ბონუსი თარიღის შემდეგ?",
        "body": "უკვე გაცემული თანხები რჩება. არჩეული თარიღის შემდეგ აღარაფერი გაიცემა.",
        "field": "შეწყვეტა თარიღის შემდეგ",
        "ok": "შეწყვეტა",
        "cancel": "გაუქმება",
        "done": "გამეორება შეწყდა"
      },
      "revoke": {
        "action": "წაშლა",
        "title": "წაიშალოს ეს კორექტირება?",
        "body": "წაიშლება ყველა გადაუხდელი პერიოდიდან, წარსულის ჩათვლით.",
        "ok": "წაშლა",
        "cancel": "გაუქმება",
        "done": "კორექტირება წაიშალა"
      },
      "staleness": {
        "affectsRun": "{{date}}-ს უკვე ფარავს დაანგარიშებული დარიცხვა, და მისი თანხები აღარ მოიცავს ამას.",
        "openRun": "დარიცხვის გახსნა",
        "noPeriod": "{{date}}-ს არცერთი პერიოდი არ ფარავს, ამიტომ ეს არ გაიცემა სანამ პერიოდები არ დაგენერირდება."
      },
      "groupFamily": "კატეგორია",
      "groupType": "ტიპი",
      "short": {
        "BONUS_ONE_OFF": "ერთჯერადი",
        "BONUS_RECURRING": "განმეორებადი",
        "BONUS_KPI": "KPI",
        "PENALTY_ABSENCE": "გაცდენა",
        "PENALTY_LATENESS": "დაგვიანება",
        "PENALTY_DAMAGE": "ზიანი",
        "CORRECTION_ADD": "დამატება",
        "CORRECTION_DEDUCT": "გამოკლება",
        "CARRY_FORWARD": "გადმოტანილი"
      },
      "err": {
        "employee": "აირჩიეთ თანამშრომელი",
        "amount": "შეიყვანეთ თანხა 0.01-დან 1 000 000-მდე",
        "date": "აირჩიეთ თარიღი",
        "reason": "მიუთითეთ მიზეზი (მაქს. 500 სიმბოლო)",
        "recurUntil": "დასრულების თარიღი უნდა იყოს ძალაში შესვლის თარიღის შემდეგ"
      }
    },
    "settings": {
      "title": "ხელფასის პარამეტრები",
      "editing": "რედაქტირება",
      "orgDefault": "ორგანიზაციის ნაგულისხმევი",
      "thisBranch": "ეს ფილიალი",
      "orgDefaultLocked": "ფილიალს აქვს საკუთარი პარამეტრები, ამიტომ ორგანიზაციის ნაგულისხმევი აქ არ იკითხება.",
      "cycle": "ციკლი",
      "prorationBasis": "პროპორციის ბაზისი",
      "splitDay": "გაყოფის დღე",
      "inheriting": "ეს ფილიალი იყენებს ორგანიზაციის ნაგულისხმევს.",
      "overridden": "ამ ფილიალს აქვს საკუთარი პარამეტრები.",
      "orgWarning": "ეს არის ნაგულისხმევი ყველა ფილიალისთვის, რომელსაც საკუთარი არ აქვს.",
      "periodsWarning": "{{year}} წლისთვის უკვე არსებობს {{count}} პერიოდი. ციკლის შეცვლა მოქმედებს მხოლოდ ახლად შექმნილ პერიოდებზე.",
      "confirmOrg": {
        "title": "შეიცვალოს ორგანიზაციის ნაგულისხმევი?",
        "body": "ეს შეეხება ყველა ფილიალს, რომელსაც საკუთარი პარამეტრები არ აქვს.",
        "ok": "შეცვლა",
        "cancel": "გაუქმება"
      },
      "save": "შენახვა",
      "saved": "პარამეტრები შენახულია",
      "cycleValue": {
        "MONTHLY": "ყოველთვიური",
        "SEMI_MONTHLY": "თვეში ორჯერ",
        "WEEKLY": "ყოველკვირეული"
      },
      "basisValue": {
        "CYCLE_SHARE": "ციკლის წილი",
        "SCHEDULED_DAYS": "დაგეგმილი დღეები",
        "EQUAL_SPLIT": "თანაბარი გაყოფა"
      },
      "equalSplitWeeklyHint": "თანაბარი გაყოფა ვერ გამოიყენება ყოველკვირეულ ციკლთან."
    },
    "report": {
      "title": "გამომუშავება თანამშრომლების მიხედვით",
      "subtitle": "მთლიანი გამომუშავება — პროცენტის გამოკლებამდე; არ მოიცავს ფიქსირებულ ხელფასს, ბონუსებსა და ჯარიმებს.",
      "from": "დან",
      "to": "მდე",
      "employee": "თანამშრომელი",
      "allEmployees": "ყველა თანამშრომელი",
      "run": "ჩვენება",
      "transactions": "ტრანზაქციები",
      "generatedOutput": "გამომუშავება",
      "none": "ამ თარიღებში გამომუშავება არ დაფიქსირებულა",
      "toPayroll": "რეალური ხელფასისთვის გახსენით დარიცხვა"
    },
    "export": "ექსპორტი",
    "exporting": "მიმდინარეობს…",
    "audit": {
      "title": "ისტორია",
      "empty": "ჩანაწერები ჯერ არ არის.",
      "emptyFiltered": "ფილტრს ჩანაწერი არ შეესაბამება.",
      "screenTitle": "ხელფასის ისტორია",
      "filterAction": "მოქმედება",
      "filterEmployee": "თანამშრომელი",
      "filterFrom": "დან",
      "filterTo": "მდე",
      "filterAll": "ყველა",
      "reset": "გასუფთავება",
      "count": "{{count}} ჩანაწერი",
      "action": {
        "RUN_CALCULATE": "დაანგარიშდა",
        "RUN_APPROVE": "დამტკიცდა",
        "RUN_UNAPPROVE": "დამტკიცება გაუქმდა",
        "PAYOUT_RECORD": "გადაიხადა",
        "PAYOUT_VOID": "გადახდა წაიშალა",
        "ADJUSTMENT_CREATE": "დაემატა კორექტირება",
        "ADJUSTMENT_REVOKE": "კორექტირება გაუქმდა",
        "RATE_SET": "შეიცვალა განაკვეთი"
      }
    }
  },
  "SALARY": {
    "gel": "₾",
    "wantContinue": "ნამდვილად გსურთ გაგრძელება?",
    "COLUMN": {
      "employee": "თანამშრომელი",
      "generatedCash": "გამომუშავებული (GEL)",
      "generatedSale": "პროდუქტები",
      "sum": "ჯამი (GEL)",
      "remainSalary": "გასაცემი",
      "salarySumOut": "გაცემული"
    },
    "comment": "მიუთითეთ კომენტარი",
    "createSalary": " ხელფასის გაცემა",
    "detailedSalary": "ხელფასი პროცედურებით",
    "salaryDate": "ხელფასის თარიღი",
    "excelExport": "Excel ექსპორტი",
    "noExportData": "ექსპორტისთვის მონაცემები ვერ მოიძებნა",
    "totalLabel": "სულ",
    "sumLabel": "ჯამი",
    "selectedCount": "არჩეულია",
    "payDisabledForBranch": "ამ ფილიალზე ხელფასი \"ხელფასების დარიცხვის\" ეკრანიდან გაიცემა.",
    "payFailed": "ხელფასის გაცემა ვერ მოხერხდა."
  },
  "SERVICE_PRODUCT": {
    "name": "დასახელება",
    "price": "გასაყიდი ფასი",
    "time": "დრო",
    "serviceCategory": "კატეგორია",
    "autoPriceView": "ფასი ავტომატურად",
    "autoTimeView": "დრო ავტომატურად",
    "autoFix": "ავტ.გადატანა ფიქს. ხარჯში",
    "fixSum": "ფიქს. ხარჯში",
    "products": "პროდუქტები",
    "product": {
      "new_product": "ახალი პროდუქტი",
      "name": "დასახელება",
      "gram": "გრამი",
      "quantity": "ცალი",
      "pricePerItem": "ცალის ფასი",
      "grPerItem": "გრამი ცალში",
      "expencePrice": "ხარჯის ღირებულება"
    },
    "notification": "შეტყობინება",
    "days": "შეხსენების ინტერვალი",
    "notificationMessage": "შეხსენების შეტყობინება",
    "providers": "პროვაიდერები",
    "provider": {
      "name": "სადაზღვევო",
      "productName": "სადაზღვევო პროდუქტი",
      "price": "სადაზღვევო ფასი"
    }
  },
  "PRODUCT": {
    "barcode": "ბარკოდი",
    "name": "დასახელება",
    "code": "პროდუცტის კოდი",
    "productCategory": "კატეგორია",
    "distributor": "მომწოდებელი",
    "pricePerItem": "მისაღები ფასი",
    "salePricePerItem": "გასაყიდი ფასი",
    "grPerItem": "გრამი ცალში",
    "gram": "გრამი",
    "quantity": "რაოდენობა",
    "restGr": "ნაშთი(გრამი)",
    "buyDate": "შეძენის თარიღი",
    "bestBefore": "ვარგისია",
    "avgPrice": "საშუალო ფასი",
    "isSpend": "გასავალში გატარება",
    "comment": "კომენტარი",
    "accountingDate": "აღრიცხვის თარიღი"
  },
  "INSURANCE": {
    "name": "დასახელება",
    "salePercent": "ფასდაკლების პროცენტი",
    "contactName": "საკონტაქტო პირი",
    "contactPhone": "საკონტაქტო ტელეფონი",
    "contactMobile": "საკონტაქტო მობილური",
    "provider": "პროვაიდერი"
  },
  "EVENT_TYPE": {
    "SYSTEM": "სისტემური",
    "SYSTEM_ADMIN": "სისტემური",
    "CUSTOM": "მანუალური"
  },
  "EVENT_KEY": {
    "COMPLETED": "ვიზიტის შემდეგ",
    "BOOKING_UPDATE": "ჯავშნის ცვლილება",
    "BOOKED": "ჯავშნის დადასტურება",
    "BOOKING_REMINDER": "ვიზიტის შეხსენება",
    "BOOKING_DELETED": "ჯავშნის გაუქმება",
    "PERIODIC_REMINDER": "დაბრუნების შეხსენება",
    "ONLINE_BOOKING_INCOME": "ონლაინ ჯავშანი",
    "ONLINE_BOOKING_CANCEL": "ონლაინ ჯავშნის გაუქმება",
    "VERIFICATION_SMS": "დამადასტურებელი კოდი",
    "OFFER_EXPIRY_WARNING": "ვაუჩერის ვადა იწურება",
    "OFFER_PURCHASE_CONFIRMATION": "ვაუჩერი შეძენილია",
    "OFFER_MERCHANT_NOTIFICATION": "ვაუჩერი გაიყიდა",
    "PACKAGE_PURCHASE_CONFIRMATION": "პაკეტი შეძენილია",
    "PACKAGE_USAGE": "პაკეტის გამოყენება",
    "PACKAGE_BATCH_USAGE": "რამდენიმე სერვისი პაკეტიდან",
    "PACKAGE_EXPIRED": "პაკეტს ვადა გაუვიდა",
    "PACKAGE_EXPIRY_WARNING": "პაკეტის ვადა იწურება",
    "INVOICE_GENERATED": "ინვოისი შეიქმნა",
    "EMPLOYEE_PASSWORD_RESET": "თანამშრომლის პაროლი",
    "USER_PASSWORD_RESET": "მომხმარებლის პაროლი"
  },
  "SCHEDULE_PERIOD_TYPE": {
    "NOW": "მაშინვე",
    "ONE_TIME": "ერთჯერადი",
    "DAILY": "ყოველდღიური",
    "Monthly": "ყოველთვიური",
    "Yerly": "ყოველწლიური"
  },
  "USER_ROLE": {
    "USER": "მომხმარებელი",
    "EMPLOYEE": "თანამშრომელი",
    "ADMIN": "ადმინ",
    "SUPER_ADMIN": "სუპერ ადმინ",
    "ADMINISTRATOR": "ადმინისტრატორი"
  },
  "header": {
    "search": {
      "placeholder": "მოძებნე ჯავშანი"
    },
    "account": {
      "dropdown": {
        "admin": "ადმინი",
        "profile": "პროფილი",
        "changePassword": "პაროლის შეცვლა",
        "logOut": "გასვლა"
      }
    }
  },
  "footer": {
    "title": "ყველა უფლება დაცულია"
  },
  "auth": {
    "welcome": {
      "title": "წარმატებულ სამუშაო დღეს გისურვებთ",
      "subTitle": "ნებისმიერი კითხვის შემთხვევაში, გთხოვთ, დაუკავშირდეთ ადმინისტრაციას 0322500290"
    },
    "form": {
      "title": "ავტორიზაცია",
      "username": "მომხმარებელი",
      "password": "პაროლი",
      "button": "შესვლა",
      "twoFA": "SMS კოდი",
      "resend": "გააგზავნეთ კოდი"
    },
    "biometric": {
      "or": "ან",
      "loginButton": "ბიომეტრიით შესვლა",
      "enterUsername": "გთხოვთ, შეიყვანოთ მომხმარებლის სახელი",
      "loginFailed": "ბიომეტრიული ავტორიზაცია ვერ მოხერხდა",
      "noCredentials": "ბიომეტრიული მოწყობილობა არ არის დარეგისტრირებული. გთხოვთ, ჯერ დაარეგისტრიროთ მოწყობილობა პროფილის პარამეტრებში.",
      "userNotFound": "მომხმარებელი ვერ მოიძებნა",
      "cancelled": "ბიომეტრიული ავტორიზაცია გაუქმდა"
    }
  },
  "DASHBOARD": {
    "HEADER": {
      "FINDRESERVATION": "მოძებნე ჯავშანი",
      "CHANGEPASSWORD": "პაროლის შეცვლა",
      "LOGOUT": "გასვლა"
    },
    "ANALYSIS": {
      "analysisOfTheDay": "დღის ანალიზი",
      "newUser": "ახალი მომხმარებელი",
      "allReservations": "ჯავშნები სულ",
      "finishedVisits": "დასრულებული ვიზიტები",
      "visitsToBeMade": "შესასრულებელი ვიზიტები",
      "totalRevenue": "მთლიანი შემოსავალი",
      "averageTicket": "საშუალო ჩეკი",
      "services": "სერვისები",
      "products": "პროდუქცია",
      "bookingDetails": "ჯავშნების დეტალები",
      "pending": "მოლოდინში",
      "inProgress": "მიმდინარე",
      "canceled": "გაუქმებული",
      "noShow": "არ გამოცხადდა",
      "occupancy": "დატვირთულობა",
      "today": "დღეს",
      "week": "კვირა",
      "month": "თვე",
      "availableSlots": "თავისუფალი დროები",
      "tomorrow": "ხვალ",
      "noSlots": "თავისუფალი დრო არ არის",
      "min": "წთ",
      "clientStats": "კლიენტების სტატისტიკა",
      "topVisitors": "ტოპ ვიზიტორები",
      "topSpenders": "ტოპ გადამხდელები",
      "newClients": "ახალი კლიენტები",
      "newClientsRevenue": "ახალი კლიენტების შემოსავალი",
      "returningClients": "დაბრუნებული კლიენტები",
      "returningClientsRevenue": "დაბრუნ. კლიენტების შემოსავალი",
      "client": "კლიენტი",
      "visits": "ვიზიტები",
      "spent": "დახარჯული",
      "noData": "მონაცემები არ არის",
      "employees": "თანამშრომლები",
      "rooms": "ოთახები",
      "combined": "საერთო",
      "salesTrend": "გაყიდვების დინამიკა",
      "days": "დღე",
      "vsYesterday": "გუშინდელთან შედარებით"
    },
    "statistic": {
      "title": "მიმოხილვა",
      "salary": "შემოსავალი და ხელფასი",
      "latestReservations": "უახლესი ჩაწერები",
      "pastReservations": "გასული ჩაწერები",
      "reservationsMadeToday": "დღეს ჩაწერილები"
    }
  },
  "profile": {
    "fullName": "სახელი, გვარი",
    "firstname": "სახელი",
    "lastname": "გვარი",
    "userName": "მომხმარებლის სახელი",
    "phoneNumber": "მობილურის ნომერი",
    "idNumber": "პირადი ნომერი",
    "gender": "სქესი",
    "dateOfBirth": "დაბადების თარიღი",
    "email": "ელ.ფოსტა",
    "city": "ქალაქი",
    "address": "მისამართი",
    "additionalInformation": "დამატებითი ინფორმაცია",
    "currentPassword": "მიმდინარე პაროლი",
    "newPassword": "ახალი პაროლი",
    "repeatPassword": "გაიმეორეთ პაროლი",
    "changePassword": "პაროლის შეცვლა",
    "updateProfile": "პროფილის განახლება",
    "passwordChange": "პაროლის შეცვლა",
    "disable2FA": "გამორთეთ 2FA",
    "enable2FA": "ჩართეთ 2FA",
    "2FAEnabled": "ორმაგი ავტორიზაცია ჩართულია",
    "2FADisabled": "ორმაგი ავტორიზაცია გამორთულია",
    "2FA": "ორმაგი ავტორიზაცია",
    "bookingHubEnabled": "ონლაინ ჯავშნები ჩართულია",
    "bookingHubDisabled": "ონლაინ ჯავშნები გამორთულია",
    "bookingHubButtonDisable": "ონლაინ ჯავშნების გამორთვა",
    "bookingHubButtonEnable": "ონლაინ ჯავშნების ჩართვა",
    "bookingHubNotActive": "ჯავშნების სერვისი არ არის აქტიური",
    "bookingHubButtonActivate": "ჯავშნების სერვისის აქტივაცია",
    "bookingHubEnableConfirm": "ნამდვილად გსურთ ონლაინ ჯავშნების ჩართვა?",
    "bookingHubDisableConfirm": "ნამდვილად გსურთ ონლაინ ჯავშნების გამორთვა?",
    "branch": {
      "title": "ფილიალები",
      "add": "ფილიალის დამატება",
      "edit": "ფილიალის რედაქტირება",
      "delete": "ფილიალის დეაქტივაცია",
      "name": "სახელი",
      "physicalAddress": "მისამართი",
      "mobile": "ტელეფონი",
      "email": "ელ.ფოსტა",
      "city": "ქალაქი",
      "country": "ქვეყანა",
      "whStart": "სამუშაოს დაწყების დრო",
      "whEnd": "სამუშაოს დასრულების დრო",
      "smsBrandName": "SMS ბრენდის სახელი",
      "deleteConfirm": "ნამდვილად გსურთ ფილიალის წაშლა? ",
      "deleteSuccess": "ფილიალი წაშლილია",
      "onlineBooking": "ონლაინ ჩაწერა",
      "workingHours": "სამუშაო საათები",
      "invoiceOrganizationName": "ორგანიზაციის სახელი ინვოისზე",
      "invoiceOrganizationTaxId": "ორგანიზაციის კოდი ინვოისზე",
      "settings": "პარამეტრები"
    },
    "biometric": {
      "title": "ბიომეტრიული ავტორიზაცია",
      "deviceName": "მოწყობილობა",
      "lastUsed": "ბოლო გამოყენება",
      "noDevices": "ბიომეტრიული მოწყობილობები არ არის დარეგისტრირებული",
      "addDevice": "მოწყობილობის დამატება",
      "removeConfirm": "ნამდვილად გსურთ ამ მოწყობილობის წაშლა?",
      "registerSuccess": "ბიომეტრიული მოწყობილობა წარმატებით დარეგისტრირდა",
      "registerFailed": "ბიომეტრიული მოწყობილობის რეგისტრაცია ვერ მოხერხდა",
      "removeSuccess": "მოწყობილობა წარმატებით წაიშალა",
      "removeFailed": "მოწყობილობის წაშლა ვერ მოხერხდა",
      "noPlatformAuth": "Touch ID ან Windows Hello მიუწვდომელია ამ მოწყობილობაზე. გამოიყენეთ ბიომეტრიული აპარატურით აღჭურვილი მოწყობილობა."
    }
  },
  "employee": {
    "add": "დამატება",
    "massiveAddition": "მასიური დამატება",
    "download": "ჩამოტვირთვა",
    "delete": "ნამდვილად გსურთ წაშლა? ",
    "rollback": "აღდგენა",
    "rollbackConfirm": "ნამდვილად გსურთ აღდგენა? ",
    "resetPassword": "ნამდვილად გსურთ პაროლის აღდგენა?",
    "addEmployee/edit": "თანამშრომლის დამატება/რედაქტირება",
    "addPosition/edit": "პოზიციის დამატება/რედაქტირება",
    "addProcedure/edit": "პროცედურის დამატება/რედაქტირება",
    "addRestDay": "დასვენების დამატება",
    "procedure": "პროცედურა",
    "canScheduleStartTime": "სამუშაოს დაწყება",
    "canScheduleEndTime": "სამუშაოს დასრულება",
    "tabs": {
      "employees": "თანამშრომლები",
      "positions": "პოზიციები"
    },
    "search": {
      "searchWord": "საძიებო სიტყვა",
      "position": "პოზიცია",
      "visibleInApp": "გამოჩნდეს აპლიკაციაში",
      "inCalendar": "გამოჩნდეს კალენდარში"
    },
    "form": {
      "firstName": "სახელი",
      "lastName": "გვარი",
      "phoneNumber": "მობილურის ნომერი",
      "homePhone": "სახლის ტელეფონი",
      "idNumber": "პირადი ნომერი",
      "gender": "სქესი",
      "female": "მდედრობითი",
      "male": "მამრობითი",
      "dateOfBirth": "დაბადების თარიღი",
      "email": "ელ.ფოსტა",
      "salaryType": "ხელფასის ტიპი",
      "fixedSalary": "ფიქსირებული ხელფასი",
      "%ofGenerating": "გამომუშავების %",
      "additionalInformation": "დამატებითი ინფორმაცია",
      "showInCalendar": "გამოჩნდეს კალენდარში",
      "showInApplication": "გამოჩნდეს აპლიკაციაში",
      "save": "შენახვა",
      "add": "დამატება",
      "created": "შექმნილი",
      "errors": {
        "title": "შეცდომა",
        "requiredFields": "შეავსეთ სავალდებულო ველები (მათ შორის სახელი და გვარი).",
        "saveFailed": "შენახვა ვერ მოხერხდა"
      },
      "salaryTypes": {
        "OUTPUT": "გამომუშავების %",
        "FIXED": "ფიქსირებული",
        "ALL": "ყველა"
      }
    },
    "detailView": {
      "statistics": "სტატისტიკა",
      "reservations": "ჯავშნები",
      "completedVisits": "შესრულებული ვიზიტები",
      "amountEarned": "გამომუშავებლი თანხა",
      "issuedAmount": "გაცემული თანხა",
      "information": "ინფორმაცია",
      "procedures": "პროცედურები",
      "finances": "ფინანსები",
      "recoveryPassword": "პაროლის აღდგენა",
      "workSchedule": "სამუშაო გრაფიკი",
      "employeeProcedure": "თანამშრომლის პროცედურა",
      "calendar": "კალენდარი",
      "identitySection": "პირადი მონაცემები",
      "contactSection": "საკონტაქტო ინფორმაცია",
      "employmentSection": "დასაქმების ინფორმაცია"
    }
  },
  "services": {
    "addProcedure/edit": "პროცედურის დამატება/რედაქტირება",
    "addSpecialProcedure/edit": "სპეც პროცედურის დამატება/რედაქტირება",
    "addProduct/edit": "პროდუქტის დამატება/რედაქტირება",
    "search": {
      "searchWord": "საძიებო სიტყვა",
      "onlineBooking": "Booking Hub-ში გამოჩენა",
      "vat": "დღგ-ით დასაბეგრი"
    },
    "tabs": {
      "procedures": "პროცედურები",
      "specialProcedures": "სპეც. პროცედურები",
      "categories": "კატეგორიები",
      "regular": "სერვისები",
      "offers": "შეთავაზებები",
      "packages": "პაკეტები"
    },
    "sections": {
      "basicInfo": "ძირითადი ინფორმაცია",
      "pricing": "ფასი და ხანგრძლივობა",
      "settings": "პარამეტრები"
    },
    "offers": {
      "offerName": "შეთავაზება",
      "remaining": "დარჩენილი",
      "expires": "ვადა",
      "prepaid": "წინასწარ გადახდილი",
      "noOffers": "შეთავაზებები არ მოიძებნა",
      "left": "დარჩა",
      "reserved": "გამოყენებული"
    },
    "packages": {
      "packageName": "პაკეტი",
      "coveredByPackage": "დაფარულია პაკეტით",
      "noPackages": "პაკეტები არ მოიძებნა",
      "noActivePackage": "აქტიური პაკეტი არ მოიძებნა",
      "noActivePackageDescription": "ამ მომენტში აქტიური პაკეტი არ არის ხელმისაწვდომი",
      "noPackagesForSearch": "„{{term}}“-ის შესაბამისი პაკეტი ვერ მოიძებნა",
      "fromTemplate": "შაბლონიდან",
      "adHoc": "ინდივიდუალური",
      "adHocBundle": "ინდივიდუალური პაკეტი",
      "addProcedure": "პროცედურის დამატება",
      "noProcedures": "დაამატეთ პროცედურები პაკეტში",
      "selectProcedure": "აირჩიეთ პროცედურა",
      "total": "სულ",
      "validityDays": "ვადა (დღე)",
      "buyForAnother": "შეძენა სხვა მომხმარებლისთვის",
      "selectBeneficiary": "აირჩიეთ მოსარგებლე",
      "giftFrom": "საჩუქარი",
      "boughtFor": "შეძენილია",
      "saveToTemplates": "შაბლონებში შენახვა",
      "templateName": "პაკეტის სახელი",
      "templateNameRequired": "გთხოვთ შეავსოთ პაკეტის სახელი",
      "templateSaved": "პაკეტი შაბლონებში შეინახა",
      "templateSaveFailed": "გაყიდვა შესრულდა, თუმცა შაბლონში შენახვა ვერ მოხერხდა"
    },
    "column": {
      "title": "დასახელება",
      "price": "ღირებულება",
      "discount": "ფასდაკლება",
      "time": "დრო",
      "priceAutomatically": "ფასი ავტომატურად",
      "timeAutomatically": "დრო ავტომატურად",
      "category": "კატეგორია",
      "provider": "პროვაიდერი",
      "vat": "დღგ",
      "created": "შექმნილი",
      "providerPrice": "პროვაიდერის ფასი",
      "color": "ფერი",
      "position": "პოზიცია",
      "reminder": "შეხსენება",
      "reminderPeriod": "შეხსენების პერიოდი",
      "reminderSmsTemplate": "შეხსენების შაბლონი"
    },
    "form": {
      "title": "დასახელება",
      "salePrice": "გასაყიდი ფასი",
      "time": "დრო",
      "category": "კატეგორია",
      "priceAutomatically": "ფასი ავტომატურად",
      "timeAutomatically": "დრო ავტომატურად",
      "automaticTransfer": "ავტ.გადატანა ფიქს. ხარჯში",
      "products": "პროდუქტები",
      "notification": "შეტყობინება",
      "gram": "გრამი",
      "piece": "ცალი",
      "reminderInterval": "შეხსენების ინტერვალი",
      "reminderNotification": "შეხსენების შეტყობინება",
      "reminderMessage": "მიუთითეთ შეხსენების შეტყობინება",
      "employee": "თანამშრომელი",
      "%generating": "გამომუშავების %",
      "fixedSalary": "ფიქსირებული ხელფასი",
      "fixSum": "ფიქს. ხარჯში",
      "onlineBooking": "Booking Hub-ში გამოჩენა",
      "maxParallelBookings": "მაქს. პარალელური ჯავშნები",
      "maxParallelBookingsHint": "0 = შეუზღუდავი, N = მაქსიმალური პარალელური ჯავშნების რაოდენობა",
      "ncsps": "NCSP კოდები",
      "serviceType": "სერვისის ტიპი",
      "standard": "სტანდარტული",
      "minute": "წუთები",
      "minute-price": "წუთის ფასი",
      "minute-discount": "წუთის ფასდაკლება",
      "price": "ფასი",
      "discount": "ფასდაკლება",
      "unit": "ერთეული",
      "inPiece": "გრამი ცალში",
      "willUse": "დაიხარჯება"
    },
    "category": {
      "add": {
        "title": "კატეგორიის დამატება/რედაქტირება"
      }
    },
    "notifications": {
      "service": "პროცედურა",
      "updated": "წარმატებით განახლდა",
      "created": "წარმატებით შეიქმნა",
      "error": "შეცდომა"
    },
    "v2": {
      "searchPlaceholder": "შეიყვანეთ სერვისის დასახელება",
      "summary": "ნაჩვენებია {{total}} სერვისი",
      "serviceCount": "სერვისები: {{count}}",
      "uncategorized": "კატეგორიის გარეშე",
      "loadFailed": "ჩატვირთვა ვერ მოხერხდა",
      "toggleFailed": "ცვლილება ვერ შეინახა",
      "column": {
        "name": "დასახელება",
        "onlineBooking": "ონლაინ ჩანერა",
        "price": "ფასი",
        "duration": "ხანგრძლივობა",
        "break": "ტექ. შესვენება",
        "materials": "მასალები",
        "employees": "თანამშრომლები"
      },
      "form": {
        "newTitle": "ახალი სერვისი",
        "newTitleSpecial": "ახალი სპეც. პროცედურა",
        "editTitleSpecial": "სპეც. პროცედურის რედაქტირება",
        "editTitle": "სერვისის რედაქტირება",
        "tab": {
          "main": "ძირითადი პარამეტრები",
          "online": "ონლაინ ჩანერა",
          "languages": "ენები",
          "products": "პროდუქტები",
          "ncsp": "NCSP კოდები",
          "employees": "თანამშრომლები",
          "rooms": "ოთახები",
          "activity": "აქტივობა"
        },
        "name": "დასახელება",
        "category": "კატეგორია",
        "basePrice": "საბაზისო ფასი",
        "useRange": "ფასის დიაპაზონის მითითება",
        "priceFrom": "დან",
        "priceTo": "მდე",
        "duration": "სერვისის ხანგრძლივობა",
        "hoursShort": "სთ",
        "minutesShort": "წთ",
        "onlineBooking": "ონლაინ ჩანერა",
        "publicName": "დასახელება ონლაინ ჩანერისთვის",
        "publicDescription": "აღწერა",
        "publicHint": "ეს ტექსტი კლიენტს ეჩვენება ონლაინ ჩანერისას და შიდა დასახელებისგან დამოუკიდებელია.",
        "languagesHint": "დაამატეთ თარგმანები, რომ კლიენტმა სერვისი თავის ენაზე დაინახოს. თუ თარგმანი ცარიელია, გამოიყენება ძირითადი დასახელება.",
        "lang": {
          "ka": "ქართული",
          "en": "ინგლისური",
          "ru": "რუსული"
        },
        "standard": "სტანდარტული",
        "optional": "არასავალდებულო",
        "fromMain": "აღებულია ძირითადი პარამეტრებიდან",
        "nameRequired": "შეავსეთ დასახელება",
        "rangeIncomplete": "დიაპაზონს ორივე ზღვარი სჭირდება",
        "saved": "შენახულია",
        "saveFailed": "შენახვა ვერ მოხერხდა",
        "vat": "დღგ-ით დასაბეგრი",
        "saveFirst": "ჯერ შეინახეთ სერვისი — შემდეგ შეძლებთ აქ დამატებას.",
        "viewOnly": "ამ სერვისის ნახვა შეგიძლიათ, მაგრამ შეცვლის უფლება არ გაქვთ."
      },
      "create": "შექმნა",
      "title": "სერვისების კატეგორიები",
      "subtitle": "სერვისები",
      "on": "ჩართული",
      "off": "გამორთული",
      "emptyCategory": "ამ კატეგორიაში სერვისი ჯერ არ არის",
      "addService": "დამატება",
      "filter": {
        "all": "ყველა",
        "online": "ონლაინ ჩანერა",
        "inSalon": "მხოლოდ სალონში",
        "special": "სპეც. პროცედურები"
      },
      "searchEmpty": "ამ სახელით სერვისი ვერ მოიძებნა",
      "searchTruncated": "ნაჩვენებია პირველი 200 შედეგი — დააზუსტეთ ძებნა.",
      "chooser": {
        "title": "რის შექმნა გსურთ?",
        "new": "ახალი",
        "category": {
          "title": "სერვისის კატეგორია",
          "hint": "მსგავსი სერვისების ჯგუფი, მაგალითად, თმის შეჭრა"
        },
        "service": {
          "title": "სერვისი",
          "hint": "ცალკეული სერვისი, რომელსაც სპეციალისტი ასრულებს, მაგალითად, მანიკიური"
        },
        "special": {
          "title": "სპეც. პროცედურა",
          "hint": "მხოლოდ სალონში შესრულებადი პროცედურა — ონლაინ ჯავშანსა და NCSP კოდს არ იყენებს"
        },
        "package": {
          "title": "სერვისების პაკეტი",
          "hint": "ერთ შეთავაზებად გაერთიანებული სერვისების ნაკრები, მაგალითად, მანიკიური და პედიკიური"
        }
      },
      "category": {
        "newTitle": "ახალი სერვისის კატეგორია",
        "editTitle": "კატეგორიის რედაქტირება",
        "namePlaceholder": "მაგალითად: შეჭრები",
        "useOnlineName": "სხვა დასახელების გამოყენება ონლაინ ჩანერისთვის",
        "onlineName": "დასახელება ონლაინ ჩანერისთვის",
        "nameRequired": "შეიყვანეთ კატეგორიის დასახელება",
        "created": "კატეგორია წარმატებით შეიქმნა",
        "saved": "კატეგორია შენახულია",
        "languagesHint": "დაამატეთ თარგმანები, რომ კატეგორია სხვა ენაზეც სწორად გამოჩნდეს.",
        "fallsBack": "თუ ცარიელია, გამოჩნდება ქართული დასახელება",
        "viewOnly": "ამ კატეგორიის ნახვა შეგიძლიათ, მაგრამ შეცვლის უფლება არ გაქვთ.",
        "colorHint": "ამ კატეგორიის სერვისების ჯავშნები კალენდარში ამ ფერით გამოჩნდება.",
        "reminderHint": "ამ კატეგორიის სერვისზე ვიზიტიდან მითითებული რაოდენობის დღის შემდეგ კლიენტს SMS გაეგზავნება.",
        "reminderDays": "გაგზავნის ვადა (დღე)",
        "reminderDaysHint": "აითვლება ვიზიტის თარიღიდან.",
        "reminderPlaceholders": "შეგიძლიათ გამოიყენოთ {firstname} კლიენტის სახელისთვის და {serviceCategoryName} კატეგორიის სახელისთვის.",
        "reminderIncomplete": "შეხსენება არ გაიგზავნება, სანამ დღეების რაოდენობა და SMS-ის ტექსტი არ შეივსება.",
        "chooseColor": "ფერის არჩევა",
        "noColor": "ფერი არ არის არჩეული"
      },
      "noBreak": "არ არის",
      "minutesShort": "{{count}} წთ",
      "materialCount": "{{count}} მასალა",
      "reorderFailed": "თანმიმდევრობა ვერ შეინახა",
      "materials": {
        "search": "მასალის ძებნა",
        "selected": "არჩეული მასალები",
        "noneFound": "მასალა ვერ მოიძებნა",
        "noneSelected": "მასალა ჯერ არ არის არჩეული",
        "lowStock": "მარაგი მცირდება",
        "inStock": "მარაგში {{count}}",
        "gram": "გრ",
        "piece": "ცალი",
        "costPerService": "ერთი სერვისის მასალის ხარჯი",
        "servicePrice": "სერვისის ფასი",
        "margin": "მარჟა",
        "writeOffHint": "მასალები ნებისმიერ დროს შეიცვლება — ხელახლა დააჭირეთ ცხრილში მასალების უჯრას.",
        "footerHint": "შენახვის შემდეგ ეს მასალები ავტომატურად მოყვება ამ სერვისის ყველა ახალ ჯავშანს.",
        "title": "მასალების მიბმა",
        "expired": "ვადა გასულია",
        "expiresOn": "ვადა {{date}}"
      },
      "breakHint": "წუთები, რომლის განმავლობაშიც ოთახი დაკავებული რჩება სერვისის შემდეგ",
      "rooms": {
        "tabLabel": "ოთახები",
        "hint": "მონიშნე ოთახები, სადაც ეს სერვისი შესრულდება.",
        "none": "ფილიალში ოთახები არ არის.",
        "selected": "მონიშნულია {{count}} ოთახი",
        "saved": "ოთახები შენახულია",
        "saveFailed": "ოთახების შენახვა ვერ მოხერხდა",
        "loadFailed": "ოთახების ჩატვირთვა ვერ მოხერხდა"
      },
      "activity": {
        "none": "ცვლილებები ჯერ არ დაფიქსირებულა.",
        "unknown": "უცნობი",
        "empty": "ცარიელი",
        "yes": "დიახ",
        "no": "არა",
        "loadFailed": "ისტორიის ჩატვირთვა ვერ მოხერხდა",
        "action": {
          "CREATED": "შექმნა",
          "UPDATED": "ცვლილება",
          "DELETED": "წაშლა",
          "ONLINE_BOOKING": "ონლაინ ჩანერა",
          "EMPLOYEES": "თანამშრომლები",
          "ROOMS": "ოთახები",
          "PRODUCTS": "პროდუქტები"
        },
        "count": "{{count}} ჩანაწერი"
      },
      "addLink": "დამატება",
      "notSetShort": "—",
      "countSalon": "სალონში {{count}}",
      "countOnline": "ონლაინ {{count}}",
      "employeesDrawer": {
        "title": "სერვისის თანამშრომლები"
      },
      "import": {
        "title": "იმპორტი Excel-იდან",
        "subtitle": "ფასების და ხანგრძლივობის მასობრივი განახლება და ახალი სერვისების დამატება.",
        "dropTitle": "გადმოიტანეთ Excel ფაილი ან აირჩიეთ კომპიუტერიდან",
        "dropHint": "ფაილის ფორმატი xlsx, მაქსიმუმ 5 MB",
        "choose": "ფაილის არჩევა",
        "remove": "ფაილის წაშლა",
        "checkTitle": "ფაილის შემოწმება",
        "checking": "მოწმდება...",
        "count": {
          "create": "ახალი",
          "update": "განახლდება",
          "unchanged": "უცვლელი",
          "warning": "გაფრთხილება",
          "error": "შეცდომა"
        },
        "table": {
          "row": "სტრიქონი",
          "service": "სერვისი",
          "message": "შეტყობინება"
        },
        "showAll": "ყველა სტრიქონის ჩვენება",
        "showProblems": "მხოლოდ პრობლემური სტრიქონები",
        "allClean": "ფაილში პრობლემები არ არის.",
        "footerNote": "შეცდომიანი სტრიქონები არ ჩაიწერება. შეიქმნება {{create}}, განახლდება {{update}}.",
        "done": "იმპორტი დასრულდა: შეიქმნა {{create}}, განახლდა {{update}}.",
        "resultDiffers": "შედეგი განსხვავდება შემოწმებისგან — მონაცემები შემოწმების შემდეგ შეიცვალა.",
        "onlineSummary": "ონლაინ ჯავშანი: ჩაირთვება {{on}}, გამოირთვება {{off}}",
        "cancel": "გაუქმება",
        "confirm": "იმპორტის დადასტურება",
        "close": "დახურვა",
        "wrongType": "მხოლოდ .xlsx ფაილი მიიღება.",
        "tooLarge": "ფაილი 5 MB-ზე დიდია.",
        "failed": "ფაილის დამუშავება ვერ მოხერხდა. სცადეთ თავიდან.",
        "redesignDisabled": "სერვისების ახალი ეკრანი ამ ფილიალისთვის გამორთულია.",
        "forbidden": "ამ ფილიალზე წვდომა არ გაქვთ.",
        "column": {
          "id": "ID",
          "name": "დასახელება",
          "category": "კატეგორია",
          "price": "ფასი",
          "discountPrice": "ფასდაკლებული ფასი",
          "time": "ხანგრძლივობა",
          "serviceType": "ტიპი",
          "vat": "დღგ",
          "autoPrice": "ფასის ავტ. გამოტანა",
          "autoTime": "დროის ავტ. გამოტანა",
          "technicalBreak": "ტექ. შესვენება",
          "maxParallel": "მაქს. პარალელური ჯავშნები",
          "autoFix": "ფიქს ხარჯში ავტ. გადატანა",
          "fixSum": "ფიქს ხარჯის თანხა",
          "onlineBooking": "ონლაინ ჯავშანი"
        },
        "msg": {
          "nameRequired": "დასახელება სავალდებულოა",
          "notANumber": "„{{column}}“ არ არის რიცხვი",
          "negative": "„{{column}}“ არ შეიძლება იყოს უარყოფითი",
          "notPositive": "„{{column}}“ უნდა იყოს 0-ზე მეტი",
          "invalidValue": "„{{column}}“ — დაუშვებელი მნიშვნელობა",
          "serviceNotFound": "სერვისი ვერ მოიძებნა ამ ფილიალში",
          "duplicateId": "ეს ID ფაილში მეორდება",
          "duplicateName": "დუბლიკატი დასახელება ამ კატეგორიაში",
          "categoryWillBeCreated": "შეიქმნება ახალი კატეგორია: {{name}}",
          "priceRangeKept": "სერვისს აქვს ფასის დიაპაზონი — ფასი შეიცვლება, დიაპაზონი უცვლელი დარჩება",
          "notXlsx": "ფაილი არ არის Excel (.xlsx)",
          "emptyFile": "ფაილი ცარიელია",
          "missingNameColumn": "ფაილს აკლია სვეტი „დასახელება“",
          "tooManyRows": "ფაილში {{max}}-ზე მეტი სტრიქონია",
          "unknownColumn": "უცნობი სვეტი „{{name}}“ გამოტოვებულია",
          "unknown": "უცნობი შეცდომა",
          "tooLarge": "ფაილი გახსნისას ძალიან დიდია.",
          "notWholeNumber": "„{{column}}“ უნდა იყოს მთელი რიცხვი",
          "breakNotForMinute": "MINUTE ტიპის სერვისს ტექ. შესვენება არ აქვს (0 ან ცარიელი)",
          "fixSumIgnored": "გადატანა გამორთულია — თანხა შეინახება როგორც 0",
          "onlineBookingUnavailable": "ორგანიზაციაში ონლაინ ჯავშანი გამორთულია"
        }
      },
      "excel": {
        "menu": "Excel მოქმედებები",
        "export": "ექსპორტი Excel-ში",
        "exportHint": "ყველა სერვისი მიმდინარე ფილტრით.",
        "import": "იმპორტი Excel-იდან",
        "importHint": "ფასების და ხანგრძლივობის მასობრივი განახლება.",
        "template": "შაბლონის ჩამოტვირთვა",
        "templateHint": "ცარიელი ფაილი სწორი სვეტებით.",
        "exportFailed": "ექსპორტი ვერ მოხერხდა.",
        "templateFailed": "შაბლონის ჩამოტვირთვა ვერ მოხერხდა."
      },
      "delete": {
        "titleService": "სერვისის წაშლა: {{name}}",
        "titleServiceNoName": "სერვისის წაშლა",
        "titleCategory": "კატეგორიის წაშლა: {{name}}",
        "titleCategoryNoName": "კატეგორიის წაშლა",
        "checking": "მოწმდება...",
        "confirmService": "წაიშლება მოცემული სერვისი. ნამდვილად გსურთ წაშლა?",
        "confirmCategory": "წაიშლება კატეგორია. ნამდვილად გსურთ წაშლა?",
        "historyKept": "წარსული ვიზიტები შენარჩუნდება.",
        "blocked": "ვერ წაიშლება",
        "bookings": "{{count}} მომავალი ჯავშანი",
        "offers": "{{count}} აქტიური შეთავაზება",
        "packages": "{{count}} აქტიური პაკეტი",
        "purchases": "აუთვისებელი სეანსებით ნაყიდი პაკეტები: {{count}}",
        "vouchers": "{{count}} აუთვისებელი ვაუჩერი",
        "services": "კატეგორიაში {{count}} სერვისია — ჯერ წაშალეთ ან გადაიტანეთ ისინი",
        "delete": "წაშლა",
        "cancel": "გაუქმება",
        "close": "დახურვა",
        "done": "წაიშალა",
        "failed": "წაშლა ვერ მოხერხდა. სცადეთ თავიდან.",
        "forbidden": "ამ ფილიალზე წვდომა არ გაქვთ.",
        "redesignDisabled": "სერვისების ახალი ეკრანი ამ ფილიალისთვის გამორთულია.",
        "notFound": "ჩანაწერი ვერ მოიძებნა — შესაძლოა უკვე წაშლილია.",
        "button": "წაშლა"
      }
    }
  },
  "users": {
    "consentsHistory": "თანხმობები და ვერიფიკაცია",
    "consent": {
      "documentType": "დოკუმენტის ტიპი",
      "verified": "ვერიფიცირებული",
      "verifiedYes": "დიახ",
      "verifiedNo": "არა",
      "search": "ძებნა",
      "clear": "გასუფთავება",
      "type": {
        "PROCEDURE_CONSENT": "პროცედურის თანხმობა",
        "CUSTOMER_VERIFICATION": "მომხმარებლის ვერიფიკაცია",
        "DATA_PROCESSING": "მონაცემთა დამუშავება",
        "INFORMED_CONSENT": "ინფორმირებული თანხმობა"
      },
      "status": {
        "VERIFIED": "ვერიფიცირებული",
        "PENDING": "მოლოდინში",
        "CONFIRMED": "დადასტურებული",
        "EXPIRED": "ვადაგასული"
      },
      "column": {
        "type": "ტიპი",
        "status": "სტატუსი",
        "code": "კოდი",
        "verified": "ვერიფიცირებული",
        "verifiedAt": "ვერიფიკაციის თარიღი",
        "mobilePhone": "ტელეფონი",
        "date": "თარიღი"
      }
    },
    "gel": "₾",
    "min": "წთ",
    "information": "ინფორმაცია",
    "addUser/edit": "მომხმარებლის დამატება/რედაქტირება",
    "sections": {
      "personalInfo": "პირადი ინფორმაცია",
      "contactInfo": "საკონტაქტო ინფორმაცია",
      "additionalInfo": "დამატებითი ინფორმაცია"
    },
    "upBalance": "ბალანსის შევსება",
    "minutes": "წუთები",
    "amount": "თანხა",
    "numberMinutes": "წუთების რაოდენობა",
    "typePayment": "გადახდის ტიპი",
    "moneyMode": "თანხის გატარება",
    "withoutMoney": "თანხის გატარების გარეშე",
    "withMoney": "თანხის გატარებით",
    "moneyRequired": "თანხის გატარებით ოპერაციაში თანხა უნდა იყოს 0-ზე მეტი",
    "comment": "კომენტარი",
    "operationType": "ოპერაციის ტიპი",
    "topUpBalance": "ბალანსის დარიცხვა",
    "returnBalance": "ბალანსის უკან დაბრუნება",
    "balanceAmount": "ბალანსის ოდენობა",
    "historyVisits": "ვიზიტების ისტორია",
    "transactions": "ტრანზაქციები",
    "completedSuccessfully": "შესრულდა წარმატებით",
    "balanceFilledSuccessfully": "ბალანსი წარმატებით შეივსო",
    "balanceNotEnough": "ბალანსი არ არის საკმარისი",
    "verified": "ვერიფიცირებული",
    "choose": "არჩევა",
    "search": {
      "searchWord": "საძიებო სიტყვა",
      "branch": "ფილიალი",
      "userSource": "მომხმარებლის წყარო",
      "withBalance": "მიმდინარე ბალანსით",
      "withMinutes": "მიმდინარე წუთები",
      "results": "მომხმარებლები",
      "placeholder": "მომხმარებლის ძიება",
      "startTyping": "დაიწყეთ აკრეფა..."
    },
    "transactionDate": "ტრანზაქციის თარიღი",
    "column": {
      "cardNo": "ბარათის #",
      "name": "სახელი",
      "lastName": "გვარი",
      "identificationNo": "ს/კ #",
      "female": "მდედრობითი",
      "male": "მამრობითი ",
      "gender": "სქესი",
      "dateOfBirth": "დაბადების თარიღი",
      "phoneNumber": "მობილურის ნომერი",
      "branch": "ფილიალი",
      "userSource": "მომხმარებლის წყარო",
      "created": "შექმნილი",
      "role": "როლი",
      "service": "სერვისი",
      "price": "ღირებულება",
      "balance": "ბალანსი(₾)",
      "minutes": "წუთები",
      "cashback": "ქეშბექი",
      "reservationTime": "ჩაწერის თარიღი",
      "startingTime": "დაწყების დრო",
      "finishingTime": "დასრულების დრო",
      "employee": "თანამშრომელი",
      "description": "აღწერა",
      "medicalSpecialty": "სამედიცინო სპეციალობა"
    },
    "form": {
      "cardNo": "ბარათის #",
      "name": "სახელი",
      "lastName": "გვარი",
      "phoneNumber": "მობილურის ნომერი",
      "homePhone": "სახლის ტელეფონი",
      "idNumber": "პირადი ნომერი",
      "female": "მდედრობითი",
      "male": "მამრობითი ",
      "gender": "სქესი",
      "dateOfBirth": "დაბადების თარიღი",
      "email": "ელ.ფოსტა",
      "additionalInformation": "დამატებითი ინფორმაცია",
      "role": "როლი",
      "created": "შექმნილი",
      "userSource": "მომხმარებლის წყარო",
      "smsLanguage": "SMS-ის ენა",
      "smsLanguageKa": "ქართული",
      "smsLanguageRu": "რუსული",
      "smsLanguageEn": "ინგლისური",
      "verification": "ვერიფიკაცია",
      "notSet": "არ არის მითითებული",
      "smsLanguageHint": "ენა, რომელზეც კლიენტი მიიღებს SMS-ს",
      "smsLanguageSaved": "SMS-ის ენა შენახულია",
      "smsLanguageError": "ენის შენახვა ვერ მოხერხდა",
      "selectUser": "მომხმარებლის შეცვლა",
      "updateUser": "მომხმარებლის რედაქტირება",
      "unknownUser": "უცნობი მომხმარებელი",
      "smsLanguageDefault": "ფილიალის ნაგულისხმევი"
    },
    "offers": {
      "tabTitle": "პაკეტები",
      "title": "შეძენილი პაკეტები",
      "buyPackage": "პაკეტის შეძენა",
      "package": "პაკეტი",
      "status": "სტატუსი",
      "source": "წყარო",
      "progress": "პროგრესი",
      "price": "ფასი",
      "validity": "მოქმედების ვადა",
      "actions": "მოქმედებები",
      "noOffers": "პაკეტები არ მოიძებნა",
      "beneficiary": "ბენეფიციარი",
      "expired": "ვადაგასული",
      "expiringSoon": "იწურება",
      "activate": "აქტივაცია",
      "confirmActivate": "აქტივაციის დადასტურება",
      "activateWarning": "დარწმუნებული ხართ, რომ გსურთ ამ პაკეტის აქტივაცია?",
      "activated": "პაკეტი წარმატებით გააქტიურდა",
      "purchaseSuccess": "შეძენა წარმატებულია",
      "packagePurchased": "პაკეტი წარმატებით შეიძინა",
      "status_PURCHASED": "შეძენილი",
      "status_ACTIVE": "აქტიური",
      "status_USED": "გამოყენებული",
      "status_CANCELLED": "გაუქმებული",
      "status_SHARED": "გაზიარებული",
      "selectPackage": "აირჩიეთ პაკეტი",
      "selectPackagePlaceholder": "აირჩიეთ პაკეტი შესაძენად",
      "paymentMethod": "გადახდის მეთოდი",
      "purchasePrice": "შეძენის ფასი",
      "note": "შენიშვნა",
      "notePlaceholder": "შეიყვანეთ შენიშვნა (არასავალდებულო)",
      "purchase": "შეძენა",
      "noPackagesAvailable": "პაკეტები არ არის ხელმისაწვდომი",
      "noPackagesDescription": "ამჟამად შიდა გაყიდვისთვის ხელმისაწვდომი პაკეტები არ არის",
      "available": "ხელმისაწვდომი",
      "originalPrice": "საწყისი ფასი",
      "discountedPrice": "ფასდაკლებული ფასი",
      "discount": "ფასდაკლება",
      "servicesCount": "სერვისების რაოდენობა",
      "includedServices": "შეტანილი სერვისები",
      "useBalance": "ბალანსიდან"
    },
    "ehr": {
      "onlyWithIntervention": "მხოლოდ ჩარევის ოქმით"
    },
    "preferencesAndNotes": "პრეფერენციები და შენიშვნები",
    "visitPhotos": "ვიზიტის ფოტოები",
    "giftPackages": "ნაჩუქარი პაკეტები",
    "servicePackages": "სერვის პაკეტები",
    "ownPackages": "საკუთარი პაკეტები"
  },
  "calendar": {
    "gel": "₾",
    "offerService": "შეთავაზება",
    "packageService": "პაკეტი",
    "packageClearFailed": "წინა მომხმარებლის პაკეტის სრულად გასუფთავება ვერ მოხერხდა",
    "serviceDeleted": "წაშლილი სერვისი",
    "packageExpired": "ვადაგასული",
    "minute": "წთ",
    "hours": "სთ",
    "day": "დღე",
    "sortEmployee": "თანამშრომლის დალაგება",
    "planVisit": "ვიზიტის დაგეგმვა",
    "createUser": "მომხმარებლის შექმნა",
    "calendarTitle": "კალენდარი",
    "PlanVisit": "ვიზიტის დაგეგმვა",
    "services": "სერვისები",
    "addProcedure": "პროცედურის დამატება",
    "addProduct": "პროდუქტის დამატება",
    "editProduct": "პროდუქტის რედაქტირება",
    "specialProcedures": "სპეც.პროცედურები",
    "addSpecialProcedure": "სპეც.პროცედურის დამატება",
    "allDayOff": "დასვენების დღე",
    "form": {
      "user": "მომხმარებელი",
      "birthdayToday": "დღეს დაბადების დღეა",
      "birthdayGreeting": "დაბადების დღის მილოცვა",
      "employee": "თანამშრომელი",
      "employeeLocked": "პროცედურის დამატების შემდეგ თანამშრომელი აღარ იცვლება",
      "employeeBusy": "ამ დროს თანამშრომელი დაკავებულია",
      "startTime": "დაწყების დრო",
      "userRequest": "მომხმარებლის მოთხოვნით",
      "date": "თარიღი",
      "startingTime": "დაწყების დრო",
      "finishingTime": "დასრულების დრო",
      "comment": "კომენტარი",
      "fixatedExpense": "ფიქს. ხარჯი",
      "expense": "ხარჯი",
      "paymentMethod": "გადახდის მეთოდი",
      "balance": "ბალანსი",
      "available": "ხელმისაწვდომი",
      "cash": "ნაღდი",
      "bank": "საბანკო",
      "minutes": "წუთები",
      "exchange": "ბარტერი",
      "consignment": "კონსიგნაცია",
      "bankTransfer": "საბანკო ოპერაცია",
      "gel": "ლარი",
      "sumTotal": "ჯამური ფასი",
      "present": "საჩუქარი",
      "sendNotification": "შეტყობინების გაგზავნა",
      "withCash": "ნაღდი ანგარიშსწორება",
      "procedure": "პროცედურა",
      "procedureAndPrice": "პროცედურა და ფასი",
      "name": "სახელი",
      "lastName": "გვარი",
      "phoneNumber": "მობილურის ნომერი",
      "duration": "ხანგრძლივობა",
      "time": "დრო",
      "price": "ღირებულება",
      "discount": "ფასდაკლება",
      "percent": "პროცენტი",
      "discountedPrice": "ფასდაკლებული ფასი",
      "fixatedSalary": "ხელფასი ფიქს",
      "salary%": "ხელფასი%",
      "fromValue": "ღირებულებიდან",
      "numberProcedures": "პროცედურის რაოდენობა",
      "expenses": "დანახარჯი",
      "products": "პროდუქტები",
      "gram": "გრამი",
      "quantity": "რაოდენობა",
      "product": "პროდუქტი",
      "piece": "ცალი",
      "specialProcedure": "სპეციალური პროცედურა",
      "specialist": "სპეციალისტი",
      "salary": "ხელფასი",
      "inStock": "მარაგშია",
      "debt": "დავალიანება",
      "room": "ოთახი",
      "selectRoom": "აირჩიეთ ოთახი",
      "source": "ჯავშნის წყარო",
      "sourcePlaceholder": "აირჩიეთ წყარო",
      "additionalEmployees": "დამატებითი თანამშრომლები",
      "employees": "თანამშრომლები",
      "addEmployee": "თანამშრომლის დამატება",
      "selectEmployee": "აირჩიეთ თანამშრომელი",
      "verified": "ვერიფიცირებული",
      "errors": {
        "dateRangeError": "დაწყების დრო არ უნდა აღემატებოდეს დასრულების დროს",
        "totalPrice": "ჯამური ფასი არ შეიძლება იყოს 0 ან ღირებულებაზე მეტი"
      },
      "unit": "ერთეული",
      "willUse": "დაიხარჯება"
    },
    "week": {
      "mon": "ორშ",
      "tue": "სამ",
      "wed": "ოთხ",
      "thu": "ხუთ",
      "fri": "პარ",
      "sat": "შაბ",
      "sun": "კვი"
    },
    "months": {
      "january": "იანვარი",
      "february": "თებერვალი",
      "march": "მარტი",
      "april": "აპრილი",
      "may": "მაისი",
      "june": "ივნისი",
      "july": "ივლისი",
      "august": "აგვისტო",
      "september": "სექტემბერი",
      "october": "ოქტომბერი",
      "november": "ნოემბერი",
      "december": "დეკემბერი"
    },
    "popup": {
      "employee": "თანამშრომელი",
      "user": "მომხმარებელი",
      "mobilePhone": "მობილური",
      "procedure": "პროცედურა",
      "price": "ფასი",
      "discount": "ფასდაკლებით",
      "times": "დრო",
      "comment": "კომენტარი",
      "bookedAt": "დაჯავშნილია",
      "bookedBy": "შექმნა",
      "completedBy": "დასრულება",
      "status": "სტატუსი",
      "balance": "ბალანსი",
      "source": "წყარო",
      "additionalEmployee": "დამატებითი თანამშრომელი",
      "room": "ოთახი",
      "paidAmount": "გადახდილი"
    },
    "tooltip": {
      "calendar": "კალენდარი",
      "employeeCard": "თანამშრომლის ბარათი"
    },
    "menu": {
      "newVisit": "ახალი ვიზიტი",
      "employeeDay": "თანამშრომლის კალენდარი",
      "block": "დროის დაბლოკვა",
      "blockConfirm": "დაბლოკოს {{name}}-ის მთელი დღე ({{date}})?",
      "blockSuccess": "დღე მონიშნულია არასამუშაოდ"
    },
    "status": {
      "confirmed": "დადასტურებული",
      "inProgress": "პროცესში",
      "completed": "დასრულებული",
      "noShow": "არ გამოცხადდა"
    },
    "unknownClient": "უცნობი",
    "notWorking": "არასამუშაო",
    "saveError": "შენახვა ვერ მოხერხდა",
    "hold": {
      "tooltip": "სლოტი დაჯავშნილია ონლაინ გადახდისთვის — დაჯავშნა შეუძლებელია",
      "genericSource": "ონლაინ ჯავშანი",
      "ariaLabel": "დაჯავშნილია {{source}}-ის მეშვეობით, {{start}}–{{end}}, დაჯავშნა შეუძლებელია"
    },
    "pendingOnline": {
      "title": "მოლოდინში მყოფი ონლაინ ჯავშანი",
      "tooltip": "საჭიროებს დადასტურებას — გადადით ონლაინ ჯავშნებში მისაღებად ან უარსაყოფად",
      "overlapWarningTitle": "ეს სლოტი ემთხვევა მოლოდინში მყოფ ონლაინ ჯავშანს",
      "overlapWarningContent": "{{name}}, {{start}}–{{end}}, გადახდილია ₾{{paid}} ₾{{total}}-დან. მაინც დავჯავშნოთ?",
      "overlapWarningConfirm": "მაინც დაჯავშნა",
      "overlapWarningUnknownCustomer": "კლიენტი"
    },
    "confirmedOnline": {
      "label": "ონლაინ"
    }
  },
  "recordings": {
    "start": "დაწყება",
    "finish": "დასრულება",
    "deleted": "წაშლილები",
    "status": "სტატუსი",
    "service": "სერვისი",
    "price": "ღირებულება",
    "reservationTime": "ჩაწერის თარიღი",
    "startingTime": "დაწყ. დრო",
    "finishingTime": "დასრ. დრო",
    "employee": "თანამშრომელი",
    "room": "ოთახი",
    "source": "წყარო",
    "user": "მომხმარებელი",
    "mobilePhone": "მობილური",
    "createdBy": "ვინ ჩაწერა",
    "created": "შექმნილი",
    "cancellationDate": "გაუქმების თარიღი",
    "cancelledBy": "გააუქმა",
    "cancellationReason": "გაუქმების მიზეზი",
    "download": "ჩამოტვირთვა"
  },
  "statistic": {
    "detailSearch": {
      "operationSource": {
        "reservation": "ჩაწერა",
        "salary": "ხელფასი",
        "realization": "რეალიზაცია",
        "expense": "გასავალი",
        "purchase": "შესყიდვა",
        "popOpBalance": "ბალანსის შევსება",
        "returnBalance": "ბალანსის დაბრუნება",
        "cashRegister": "სალარო"
      },
      "operationType": {
        "procedure": "პროცედურა ",
        "specialProcedure": "სპეც.პროცედურა",
        "accrualSalary": "ხელფასის დარიცხვა",
        "salaryDisbursement": "ხელფასის გაცემა",
        "sell": "გაყიდვა",
        "spend": "გახარჯვა",
        "purchase": "შესყიდვა",
        "expense": "გასავალი",
        "topUpBalance": "ბალანსის შევსება",
        "spendBalance": "ბალანსის გახარჯვა",
        "returnBalance": "ბალანსის დაბრუნება"
      },
      "search": {
        "start": "დაწყება",
        "finish": "დასრულება",
        "employee": "თანამშრომელი",
        "user": "მომხმარებელი",
        "procedureCategory": "პროცედურის კატეგორია",
        "category": "კატეგორია",
        "procedure": "პროცედურა",
        "room": "ოთახი",
        "source": "წყარო",
        "expenseCategory": "გასავლის კატეგორია",
        "expenseSubCategory": "გასავლის ქვე კატეგორია",
        "sourceOperation": "ოპერაციის წყარო",
        "operationType": "ოპერაციის ტიპი",
        "product": "პროდუქტი",
        "productCategory": "პროდუქტის კატეგორია",
        "productProvider": "პროდუქტის მომწოდებელი",
        "reservation": "ჩაწერა",
        "productCodeBarcode": "პროდუქტის კოდი ან ბარკოდი"
      },
      "column": {
        "operationNumber": "#",
        "date": "თარიღი",
        "sourceOperation": "ოპერაციის წყარო",
        "type": "ტიპი",
        "paymentMethod": "გადახდის ტიპი",
        "service": "სერვისი",
        "category": "კატეგორია",
        "time": "დრო",
        "user": "მომხმარებელი",
        "price": "ღირებულება",
        "discountPrice": "ფასდაკლების ფასი",
        "discount%": "ფასდაკლების %",
        "fixatedExpense": "ფიქს.ხარჯი",
        "specialProcedureExpense": "სპეც.პროც. დანახარჯი",
        "employee": "თანამშრომელი",
        "employeeSalary": "ხელფასი",
        "expenseCategory": "ხარჯის კატეგორია",
        "nameProduct": "პროდუქტის დასახელება",
        "barcode": "ბარკოდი",
        "provider": "მომწოდებელი",
        "quantity": "რაოდენობა",
        "capacity": "მოცულობა",
        "created": "შექმნილი",
        "createdBy": "ვინ შექმნა"
      },
      "detailView": {
        "user": "მომხმარებელი",
        "created": "შექმნილი",
        "comment": "კომენტარი",
        "employee": "თანამშრომელი",
        "createdBy": "ვინ შექმნა",
        "sumTotal": "ჯამი",
        "type": "ტიპი",
        "procedures": "პროცედურები",
        "reservationDate": "ჩაწერის თარიღი",
        "nameLastName": "სახელი,გვარი",
        "time": "დრო",
        "price": "ღირებულება",
        "position": "პოზიცია",
        "fixatedExpense": "ფიქს.ხარჯი",
        "additionalExpense": "დამატებითი ხარჯი",
        "discountPrice": "ფასდ.ფასი",
        "employee%": "თანამშრომლის%",
        "products": "პროდუქტები",
        "barcode": "ბარკოდი",
        "nameProduct": "პროდუქტის დასახელება",
        "service": "სერვისი",
        "capacity": "მოცულობა",
        "quantity": "რაოდენობა",
        "salary": "ხელფასი",
        "fixated%": "ფიქს. %",
        "employeeSalary": "თანამშრომლის ხელფასი",
        "transaction": "ტრანზაქცია",
        "transaction#": "ტრანზ. #",
        "transactionType": "ტრანზაქციის ტიპი",
        "paymentMethod": "გადახდის ტიპი",
        "cash": "ნაღდი",
        "card": "ბარათი",
        "bank": "ბანკი",
        "balance(GEL)": "ბალანსი(₾)  ",
        "status": "სტატუსი",
        "addAmount": "თანხის დამატება",
        "amount": "თანხა",
        "gel": "ლარი",
        "salaryDisbursement": " ხელფასის გაცემა",
        "Products": "პროდუქტები ",
        "expenses": "ხარჯები",
        "balance": "ბალანსი "
      }
    },
    "operation": {
      "operationSource": {
        "reservation": "ჩაწერა",
        "salary": "ხელფასი",
        "realization": "რეალიზაცია",
        "expense": "გასავალი",
        "purchase": "შესყიდვა",
        "popOpBalance": "ბალანსის შევსება",
        "returnBalance": "ბალანსის დაბრუნება",
        "cashRegister": "სალარო"
      },
      "search": {
        "start": "დაწყება",
        "finish": "დასრულება",
        "operationNumber": "ოპერაციის ნომერი",
        "sourceOperation": "ოპერაციის წყარო",
        "employee": "თანამშრომელი",
        "createdBy": "შექმნა",
        "user": "მომხმარებელი",
        "bank": "ბანკი"
      },
      "column": {
        "operationNumber": "#",
        "sourceOperation": "ოპერაციის წყარო",
        "paymentMethod": "გადახდის ტიპი",
        "date": "თარიღი",
        "price": "ღირებულება",
        "cash": "ნაღდი",
        "card": "ბარათი",
        "bank": "ბანკი",
        "bankName": "ბანკის დასახელება",
        "balance": "ბალანსი(₾)",
        "minutes": "ბალანსი(წუთი)",
        "user": "მომხმარებელი",
        "employee": "თანამშრომელი",
        "createdBy": "ვინ შექმნა",
        "procedure": "პროცედურა",
        "created": "შექმნილი",
        "seeDetails": "დეტალური ნახვა",
        "barter": "ბარტერი"
      }
    },
    "transaction": {
      "search": {
        "start": "დაწყება",
        "finish": "დასრულება",
        "paymentMethod": "გადახდის მეთოდი",
        "deleted": "წაშლილები"
      },
      "column": {
        "transaction#": "ტრანზ.#",
        "date": "თარიღი",
        "created": "შექმნილი",
        "transactionType": "ტრანზაქციის ტიპი",
        "paymentMethod": "გადახდის ტიპი",
        "paid": "გადახდილი",
        "cash": "ნაღდი",
        "card": "ბარათი",
        "bank": "ბანკი",
        "bankName": "ბანკის სახელი",
        "balance(GEL)": "ბალანსი(₾)",
        "price": "ღირებულება",
        "discountPrice": "ფასდ.ფასი",
        "discount%": "ფასდ.%",
        "fixatedExpense": "ფიქს.ხარჯი",
        "specialProcedureExpense": "სპეც.პროც.დანახარჯი",
        "comment": "კომენტარი",
        "createdBy": "ვინ შექმნა",
        "status": "სტატუსი",
        "transaction": "ტრანზაქცია",
        "user": "მომხმარებელი"
      }
    },
    "consignation": {
      "consignmentCoverage": "კონსიგნაციის დაფარვა",
      "paymentMethod": "გადახდის ტიპი",
      "comment": "კომენტარი",
      "error": {
        "max": "მაქსიმალური დაფარვის თანხა არის {{max}} ლარი"
      },
      "search": {
        "start": "დაწყება",
        "finish": "დასრულება",
        "user": "მომხმარებელი",
        "status": "სტატუსი",
        "toPaid": "გადასახდელი",
        "paid": "გადახდილი",
        "totalPayment": "ჯამური გადასახდელი",
        "gel": "ლარი"
      },
      "column": {
        "date": "თარიღი",
        "user": "მომხმარებელი",
        "price": "ღირებულება",
        "discountPrice": "ფასდ.ფასი",
        "ToPaid": "გადასახდელი",
        "cash": "ნაღდი",
        "card": "ბარათი",
        "bank": "ბანკი",
        "consignment": "კონსიგნაცია",
        "covered": "დაფარული",
        "status": "სტატუსი",
        "employee": "თანამშრომელი",
        "created": "შექმნილი",
        "issued": "გადასახდელი",
        "paid": "გადახდილი"
      },
      "title": "კონსიგნაცია"
    }
  },
  "profitLoss": {
    "search": {
      "start": "დაწყება",
      "finish": "დასრულება"
    },
    "column": {
      "date": "თარიღი",
      "income": "შემოსავალი",
      "cash": "ნაღდი ფული ",
      "cashless": "უნაღდო",
      "fixatedExpense": "ფიქს. ხარჯი",
      "expense": "გასავალი",
      "expenseCash": "გასავალი ნაღდი",
      "cashlessExpense": "გასავალი უნაღდო",
      "salaries": "ხელფასები",
      "otherExpenses": "სხვა ხარჯები",
      "profit": "მოგება",
      "profitFixatedExpense": "მოგება-ფიქს.ხარჯი",
      "addMoney": "დამატება სალაროში",
      "subMoney": "გატანა სალაროდან"
    }
  },
  "diagrams": {
    "graphicDiagrams": "გრაფიკული დიაგრამები",
    "incomeProcedures": "პროცედურებით შემოსავალი",
    "incomeCategories": "კატეგორიებით შემოსავალი",
    "clients": "ახალი მომხმარებელი",
    "products": "პროდუქტები",
    "start": "დაწყება",
    "finish": "დასრულება",
    "procedure": "პროცედურა",
    "sumTotal": "ჯამური ღირებულება",
    "quantity": "რაოდენობა",
    "categoriesIncome": "პროცედურების კატეგორიების შემოსავალი",
    "procedureCategory": "პროცედურის კატეგორია"
  },
  "expense": {
    "expenseType": "გასავლის ტიპი",
    "category": "კატეგორია",
    "toPaid": "გადასახდელი",
    "amount": "თანხა",
    "viaBank": "საბანკო ოპერაცია",
    "comment": "მიუთითეთ კომენტარი",
    "issueExpense": "გასავლის გაცემა",
    "expenseCategories": "გასავლის კატეგორიები",
    "addExpense": "გასავლის დამატება",
    "nameExpense": "გასავლის სახელი",
    "subCategory": "ქვე-კატეგორია",
    "expenseProcessing": "გასავლის გატარება",
    "addSubCategory": "ქვეკატეგორიის დასახელება",
    "date": "გასავლის თარიღი",
    "close": "დახურვა",
    "paymentMethod": {
      "label": "გადახდის მეთოდი",
      "cash": "ნაღდი",
      "card": "ბარათი",
      "transfer": "გადარიცხვა"
    },
    "bank": "ბანკი",
    "total": "სულ",
    "payableTotal": "გადასახდელი ჯამი",
    "issueSuccess": "გასავალი წარმატებით გაიცა",
    "noSubcategory": "ქვეკატეგორია არ არის დამატებული",
    "required": "შევსება სავალდებულოა",
    "viewDeleted": "წაშლილების ჩვენება",
    "deleted": "წაშლილი"
  },
  "booking": {
    "productExpense": "პროდუქტის ხარჯი",
    "additionalExpense": "დამატებითი ხარჯი",
    "totalExpense": "ჯამური ხარჯი"
  },
  "marketing": {
    "reminder": {
      "created": "შექმნილი",
      "user": "მომხმარებელი",
      "serviceCategory": "სერვისის კატეგორია",
      "lastVisit": "ბოლო ვიზიტი",
      "reminderPeriod": "შემახსენებლის პერიოდი",
      "remindDate": "შემახსენებლის თარიღი",
      "isSent": "გაგზავნილია"
    },
    "smsHistory": {
      "search": {
        "start": "დაწყება",
        "finish": "დასრულება",
        "sender": "გამგზავნი",
        "receiver": "მიმღები",
        "user": "მომხმარებელი",
        "reminderSource": "შეხსენების წყარო"
      },
      "created": "შექმნილი",
      "smsType": "SMS ტიპი",
      "sender": "გამგზავნი",
      "receiver": "მიმღები",
      "user": "მომხმარებელი",
      "reminderSource": "შეხსენების წყარო",
      "reminderPeriod": "შეხსენების პერიოდი",
      "notification": "შეტყობინება"
    },
    "smsTemplate": {
      "yourTemplate": "თქვენი შაბლონი",
      "addTemplateEdit": "შაბლონის დამატება/რედაქტირება",
      "addTemplate": "შაბლონის დამატება",
      "branchConfig": "ფილიალის კონფიგურაცია",
      "advancedSmsEnabled": "გაფართოებული SMS",
      "defaultLanguage": "ნაგულისხმევი ენა",
      "reminderOffsets": "შეხსენება ვიზიტამდე (წუთი)",
      "eventEnabled": "ჩართული",
      "previewTest": "გადახედვა / ტესტი",
      "language": "ენა",
      "preview": "გადახედვა",
      "noPreview": "გადახედვა მიუწვდომელია",
      "testPhone": "ტელეფონი",
      "sendTest": "სატესტო გაგზავნა",
      "configSaved": "პარამეტრები შენახულია",
      "eventToggled": "მოვლენა განახლებულია",
      "testSentOk": "სატესტო SMS გაიგზავნა",
      "testSentFail": "სატესტო SMS ვერ გაიგზავნა",
      "saveFailed": "შენახვა ვერ მოხერხდა",
      "toggleError": "სტატუსის განახლება ვერ მოხერხდა",
      "title": "SMS შეტყობინებები",
      "subtitle": "მართეთ ამ ფილიალის SMS-შეტყობინებები: რომელ მოვლენებზე იგზავნება, რომელ ენაზე და რომელი შაბლონით.",
      "statusOn": "ჩართულია",
      "statusOff": "გამორთულია",
      "event": "მოვლენა",
      "languages": "ენები",
      "hasOverride": "ფილიალის შაბლონი დაყენებულია",
      "usesDefault": "იყენებს ნაგულისხმევ ტექსტს",
      "noEvents": "მოვლენები არ მოიძებნა",
      "systemDefault": "შეტყობინების ტექსტი",
      "branchOverride": "თქვენი ვერსია",
      "insertField": "ველის ჩასმა:",
      "chars": "სიმბოლო",
      "reminderOffsetsHelp": "მიუთითეთ, რამდენი წუთით ადრე გაეგზავნოს კლიენტს შეხსენება (მაგ. 1440 — 1 დღით ადრე, 120 — 2 საათით ადრე).",
      "defaultLanguageHelp": "ამ ენაზე გაიგზავნება SMS, თუ კლიენტის სასურველი ენა უცნობია.",
      "advancedSmsEnabledHelp": "ჩართავს ამ ფილიალის დამოუკიდებელ SMS-სისტემას: შაბლონები ენების მიხედვით, მოვლენების ჩართვა-გამორთვა და შეხსენების დროის მართვა.",
      "remindersHeading": "ვიზიტის შეხსენებები",
      "fixedReminderLabel": "1 დღით ადრე, 17:00 საათზე (ყოველთვის ჩართული)",
      "additionalReminderLabel": "დამატებითი შეხსენება ვიზიტამდე",
      "additionalReminderHelp": "სურვილისამებრ, გააგზავნეთ კიდევ ერთი შეხსენება ვიზიტამდე გარკვეული დროით ადრე.",
      "unitMinutes": "წუთი",
      "unitHours": "საათი",
      "reminderRange": "შეხსენება უნდა იყოს 5 წუთიდან 1 დღემდე ინტერვალში.",
      "clearReminder": "გასუფთავება"
    },
    "birthday": {
      "title": "დაბადების დღეები",
      "subtitle": "ვის აქვს დაბადების დღე უახლოეს დღეებში. ავტომატური მილოცვა იგზავნება მხოლოდ დაბადების დღეს, ხოლო ხელით გაგზავნა შესაძლებელია ნებისმიერ დღეს.",
      "range": "პერიოდი",
      "branch": "ფილიალი",
      "allBranches": "ყველა ფილიალი",
      "customer": "მომხმარებელი",
      "birthDate": "დაბადების დღე",
      "daysLeft": "დარჩა დღე",
      "phone": "ტელეფონი",
      "lastBranch": "ფილიალი",
      "statusColumn": "სტატუსი",
      "greetedToday": "მილოცულია",
      "notGreeted": "ჯერ არ არის მილოცული",
      "today": "დღეს",
      "inDays": "{{n}} დღეში",
      "todayGroup": "დღეს",
      "upcomingGroup": "მომავალი",
      "noneToday": "დღეს არავის აქვს დაბადების დღე.",
      "manualRule": "ხელით გაგზავნა ნებისმიერ დღეს შეიძლება. ავტომატური მილოცვა მხოლოდ დაბადების დღეს იგზავნება.",
      "loadFailed": "სიის ჩატვირთვა ვერ მოხერხდა",
      "sendSelected": "მილოცვის გაგზავნა",
      "confirmTitle": "გაიგზავნოს {{count}} მომხმარებელს?",
      "confirmTemplate": "შაბლონი: {{template}}",
      "confirmRepeat": "შაბლონი: {{template}}. მათგან {{count}}-ს ბოლო წლის განმავლობაში უკვე გაეგზავნა მილოცვა.",
      "templatePlaceholder": "შაბლონი",
      "noTemplates": "შაბლონი არ არის შექმნილი — შექმენით პარამეტრებში",
      "featureDisabledHint": "დაბადების დღეების მილოცვა გამორთულია — ჩართეთ პარამეტრებში",
      "sendFailedGeneric": "გაგზავნა ვერ მოხერხდა",
      "greetedOn": "მილოცულია — {{date}}",
      "status": {
        "SENT": "გაიგზავნა",
        "ALREADY_SENT": "დღეს უკვე მიულოცეს",
        "NO_PHONE": "ტელეფონის ნომერი არ აქვს",
        "NO_BRANCH": "ფილიალი ვერ დადგინდა",
        "NO_SENDER": "ფილიალს SMS გამგზავნი არ აქვს",
        "NO_TEMPLATE": "ამ ენაზე აქტიური შაბლონი არ არის",
        "NOT_ELIGIBLE": "არ არის შესაფერისი (არ აქვს დაბადების თარიღი, ტელეფონის ნომერი ან არ არის ამ ორგანიზაციის მომხმარებელი)",
        "FAILED": "შეცდომა"
      },
      "config": {
        "title": "დაბადების დღის კონფიგურაცია",
        "subtitle": "ავტომატური მილოცვის პარამეტრები და შაბლონები. პარამეტრები მთელ ორგანიზაციაზე მოქმედებს.",
        "isActive": "ავტომატური გაგზავნა",
        "isActiveHint": "ჩართვის შემდეგ მილოცვა ყოველდღე ავტომატურად გაიგზავნება",
        "stateOn": "ჩართულია",
        "stateOff": "გამორთულია",
        "sendHour": "გაგზავნის საათი",
        "sendHourHint": "თბილისის დროით, 0-დან 23-მდე",
        "sendHourError": "მიუთითეთ საათი 0-დან 23-მდე",
        "minVisits": "მინიმალური ვიზიტები",
        "minVisitsHint": "ამაზე ნაკლები ვიზიტის მქონე მომხმარებელს მილოცვა არ გაეგზავნება",
        "minVisitsError": "მინიმუმ 1",
        "save": "შენახვა",
        "saved": "შენახულია",
        "saveFailed": "შენახვა ვერ მოხერხდა",
        "confirmTitle": "ავტომატური გაგზავნის ჩართვა",
        "confirmBody": "ყოველდღე {{hour}}:00 საათზე (თბილისის დროით) მთელი ორგანიზაციის ყველა შესაბამის მომხმარებელს ავტომატურად გაეგზავნება SMS. თითოეული გზავნილი ფასიანია.",
        "confirmOk": "ჩართვა"
      },
      "template": {
        "title": "შაბლონები",
        "add": "შაბლონის დამატება",
        "edit": "შაბლონის რედაქტირება",
        "editAction": "რედაქტირება",
        "name": "სახელი",
        "nameError": "სახელი სავალდებულოა",
        "language": "ენა",
        "message": "ტექსტი",
        "messageError": "ტექსტი სავალდებულოა",
        "isDefault": "ნაგულისხმევი",
        "isActive": "აქტიური",
        "active": "აქტიური",
        "inactive": "გამორთული",
        "defaultWarning": "ამ ენაზე უკვე არის ნაგულისხმევი შაბლონი. შენახვისას ის ავტომატურად გამოირთვება.",
        "save": "შენახვა",
        "cancel": "გაუქმება",
        "saved": "შენახულია",
        "saveFailed": "შენახვა ვერ მოხერხდა",
        "loadFailed": "შაბლონების ჩატვირთვა ვერ მოხერხდა"
      },
      "widget": {
        "title": "დაბადების დღეები",
        "seeAll": "სრული სია",
        "today": "დღეს",
        "tomorrow": "ხვალ",
        "week": "მომდევნო კვირაში",
        "none": "უახლოეს კვირაში დაბადების დღეები არ არის.",
        "failed": "დაბადების დღეების ჩატვირთვა ვერ მოხერხდა."
      }
    }
  },
  "MassiveUploadProcedures": {
    "title": "პროცედურების მასიური ატვირთვა ფაილით",
    "p1": "პროცედურის დამატებისას აუცილებელია, რომ ასატვირთი ინფორმაცია შეყვანილი იყოს უკვე გამზადებულ ექსელის ფაილში, რომლის შაბლონის ჩამოტვირთვაც შეგიძლიათ ღილაკზე \"შაბლონი\" დაჭერით",
    "p2": "გადაიტანეთ თქვენი ფაილებიდან აღნიშნულ ფორმაში პროცედურების დასახელება სხვა ინფორმაციასთან ერთად და ატვირთეთ სისტემაში",
    "p3": "გთხოვთ გაითვალისწინოთ, რომ კატეგორია, პროვაიდერი და პროვაიდერის პროდუქტის დასახელება იყოს 100% თანხვედრაში პროგრამაში უკვე არსებულ ჩანაწერსა და თქვენს მიერ, ექსელში მითითებულს შორის, სხვა შემთხვევაში, პროგრამულ უზრუნველყოფაში შეიქმნება ახალი დასახელების კატეგორია, პროვაიდერი და პროვაიდერის პროდუქტი."
  },
  "massiveUploadProduct": {
    "title": "პროდუქტების მასიური ატვირთვა ფაილით",
    "p1": "პროდუქტის ატვირთვისას აუცილებელია, რომ თქვენი ნაშთები იყოს შეყვანილი უკვე გამზადებულ ექსელის ფორმაში, რომლის შაბლონი შეგიძლიათ გადმოწეროთ ღილაკზე დაჭერით 'შაბლონის ჩამოტვირთვა'",
    "p2": "გადაიტანეთ თქვენი ფაილებიდან პროდუქტების ინფორმაცია აღნიშნულ ფაილში და ატვირთეთ სისტემაში.",
    "p3": "გთხოვთ გაითვალისწინოთ, რომ მომწოდებლისა და კატეგორიის დასახელება იყოს 100% თანხვედრაში პროგრამაში უკვე არსებულ ჩანაწერსა და თქვენს მიერ, ექსელში მითითებულს შორის, სხვა შემთხვევაში, პროგრამულ უზრუნველყოფაში შეიქმნება ახალი დასახელების კატეგორია ან მომწოდებელი."
  },
  "massiveUploadUser": {
    "title": "მომხმარებლის მასიური ატვირთვა ფაილით",
    "p1": "მომხმარებელთა ბაზის ატვირთვისას აუცილებელია, რომ მათი ინფორმაცია იყოს შეყვანილი უკვე გამზადებულ ექსელის ფორმაში, რომლის შაბლონი შეგიძლიათ გადმოწეროთ ღილაკზე დაჭერით 'შაბლონის ჩამოტვირთვა'.",
    "p2": "გადაიტანეთ თქვენი ფაილებიდან მომხმარებელთა ინფორმაცია აღნიშნულ ფაილში და ატვირთეთ სისტემაში.",
    "p3": "გთხოვთ გაითვალისწინოთ, რომ ინფორმაცია უნდა იყოს 100% თანხვედრაში ველების დასახელებასთან."
  },
  "validators": {
    "percentRange": "პროცენტი უნდა იყოს 0-დან 100-მდე",
    "required": "მითითება სავალდებულოა",
    "personalId11Digits": "პირადი ნომერი უნდა შედგებოდეს ზუსტად 11 ციფრისგან",
    "email": "მიუთითეთ სწორი ელ.ფოსტა",
    "minTimeRequired": "დრო არ შეიძლება იყოს 00:00",
    "PleaseEnterUser": "გთხოვთ შეიყვანოთ მომხმარებლის სახელი",
    "PleaseEnterPassword": "გთხოვთ შეიყვანოთ სწორი პაროლი",
    "incorrectUsername": "მომხმარებლის სახელი არასწორია",
    "incorrectPassword": "პაროლი არასწორია",
    "indicateCurrentPassword": "მიუთითეთ მიმდინარე პაროლი!",
    "indicateNewPassword": "მიუთითეთ ახალი პაროლი!",
    "repeatedPasswordMandatory": "განმეორებითი პაროლის მითითება სავალდებულოა",
    "passwordMatch": "პაროლი არ ემთხვევა",
    "nextDayCashbox": "მომდევნო დღის სალაროს გახსნა შეუძლებელია",
    "sureCloseDayYesNo": "ნამდვილად გსურთ დღის დახურვა?დიახ/არა"
  },
  "notifications": {
    "indicationMandatory": "მითითება სავალდებულოა",
    "minTimeRequired": "დრო არ შეიძლება იყოს 00:00",
    "PleaseEnterUser": "გთხოვთ შეიყვანოთ მომხმარებლის სახელი",
    "PleaseEnterPassword": "გთხოვთ შეიყვანოთ სწორი პაროლი",
    "incorrectUsername": "მომხმარებლის სახელი არასწორია",
    "incorrectPassword": "პაროლი არასწორია",
    "indicateCurrentPassword": "მიუთითეთ მიმდინარე პაროლი!",
    "indicateNewPassword": "მიუთითეთ ახალი პაროლი!",
    "repeatedPasswordMandatory": "განმეორებითი პაროლის მითითება სავალდებულოა",
    "passwordMatch": "პაროლი არ ემთხვევა",
    "nextDayCashbox": "მომდევნო დღის სალაროს გახსნა შეუძლებელია",
    "sureCloseDayYesNo": "ნამდვილად გსურთ დღის დახურვა?დიახ/არა"
  },
  "buttons": {
    "newRecord": "ახალი ჩანაწერი",
    "cancel": "გაუქმება",
    "withFile": "ფაილით დამატება",
    "download": "ჩამოტვირთვა",
    "save": "შენახვა",
    "create": "შექმნა",
    "view": "ნახვა",
    "close": "დახურვა",
    "deletePop": "ნამდვილად გსურთ წაშლა?",
    "massiveUpload": "მასიური დამატება",
    "edit": "რედაქტირება",
    "delete": "წაშლა",
    "remove": "წაშლა",
    "update": "განახლება",
    "updateHistory": "განახლების ისტორია",
    "stockAccounting": "მარაგის აღრიცხვა",
    "finishPop": "ნამდვილად გსურთ დასრულება?",
    "finish": "დასრულება",
    "search": "ძებნა",
    "clear": "გასუფთავება",
    "pay": "გადახდა",
    "template": "შაბლონი",
    "chooseFile": "ფაილის არჩევა",
    "upload": "ატვირთვა",
    "decline": "გაუქმება",
    "accept": "დადასტურება",
    "sendSms": "SMS-ის გაგზავნა",
    "sendEmail": "ელ.ფოსტაზე გაგზავნა",
    "selectAll": "ყველას არჩევა",
    "add": "დამატება"
  },
  "search": {
    "searchWord": "საძიებო სიტყვა",
    "category": "კატეგორია",
    "distributor": "მომწოდებელი"
  },
  "specifyingNeccessary": "მითითება სავალდებულოა",
  "findReservation": {
    "reservation": "ჯავშანი",
    "employee": "თანამშრომელი",
    "user": "კლიენტი",
    "phoneNumber": "ტელეფონი",
    "procedure": "პროცედურა",
    "price": "ფასი",
    "gel": "ლარი"
  },
  "organization": {
    "name": "სახელი",
    "subdomain": "საიტის მისამართი",
    "legalName": "იურიდიული სახელი",
    "orgPrefix": "პრეფიქსი",
    "registrationNumber": "საიდენტიფიკაციო კოდი/ პირადი ნომერი ინდ.მეწარმის შემთხვევაში",
    "physicalAddress": "ფიზიკური მისამართი",
    "legalAddress": "იურიდიული მისამართი",
    "mobile": "ხელმძღვანელის მობილური ნომერი",
    "phone": "ფილიალის მობილური ნომერი",
    "facebook": "ფეისბუქი",
    "instagram": "ინსტაგრამი",
    "webpage": "ვებგვერდი",
    "tiktok": "ტიკტოკი",
    "youtube": "იუთუბი",
    "description": "აღწერა",
    "email": "ელ.ფოსტა",
    "update": "განახლება",
    "onlineBooking": "ონლაინ ჩაწერა",
    "printConfig": {
      "title": "ბეჭდვის ჰედერი და ფუტერი",
      "configure": "კონფიგურაცია",
      "saved": "ბეჭდვის კონფიგურაცია შენახულია",
      "headerLogo": "ჰედერის ლოგო",
      "uploadLogo": "ლოგოს ატვირთვა",
      "headerTitle": "ჰედერის სათაური",
      "headerTitlePlaceholder": "კომპანია / დოკუმენტის სათაური",
      "footerLine1": "ფუტერის ხაზი 1",
      "footerLine1Placeholder": "მისამართი, ტელეფონი და ა.შ.",
      "footerLine2": "ფუტერის ხაზი 2",
      "footerLine2Placeholder": "ვებგვერდი, ელ.ფოსტა და ა.შ.",
      "showPageNumbers": "გვერდების ნომრების ჩვენება",
      "inherited": "ორგანიზაციიდან",
      "resetToOrg": "ორგანიზაციის პარამეტრებზე დაბრუნება",
      "savePrintConfig": "ბეჭდვის კონფიგურაციის შენახვა",
      "signatureImage": "ხელმოწერის სურათი",
      "uploadSignature": "ხელმოწერის ატვირთვა"
    }
  },
  "location": {
    "country": "ქვეყანა",
    "region": "რეგიონი",
    "municipality": "მუნიციპალიტეტი",
    "city": "ქალაქი",
    "district": "უბანი",
    "selectCountry": "აირჩიეთ ქვეყანა",
    "selectRegion": "აირჩიეთ რეგიონი",
    "selectMunicipality": "აირჩიეთ მუნიციპალიტეტი",
    "selectCity": "აირჩიეთ ქალაქი",
    "selectDistrict": "აირჩიეთ უბანი"
  },
  "bookinghub": {
    "activate": {
      "title": "Bookinghub.ge გააქტიურება",
      "description": "გთხოვთ შეიყვანოთ თქვენი მობილური ნომერი და პაროლი რომლის საფუძველზეა გსურთ გააქტიუროთ Bookinghub.ge სერვისი",
      "mobilePhone": "მობილური ნომერი",
      "password": "პაროლი"
    }
  },
  "onlineCatalog": {
    "title": "BookingHub პროცედურები",
    "subtitle": "BookingHub-ისთვის ონლაინ სერვისების მართვა",
    "branchServices": "ფილიალის სერვისები",
    "addService": "სერვისის დამატება",
    "editService": "სერვისის რედაქტირება",
    "serviceName": "სერვისის დასახელება",
    "category": "კატეგორია",
    "price": "ფასი",
    "duration": "ხანგრძლივობა",
    "employees": "თანამშრომლები",
    "status": "სტატუსი",
    "noServicesConfigured": "ონლაინ სერვისები არ არის კონფიგურირებული",
    "addFirstService": "პირველი სერვისის დამატება",
    "selectService": "აირჩიეთ სერვისი",
    "selectServicePlaceholder": "მოძებნეთ და აირჩიეთ სერვისი კატალოგიდან",
    "suggestedPrice": "რეკომენდირებული ფასი",
    "suggestedDuration": "რეკომენდირებული ხანგრძლივობა",
    "from": "დან",
    "upTo": "მდე",
    "minutes": "წუთი",
    "serviceAdded": "სერვისი წარმატებით დაემატა",
    "serviceUpdated": "სერვისი წარმატებით განახლდა",
    "serviceDeleted": "სერვისი წარმატებით წაიშალა",
    "serviceActivated": "სერვისი გააქტიურდა",
    "serviceDeactivated": "სერვისი დეაქტივირდა",
    "confirmDelete": "დარწმუნებული ხართ, რომ გსურთ სერვისის წაშლა?",
    "assignEmployees": "თანამშრომლების მინიჭება",
    "noEmployees": "თანამშრომლები არ არის მინიჭებული",
    "employeesCount": "თანამშრომელი",
    "employeeName": "თანამშრომლის სახელი",
    "position": "პოზიცია",
    "customPrice": "ინდივიდუალური ფასი",
    "customDuration": "ინდივიდუალური დრო",
    "defaultPrice": "სტანდარტული ფასი",
    "defaultDuration": "სტანდარტული დრო",
    "selectedEmployees": "არჩეული თანამშრომლები",
    "employeesAssigned": "თანამშრომლები წარმატებით მიენიჭა",
    "noEmployeesAvailable": "თანამშრომლები არ მოიძებნა",
    "bulkAddServices": "სერვისების მასობრივი დამატება",
    "searchServices": "მოძებნეთ სერვისები...",
    "selectAll": "ყველას მონიშვნა",
    "selectedCount": "არჩეულია",
    "addSelected": "არჩეულის დამატება",
    "selectAtLeastOneService": "გთხოვთ აირჩიოთ მინიმუმ ერთი სერვისი",
    "servicesAddedCount": "{{count}} სერვისი წარმატებით დაემატა",
    "servicesSkippedCount": "{{count}} სერვისი გამოტოვდა (უკვე დამატებულია)",
    "noServicesFound": "სერვისები არ მოიძებნა",
    "startTime": "დაწყება",
    "endTime": "დასრულება",
    "searchEmployee": "ძებნა სახელით ან პოზიციით",
    "searchService": "სერვისის ძებნა...",
    "allCategories": "ყველა კატეგორია",
    "requestService": "სერვისის მოთხოვნა",
    "serviceRequest": {
      "title": "ახალი სერვისის მოთხოვნა",
      "description": "თუ სასურველი სერვისი ან კატეგორია არ გხვდებათ კატალოგში, შეგიძლიათ გამოაგზავნოთ მოთხოვნა და ჩვენ განვიხილავთ მის დამატებას.",
      "type": "ტიპი",
      "typePlaceholder": "აირჩიეთ ტიპი",
      "typeService": "სერვისი",
      "typeCategory": "კატეგორია",
      "name": "დასახელება",
      "namePlaceholder": "მიუთითეთ სასურველი სერვისის ან კატეგორიის სახელი",
      "success": "მოთხოვნა წარმატებით გაიგზავნა",
      "error": "მოთხოვნის გაგზავნა ვერ მოხერხდა"
    }
  },
  "notification": {
    "permission_denied": "თქვენ უარყავით შეტყობინებები. გთხოვთ, დაუშვათ შეტყობინებები თქვენი ბრაუზერის პარამეტრებში განახლებების მისაღებად.",
    "permission_default": "თქვენ ჯერ არ დაუშვით შეტყობინებები. გთხოვთ, დაუშვათ შეტყობინებები თქვენი ბრაუზერის პარამეტრებში განახლებების მისაღებად.",
    "permission_request": "შეტყობინებების ჩართვა"
  },
  "packageUserLimit": "გამარჯობა, გაცნონებთ, რომ თქვენს კომპანიაზე არსებული ლიცენზიის თანამშრომლების რაოდენობის ლიმიტი გადაჭარბებულია. დამატებული თანამშრომლების ლიმიტის მაქსიმალური რაოდენობაა ({{userLimit}}), გთხოვთ დააკორექტიროთ რაოდენობა შესაბამისად, კითხვების შემთხვევაში დაგვიკავშირდით: 0322500290\nმადლობა, რომ იყენებთ ჩვენს სერვისს.",
  "notificationTitle": "შეტყობინება",
  "serverError": "სერვერის შეცდომა. გთხოვთ, სცადოთ მოგვიანებით.",
  "ALERT": {
    "important_info": "მნიშვნელოვანი ინფორმაცია",
    "important_update": "მნიშვნელოვანი განახლება"
  },
  "locale": {
    "en": "ინგლისური",
    "ka": "ქართული",
    "ru": "რუსული"
  },
  "userStatus": {
    "add-or-edit": "მომხმარებლის სტატუსის დამატება/რედაქტირება",
    "active": "აქტიური",
    "inactive": "არააქტიური",
    "name": "დასახელება",
    "description": "აღწერა"
  },
  "userSource": {
    "title": "მომხმარებლის წყაროები",
    "name": "დასახელება",
    "namePlaceholder": "მიუთითეთ წყაროს სახელი",
    "type": "ტიპი",
    "status": "სტატუსი",
    "createdAt": "შექმნილი",
    "global": "გლობალური",
    "custom": "ინდივიდუალური",
    "active": "აქტიური",
    "inactive": "არააქტიური",
    "readOnly": "მხოლოდ წაკითხვა",
    "add": "წყაროს დამატება",
    "edit": "წყაროს რედაქტირება",
    "search": "ძებნა"
  },
  "serverErrors": {
    "INSUFFICIENT_BALANCE": "ბალანსი საკმარისი არ არის გადახდისთვის",
    "INSUFFICIENT_MINUTES": "წუთები საკმარისი არ არის გადახდისთვის",
    "INVALID_SALARY_AMOUNT": "ხელფასის თანხა არასწორია",
    "signature-pad-disabled": "ხელმოწერის პადი არ არის ჩართული ამ ფილიალისთვის.",
    "Insufficient permissions": "ამ მოქმედების უფლება არ გაქვთ"
  },
  "addVisit": {
    "buttons": {
      "saveVisit": "შენახვა",
      "cancel": "ვიზიტის გაუქმება",
      "addService": "პროცედურის დამატება",
      "addProduct": "პროდუქტის დამატება",
      "continue": "გაგრძელება",
      "close": "დახურვა",
      "savePayment": "გადახდა"
    },
    "form": {
      "isAnonymous": "უცნობი მომხმარებელი",
      "anonymousName": "მომხმარებელი სახელი",
      "withOutService": "პროცედურა გარეშე",
      "sendNotification": "შეტყობინების გაგზავნა",
      "sendToMobile": "მობილურზე გაგზავნა"
    },
    "sendRecipe": {
      "title": "საგადახდო ქვითრის გაგზავნა",
      "success": "წარმატებით გაიგზავნა",
      "error": "გაგზავნისას მოხდა შეცდომა",
      "successMessage": "საგადახდო ქვითარი წარმატებით გაიგზავნა",
      "errorMessage": "საგადახდო ქვითრის გაგზავნისას მოხდა შეცდომა"
    },
    "errors": {
      "paymentTitle": "გადახდის შეცდომა",
      "totalPriceMismatch": "გადახდის ჯამი უნდა ემთხვეოდეს საერთო თანხას",
      "deletedServiceTitle": "ვიზიტს ვერ დაასრულებთ",
      "deletedServiceContent": "ეს სერვისები წაშლილია: {{names}}. შეცვალეთ ან წაშალეთ ისინი ვიზიტში და შემდეგ დაასრულეთ."
    }
  },
  "ERX": {
    "myErx": "ჩემი რეცეპტები",
    "edit": "დანიშნულების გამოწერის რედაქტირება",
    "add": "დანიშნულების გამოწერა",
    "info": "ინფორმაცია",
    "mainInfo": "ძირითადი ინფორმაცია",
    "sendTitle": "დანიშნულების გაგზავნა",
    "download": "დანიშნულების ბეჭდვა",
    "send": "გაგზავნა",
    "print": "დაბეჭდვა",
    "syncDoctor": "ელექტრონული რეცეპტის გააქტიურება",
    "activate": "გააქტიურება",
    "syncDoctorSuccess": "ექიმი წარმატებით გააქტიურდა",
    "alreadySynced": "ექიმი უკვე გააქტიურებულია",
    "syncDoctorError": "არასწორი მომხმარებელი ან პაროლი",
    "userError": "მომხმარებლის ხარვეზი",
    "confirmSendPrescription": "ნამდვილად გსურთ გაგზავნა?",
    "notSelectedProductWarning": "გთხოვთ, მიუთითოთ მედიკამენტი",
    "disableRecipeTitle": "რეცეპტის გაუქმება",
    "disableReason": "გაუქმების მიზეზი",
    "chooseProduct": "აირჩიე მედიკამენტი",
    "chooseProductTitle": "მედიკამენტების ჩამონათვალიდან არჩევა",
    "patient": "პაციენტი",
    "doctor": "ექიმი",
    "title": "E-Rx",
    "status": "სტატუსი",
    "dosagePriv": "შესაძლებელია ჩანაცვლება",
    "isCopy": "ასლი",
    "isOnlyGeneric": "მხოლოდ გენერიკი",
    "isOnlyTradeable": "მხოლოდ სავაჭრო",
    "unid": "დანიშნულების #",
    "sendAt": "გაგზავნის თარიღი",
    "recipeNo": "რეცეპტის #",
    "user": "მომხმარებელი",
    "users": "მომხმარებლების",
    "productId": "მედიკამენტის კოდი",
    "medicamentId": "მედიკამენტის კოდი",
    "tradeName": "მედიკამენტი",
    "generic": "გენერიკი",
    "prodCount": "რაოდენობა",
    "periodInput": "პერიოდი",
    "procedureSmsText": "შეტყობინების ტექსტი",
    "periodType": "პერიოდულობა",
    "durationInput": "რეცეპტის მოქმედების ვადა",
    "ds": "დანიშნულება",
    "createdAt": "შექმნის თარიღი",
    "needToSend": "გასაგზავნი",
    "sent": "გაგზავნილი",
    "cancelled": "გაუქმებული",
    "firstName": "სახელი",
    "lastName": "გვარი",
    "identityNo": "პირადი ნომერი",
    "birthDate": "დაბადების თარიღი",
    "contactNo": "საკონტაქტო ნომერი",
    "email": "ელ. ფოსტა",
    "certificateNo": "სერთიფიკატის ნომერი",
    "product": {
      "productID": "პროდუქციის კოდი",
      "GeoNDC": "წამლის ნაციონალური კოდი",
      "AtcCode": "ATC კოდი",
      "IssuanceMode": "გაცემის რეჟიმი",
      "GeoTradeName": "სავაჭრო დასახელება(ქართ)",
      "EngTradeName": "სავაჭრო დასახელება(ინგ)",
      "ProductGeneric": "გენერიკი",
      "Api": "აქტიური ნივთიერება",
      "PharmaTherapyGroup": "ფარმაკოთერაპიული ჯგუფი",
      "Manufacturer": "მწარმოებელი",
      "ManufacturerCountryName": "მწარმოებელი ქვეყანა",
      "RegistrationTill": "რეგისტრაციის ვადა",
      "OtherDetailsGeo": "სხვა დეტალები(ქართ)",
      "OtherDetailsEng": "სხვა დეტალები(ინგ)",
      "DisableReason": "რეგისტრაციიდან მოხსნის მიზეზი"
    },
    "branch": "ფილიალი"
  },
  "SHARED": {
    "SEE_MORE": "მაჩვენე მეტი",
    "PREFIX": "პრეფიქსი",
    "LEGAL_ADDRESS": "იურიდიული მისამართი",
    "SMS_BRAND_NAME": "SMS ბრენდ სახელი",
    "EHR_USERNAME": "EHR მომხმარებელი",
    "EHR_PASSWORD": "EHR პაროლი",
    "PHYSICAL_ADDRESS": "ფაქტიური მისამართი",
    "DIRECTOR_FIRSTNAME": "წარმომადგენლის სახელი",
    "DIRECTOR_LASTNAME": "წარმომადგენლის გვარი",
    "MOBILE_NUMBER": "მობილურის ნომერი",
    "CONTACT_NUMBER": "საკონტაქტო ნომერი",
    "ORGANIZATION": "ორგანიზაცია",
    "BRAND_NAME": "ბრენდული სახელი",
    "USER_NAME": "მომხმარებელი",
    "ID_NUMBER_EMPTY": "პირადი ნომრის ველი ცარიელია",
    "CONTINUE": "გაგრძელება",
    "SEE_LESS": "მაჩვენე ნაკლები",
    "REALLY_WANT_DELETE": "ნამდვილად გსურთ წაშლა?",
    "YES": "დიახ",
    "NO": "არა",
    "ADD": "დამატება",
    "START": "დაწყება",
    "END": "დასრულება",
    "START_END": "დაწყება/დასრულება",
    "DOWNLOAD": "ჩამოტვირთვა",
    "DATE": "თარიღი",
    "DOCTOR": "მკურნალი ექიმი",
    "PROCEDURES": "პროცედურები",
    "DETAILED": "დეტალური",
    "IN_DETAILS": "დეტალურად",
    "DETAILS": "დეტალები",
    "NAME_SURNAME": "სახელი გვარი",
    "PERSONAL_NUMBER": "პირადი ნომერი",
    "TELEPHONE": "ტელეფონი",
    "MOBILE": "მობილური",
    "ADDRESS": "მისამართი",
    "IDENTIFICATION_CODE": "საიდენტიფიკაციო კოდი",
    "DATE_OF_BIRTH": "დაბადების თარიღი",
    "BIRTHDAY": "დაბადების დღე",
    "INSURANCE": "დაზღვევა",
    "NAME": "დასახელება",
    "PHONE_NUMBER": "ტელეფონის ნომერი",
    "MAIL": "ელ-ფოსტა",
    "FIRST_NAME": "სახელი",
    "LAST_NAME": "გვარი",
    "CREATED_AT": "შექმნის თარიღი",
    "COMMENT": "კომენტარი",
    "FILTER": "ფილტრი",
    "CHOOSE": "აირჩიე",
    "SEARCH": "საძიებო სიტყვა",
    "DATE_ERROR_MESSAGE": "დაწყების დრო არ უნდა აღემატებოდეს დასრულების დროს",
    "FUTURE_DATE_ERROR_MESSAGE": "მომავლის თარიღით ჯავშნის დასრულება არ არის შესაძლებელი",
    "DATE_ERROR_TITLE": "დროის ხარვეზი",
    "PLEASE_SUBMIT_THE_FILE": "გთხოვთ ატვირთოთ ფაილი",
    "SERVICE": "სერვისი",
    "WHO_APPOINTMENT": "ვინ ჩაწერა",
    "CREATED": "შექმნილი",
    "DATE_OF_CANCELLATION": "გაუქმების თარიღი",
    "CANCELED": "გააუქმა",
    "appointment": "ჩაწერები",
    "PROCEDURE": "პროცედურა",
    "CANCEL": "გაუქმებული",
    "APPOINTMENT": "ჩაწერილი",
    "COMPLETED": "დასრულებული",
    "PROCESSING": "მიმდინარე",
    "NOTIFICATION": "შეტყობინება",
    "NOTIFICATION_DEFAULT_TEXT": "ფუნქციონალი მალე დაემატება...",
    "BOOKING_DOCTOR": "ჯავშნის ექიმია",
    "BOOKING_DATE": "ჯავშნის თარიღი",
    "INFORMATION_NOT_SAVED": "შევსებული მონაცემები არ არის შენახული, გსურთ სხვა გვერდზე გადასვლა?",
    "find_booking": "მოძებნე ჯავშანი",
    "invoice": "ინვოისი",
    "year": "წელი",
    "month": "თვე",
    "week": "კვირა",
    "day": "დღე"
  },
  "common": {
    "unsavedChangesTitle": "შევსებული მონაცემები არ არის შენახული",
    "unsavedChanges": "გსურთ შენახვა?",
    "cancel": "გაუქმება",
    "confirm": "დადასტურება",
    "noData": "მონაცემები არ არის",
    "month": "თვე",
    "year": "წელი",
    "uploading": "იტვირთება...",
    "yes": "დიახ",
    "no": "არა",
    "days": "დღე",
    "actions": "მოქმედებები",
    "edit": "რედაქტირება",
    "error": "შეცდომა",
    "save": "შენახვა",
    "add": "დამატება",
    "submit": "გაგზავნა"
  },
  "REPORTS": {
    "VISITS": {
      "DATE_FROM": "დაწყების თარიღი",
      "DATE_TO": "დასრულების თარიღი",
      "STATUS": "სტატუსი",
      "SEARCH_NAME": "სახელით ძებნა",
      "SEARCH": "ძებნა",
      "RESET": "გასუფთავება",
      "EXPORT": "ექსპორტი",
      "ID": "ID",
      "VISIT_DATE": "ვიზიტის თარიღი",
      "FULL_NAME": "სრული სახელი",
      "TOTAL_PAID": "გადახდილი ჯამი",
      "STATUS_COL": "სტატუსი",
      "ACTIONS": "ქმედებები",
      "DOWNLOAD_INVOICE": "ინვოისის ჩამოტვირთვა",
      "STATUS_VALUES": {
        "PENDING": "მოლოდინში",
        "CONFIRMED": "დასტურებული",
        "IN_PROGRESS": "პროცესში",
        "COMPLETED": "დასრულებული",
        "CANCELED": "გაუქმებული",
        "DELETED": "წაშლილი"
      }
    }
  },
  "ehrTemplate": {
    "title": "ელექტრონული ჯანმრთელობის შაბლონები",
    "createButton": "შაბლონის შექმნა",
    "searchPlaceholder": "ძებნა სახელით ან აღწერით",
    "noData": "შაბლონები არ მოიძებნა",
    "active": "აქტიური",
    "inactive": "არააქტიური",
    "general": "ზოგადი",
    "custom": "ინდივიდუალური",
    "useTooltip": "შაბლონის გამოყენება",
    "viewTooltip": "შაბლონის ნახვა",
    "editTooltip": "შაბლონის რედაქტირება",
    "deleteTooltip": "შაბლონის წაშლა",
    "deleteConfirm": "დარწმუნებული ხართ, რომ გსურთ შაბლონის წაშლა?",
    "columns": {
      "name": "სახელი",
      "description": "აღწერა",
      "isActive": "სტატუსი",
      "isGeneral": "ტიპი",
      "createdAt": "შექმნის თარიღი",
      "updatedAt": "განახლების თარიღი"
    },
    "form": {
      "title": "ელექტრონული ჯანმრთელობის შაბლონი",
      "createTitle": "შაბლონის შექმნა",
      "editTitle": "შაბლონის რედაქტირება",
      "viewTitle": "შაბლონის ნახვა",
      "name": "შაბლონის სახელი",
      "namePlaceholder": "შეიყვანეთ შაბლონის სახელი",
      "nameError": "შაბლონის სახელი სავალდებულოა",
      "description": "აღწერა",
      "descriptionPlaceholder": "შეიყვანეთ შაბლონის აღწერა",
      "descriptionError": "აღწერა ძალიან გრძელია",
      "content": "შაბლონის შინაარსი",
      "contentPlaceholder": "შეიყვანეთ შაბლონის შინაარსი JSON ფორმატში",
      "contentError": "არასწორი შინაარსის ფორმატი",
      "isActive": "აქტიური სტატუსი",
      "isGeneral": "ზოგადი შაბლონი",
      "cancel": "გაუქმება",
      "create": "შექმნა",
      "update": "განახლება",
      "close": "დახურვა"
    }
  },
  "room": {
    "title": "ოთახების მართვა",
    "createButton": "ოთახის შექმნა",
    "dragToReorder": "გადაათრიეთ სტრიქონები თანმიმდევრობის შესაცვლელად",
    "active": "აქტიური",
    "inactive": "არააქტიური",
    "visible": "ხილული",
    "hidden": "დამალული",
    "multiEmployee": "მრავალი თანამშრომელი",
    "singleEmployee": "ერთი თანამშრომელი",
    "unlimited": "შეუზღუდავი",
    "viewTooltip": "ოთახის დეტალების ნახვა",
    "editTooltip": "ოთახის რედაქტირება",
    "deleteTooltip": "ოთახის წაშლა",
    "deleteConfirm": "დარწმუნებული ხართ, რომ გსურთ ოთახის წაშლა?",
    "columns": {
      "name": "სახელი",
      "description": "აღწერა",
      "isActive": "აქტიური",
      "visibleInCalendar": "კალენდარში ხილვადობა",
      "canWorkMultipleEmployees": "რამდენიმე თანამშრომელი",
      "maxParallelBookings": "პარალელური ჯავშნები",
      "order": "თანმიმდევრობა",
      "createdAt": "შექმნის თარიღი",
      "actions": "მოქმედებები"
    },
    "form": {
      "name": "ოთახის სახელი",
      "namePlaceholder": "შეიყვანეთ ოთახის სახელი",
      "nameError": "გთხოვთ შეიყვანოთ ოთახის სახელი",
      "description": "აღწერა",
      "descriptionPlaceholder": "შეიყვანეთ ოთახის აღწერა",
      "order": "ჩვენების თანმიმდევრობა",
      "orderPlaceholder": "შეიყვანეთ ჩვენების თანმიმდევრობა",
      "orderError": "თანმიმდევრობა უნდა იყოს 0 ან მეტი",
      "isActive": "აქტიური",
      "visibleInCalendar": "კალენდარში ხილული",
      "canWorkMultipleEmployees": "რამდენიმე თანამშრომლის დაშვება",
      "maxParallelBookings": "მაქს. პარალელური ჯავშნები",
      "maxParallelBookingsHint": "0 = შეუზღუდავი, 1 = ერთი ჯავშანი, N = მაქსიმალური რაოდენობა"
    },
    "view": {
      "tabs": {
        "info": "ინფო და სტატისტიკა",
        "services": "ოთახის სერვისები",
        "scheduler": "განრიგი"
      },
      "info": {
        "details": "ოთახის დეტალები",
        "statistics": "სტატისტიკა",
        "totalRevenue": "ჯამური შემოსავალი",
        "totalBookings": "სულ ჯავშნები",
        "completedVisits": "დასრულებული ვიზიტები",
        "pendingVisits": "დასასრულებელი ვიზიტები",
        "assignedServices": "მინიჭებული სერვისები",
        "scheduledDays": "დაგეგმილი დღეები",
        "displayOrder": "ჩვენების თანმიმდევრობა"
      },
      "services": {
        "title": "მინიჭებული სერვისები",
        "serviceName": "სერვისის სახელი",
        "serviceCategory": "კატეგორია",
        "assignedDate": "მინიჭების თარიღი",
        "actions": "მოქმედებები",
        "addButton": "სერვისის დამატება",
        "removeTooltip": "სერვისის წაშლა",
        "removeConfirm": "დარწმუნებული ხართ, რომ გსურთ სერვისის წაშლა ოთახიდან?",
        "noServices": "ოთახს არ აქვს მინიჭებული სერვისები",
        "searchPlaceholder": "სერვისების ძიება...",
        "selectCategories": "აირჩიეთ სერვისის კატეგორიები ფილტრაციისთვის",
        "servicesSelected": "სერვისი არჩეულია"
      },
      "scheduler": {
        "title": "ოთახის განრიგი",
        "date": "თარიღი",
        "shiftStart": "ცვლის დაწყება",
        "shiftEnd": "ცვლის დასრულება",
        "status": "სტატუსი",
        "breaks": "შესვენებები",
        "actions": "მოქმედებები",
        "addButton": "განრიგის დამატება",
        "deleteTooltip": "განრიგის წაშლა",
        "noSchedules": "განრიგი არ მოიძებნა",
        "startDate": "დაწყების თარიღი",
        "endDate": "დასრულების თარიღი",
        "status_AVAILABLE": "ხელმისაწვდომი",
        "status_UNAVAILABLE": "დაკავებული",
        "status_MAINTENANCE": "მოვლა-შენახვა",
        "planButton": "განრიგის დაგეგმვა",
        "planTooltip": "აირჩიეთ თარიღები კალენდარზე განრიგის დასაგეგმად",
        "selectDates": "გთხოვთ აირჩიოთ თარიღები კალენდარზე"
      }
    }
  },
  "bookingSources": {
    "title": "ჯავშნის წყაროები",
    "addButton": "წყაროს დამატება",
    "createTitle": "ახალი წყარო",
    "editTitle": "წყაროს რედაქტირება",
    "confirmDelete": "დარწმუნებული ხართ, რომ გსურთ წყაროს წაშლა?",
    "table": {
      "icon": "ხატულა",
      "name": "სახელი",
      "status": "სტატუსი",
      "actions": "მოქმედებები"
    },
    "form": {
      "name": "წყაროს სახელი",
      "namePlaceholder": "შეიყვანეთ წყაროს სახელი",
      "nameError": "გთხოვთ შეიყვანოთ წყაროს სახელი",
      "icon": "ხატულა",
      "iconPlaceholder": "შეიყვანეთ ხატულა (ემოჯი)",
      "iconHelp": "შეიყვანეთ ემოჯი ან ხატულა"
    },
    "messages": {
      "createSuccess": "წყარო წარმატებით შეიქმნა",
      "updateSuccess": "წყარო წარმატებით განახლდა",
      "deleteSuccess": "წყარო წარმატებით წაიშალა",
      "createError": "წყაროს შექმნა ვერ მოხერხდა",
      "editError": "წყაროს განახლება ვერ მოხერხდა",
      "deleteError": "წყაროს წაშლა ვერ მოხერხდა",
      "toggleError": "სტატუსის შეცვლა ვერ მოხერხდა",
      "activateSuccess": "წყარო გააქტიურდა",
      "deactivateSuccess": "წყარო დეაქტივირდა"
    },
    "actions": {
      "edit": "რედაქტირება",
      "delete": "წაშლა"
    },
    "status": {
      "active": "აქტიური",
      "inactive": "არააქტიური"
    }
  },
  "service": {
    "price": "ფასი",
    "duration": "ხანგრძლივობა"
  },
  "offers": {
    "title": "შეთავაზებები",
    "types": {
      "fullPayment": "სრული გადახდა",
      "partialPayment": "ნაწილობრივი გადახდა"
    },
    "categories": {
      "offer": "შეთავაზება",
      "package": "პაკეტი"
    },
    "activationMethods": {
      "fixedPeriod": "ფიქსირებული პერიოდი",
      "onPurchase": "შეძენისთანავე",
      "manual": "ხელით აქტივაცია"
    },
    "status": {
      "active": "აქტიური",
      "running": "მიმდინარე",
      "completed": "დასრულებული",
      "cancelled": "გაუქმებული"
    },
    "filters": {
      "search": "შეთავაზების ძებნა...",
      "status": "სტატუსი",
      "branch": "ფილიალი",
      "startDate": "დაწყების თარიღი",
      "endDate": "დასრულების თარიღი",
      "category": "კატეგორია",
      "internalSale": "შიდა გაყიდვა"
    },
    "columns": {
      "image": "სურათი",
      "name": "დასახელება",
      "category": "კატეგორია",
      "price": "ფასი",
      "quantity": "რაოდენობა",
      "dates": "თარიღები",
      "status": "სტატუსი",
      "platforms": "პლატფორმები",
      "actions": "მოქმედებები",
      "service": "სერვისი",
      "onlineService": "ონლაინ სერვისი",
      "employees": "თანამშრომლები",
      "qty": "რაოდ.",
      "originalPrice": "საწყისი ფასი",
      "discountedPrice": "ფასდაკლებული ფასი"
    },
    "labels": {
      "sale": "გაყიდვა",
      "valid": "მოქმედი",
      "cover": "გარეკანი",
      "totalOriginal": "ჯამი საწყისი",
      "totalDiscounted": "ჯამი ფასდაკლებული",
      "discount": "ფასდაკლება",
      "internalSale": "შიდა",
      "serviceNumber": "სერვისი"
    },
    "buttons": {
      "create": "შეთავაზების შექმნა",
      "viewStats": "შესყიდვების სტატისტიკა",
      "viewAnalytics": "ანალიტიკა",
      "actions": "მოქმედებები",
      "duplicate": "დუბლირება",
      "publishBookingHub": "BookingHub-ზე გამოქვეყნება",
      "unpublishBookingHub": "BookingHub-დან მოხსნა",
      "deactivate": "შეთავაზების დეაქტივაცია",
      "delete": "წაშლა",
      "addService": "სერვისის დამატება",
      "uploadImage": "სურათის ატვირთვა",
      "setCover": "გარეკანად დაყენება"
    },
    "tabs": {
      "basicInfo": "ძირითადი ინფო",
      "translations": "თარგმანები",
      "services": "სერვისები",
      "onlineServices": "ონლაინ სერვისები",
      "dates": "თარიღები",
      "branches": "ფილიალები",
      "branch": "ფილიალი",
      "images": "სურათები",
      "settings": "პარამეტრები"
    },
    "form": {
      "createTitle": "შეთავაზების შექმნა",
      "editTitle": "შეთავაზების რედაქტირება",
      "category": "კატეგორია",
      "frontName": "საჯარო დასახელება",
      "frontNamePlaceholder": "კლიენტებისთვის საჩვენებელი სახელი",
      "frontNameHint": "ეს სახელი გამოჩნდება კლიენტებს ჯავშნის პლატფორმებზე",
      "name": "შიდა დასახელება",
      "namePlaceholder": "შიდა საცნობარო სახელი",
      "description": "აღწერა",
      "descriptionPlaceholder": "აღწერეთ რას მოიცავს შეთავაზება...",
      "totalQuantity": "ჯამური რაოდენობა",
      "pricePlaceholder": "მიუთითეთ რაოდენობა",
      "offerType": "შეთავაზების ტიპი",
      "services": "შეტანილი სერვისები",
      "selectService": "აირჩიეთ სერვისი",
      "selectOnlineService": "აირჩიეთ ონლაინ სერვისი",
      "selectEmployees": "აირჩიეთ თანამშრომლები",
      "salePeriod": "გაყიდვის პერიოდი",
      "salePeriodHint": "პერიოდი, რომლის განმავლობაში შესაძლებელია შეთავაზების შეძენა",
      "activationDate": "გაყიდვის დასაწყისი",
      "endDate": "გაყიდვის დასასრული",
      "validityPeriod": "მოქმედების ვადა",
      "validityPeriodHint": "პერიოდი, რომლის განმავლობაში შესაძლებელია შეთავაზების გამოყენება",
      "validityStartDate": "მოქმედია დან",
      "expiryDate": "მოქმედია მდე",
      "branches": "ხელმისაწვდომი ფილიალები",
      "selectBranches": "აირჩიეთ ფილიალები",
      "branchesHint": "აირჩიეთ ფილიალები, სადაც შესაძლებელია შეთავაზების გამოყენება",
      "branch": "ფილიალი",
      "selectBranch": "აირჩიეთ ფილიალი",
      "branchHint": "ჯერ აირჩიეთ ფილიალი, შემდეგ შეძლებთ ონლაინ სერვისებისა და თანამშრომლების არჩევას",
      "imagesHint": "ატვირთეთ მინიმუმ 5 სურათი შეთავაზებისთვის",
      "minimum": "მინიმუმ",
      "notifyMerchant": "მერჩანტის შეტყობინება გაყიდვისას",
      "notifyMerchantHint": "შეტყობინების გაგზავნა შეთავაზების გაყიდვისას",
      "bookingHubCategory": "BookingHub კატეგორიის ID",
      "bookingHubCategoryPlaceholder": "შეიყვანეთ კატეგორიის ID",
      "bookingHubCategoryHint": "კატეგორიის ID BookingHub პლატფორმისთვის",
      "packageSettings": "პაკეტის პარამეტრები",
      "activationMethod": "აქტივაციის მეთოდი",
      "activationMethodHint": "როგორ ხდება პაკეტის აქტივაცია შეძენის შემდეგ",
      "activeDays": "აქტიური დღეები",
      "activeDaysPlaceholder": "დღეების რაოდენობა",
      "activeDaysHint": "რამდენი დღე მოქმედებს პაკეტი აქტივაციის შემდეგ",
      "allowInternalSale": "შიდა გაყიდვის დაშვება",
      "allowInternalSaleHint": "ფილიალში ამ პაკეტის შიდა გაყიდვის გააქტიურება"
    },
    "messages": {
      "created": "შეთავაზება წარმატებით შეიქმნა",
      "updated": "შეთავაზება წარმატებით განახლდა",
      "deleted": "შეთავაზება წარმატებით წაიშალა",
      "duplicated": "შეთავაზება წარმატებით დუბლირდა",
      "deactivated": "შეთავაზება წარმატებით დეაქტივირდა",
      "published": "შეთავაზება გამოქვეყნდა BookingHub-ზე",
      "unpublished": "შეთავაზება მოიხსნა BookingHub-დან",
      "loadError": "შეთავაზების ჩატვირთვა ვერ მოხერხდა",
      "saveError": "შეთავაზების შენახვა ვერ მოხერხდა",
      "deleteError": "შეთავაზების წაშლა ვერ მოხერხდა",
      "duplicateError": "შეთავაზების დუბლირება ვერ მოხერხდა",
      "deactivateError": "შეთავაზების დეაქტივაცია ვერ მოხერხდა",
      "publishError": "შეთავაზების გამოქვეყნება ვერ მოხერხდა",
      "unpublishError": "შეთავაზების მოხსნა ვერ მოხერხდა",
      "uploadError": "სურათის ატვირთვა ვერ მოხერხდა",
      "noServices": "სერვისები ჯერ არ დამატებულა. დააჭირეთ 'სერვისის დამატება' შეთავაზებაში სერვისების ჩასამატებლად."
    },
    "validation": {
      "minServices": "გთხოვთ დაამატოთ მინიმუმ ერთი სერვისი",
      "minImages": "გთხოვთ ატვირთოთ მინიმუმ 5 სურათი"
    },
    "confirm": {
      "deactivate": "დარწმუნებული ხართ, რომ გსურთ შეთავაზების დეაქტივაცია?",
      "delete": "დარწმუნებული ხართ, რომ გსურთ შეთავაზების წაშლა?"
    }
  },
  "offerStats": {
    "title": "შეთავაზებების შესყიდვები",
    "status": {
      "active": "აქტიური",
      "used": "გამოყენებული",
      "cancelled": "გაუქმებული"
    },
    "filters": {
      "search": "ძიება სახელით, ტელეფონით, ID-ით...",
      "status": "სტატუსი",
      "source": "წყარო",
      "branch": "ფილიალი",
      "offer": "შეთავაზება",
      "startDate": "დაწყების თარიღი",
      "endDate": "დასრულების თარიღი"
    },
    "columns": {
      "externalId": "გარე ID",
      "offer": "შეთავაზება",
      "user": "მომხმარებელი",
      "price": "ფასი",
      "progress": "გამოყენება",
      "source": "წყარო",
      "status": "სტატუსი",
      "purchaseDate": "შეძენის თარიღი",
      "actions": "მოქმედებები"
    },
    "labels": {
      "validUntil": "ვალიდურია",
      "remaining": "დარჩენილი",
      "usedAt": "გამოყენებული",
      "cancelledAt": "გაუქმებული"
    },
    "buttons": {
      "cancel": "შეძენის გაუქმება"
    },
    "paymentTypes": {
      "cash": "ნაღდი",
      "card": "ბარათი",
      "transfer": "გადარიცხვა"
    },
    "cancelModal": {
      "title": "შეძენის გაუქმება",
      "operationType": "ოპერაციის ტიპი",
      "withoutRefund": "გაუქმება თანხის დაბრუნების გარეშე",
      "withRefund": "გაუქმება თანხის დაბრუნებით",
      "refundAmount": "დასაბრუნებელი თანხა",
      "paymentType": "გადახდის ტიპი",
      "confirm": "გაუქმების დადასტურება"
    },
    "messages": {
      "cancelled": "შეძენა წარმატებით გაუქმდა",
      "cancelError": "შეძენის გაუქმება ვერ მოხერხდა"
    }
  },
  "offerAnalytics": {
    "title": "შეთავაზებების ანალიტიკა",
    "filters": {
      "branch": "ფილიალი",
      "startDate": "დაწყების თარიღი",
      "endDate": "დასრულების თარიღი"
    },
    "summary": {
      "totalRevenue": "ჯამური შემოსავალი",
      "totalSold": "გაყიდული რაოდენობა",
      "commission": "საკომისიო",
      "totalPurchases": "ჯამური შეძენები"
    },
    "charts": {
      "dailyRevenue": "ყოველდღიური შემოსავალი",
      "revenueByOffer": "შემოსავალი შეთავაზებების მიხედვით",
      "categoryRevenue": "შემოსავალი კატეგორიების მიხედვით",
      "statusDistribution": "სტატუსების განაწილება",
      "sourceDistribution": "წყაროების განაწილება",
      "revenueTable": "შემოსავლის დეტალები"
    },
    "columns": {
      "offer": "შეთავაზება",
      "quantity": "რაოდენობა",
      "revenue": "შემოსავალი",
      "status": "სტატუსი",
      "count": "რაოდენობა",
      "percentage": "პროცენტი",
      "source": "წყარო",
      "category": "კატეგორია"
    },
    "labels": {
      "total": "ჯამი",
      "offer": "შეთავაზება",
      "revenue": "შემოსავალი",
      "category": "კატეგორია",
      "commission": "საკომისიო"
    },
    "status": {
      "active": "აქტიური",
      "used": "გამოყენებული",
      "cancelled": "გაუქმებული"
    },
    "sources": {
      "onlineBookings": "ონლაინ ჯავშნები",
      "bookinghub": "BookingHub",
      "swoop": "Swoop"
    },
    "empty": {
      "noData": "მონაცემები არ არის არჩეული პერიოდისთვის"
    }
  },
  "offerView": {
    "stats": {
      "price": "ფასი",
      "sold": "გაყიდული",
      "remaining": "დარჩენილი",
      "services": "სერვისები"
    },
    "sections": {
      "images": "სურათები",
      "services": "შეტანილი სერვისები",
      "onlineServices": "ონლაინ სერვისები",
      "translations": "თარგმანები",
      "details": "დეტალები",
      "dates": "თარიღები",
      "platforms": "პლატფორმები",
      "branches": "ხელმისაწვდომი ფილიალები",
      "purchaseStats": "შეძენების სტატისტიკა",
      "packageSettings": "პაკეტის პარამეტრები"
    },
    "columns": {
      "service": "სერვისი",
      "quantity": "რაოდ.",
      "originalPrice": "საწყისი ფასი",
      "discountedPrice": "ფასდაკლებული ფასი",
      "employees": "თანამშრომლები"
    },
    "fields": {
      "id": "ID",
      "category": "კატეგორია",
      "offerType": "შეთავაზების ტიპი",
      "status": "სტატუსი",
      "notifyMerchant": "გაყიდვაზე შეტყობინება",
      "bookingHubCategory": "BookingHub კატეგორია",
      "salePeriod": "გაყიდვის პერიოდი",
      "validityPeriod": "მოქმედების პერიოდი",
      "createdAt": "შექმნილია",
      "frontName": "საჯარო დასახელება",
      "name": "შიდა დასახელება",
      "description": "აღწერა",
      "activationMethod": "აქტივაციის მეთოდი",
      "activeDays": "აქტიური დღეები",
      "allowInternalSale": "შიდა გაყიდვა"
    },
    "languages": {
      "ka": "ქართული",
      "en": "ინგლისური",
      "ru": "რუსული"
    },
    "labels": {
      "total": "ჯამი"
    },
    "published": "გამოქვეყნებული",
    "notPublished": "არ არის გამოქვეყნებული",
    "empty": {
      "noImages": "სურათები არ არის ატვირთული",
      "noServices": "სერვისები არ არის დამატებული",
      "noTranslation": "თარგმანი არ არის ხელმისაწვდომი",
      "notFound": "შეთავაზება ვერ მოიძებნა"
    },
    "purchaseStats": {
      "totalRevenue": "მთლიანი შემოსავალი",
      "totalPurchases": "შეძენები",
      "commission": "საკომისიო",
      "commissionPercent": "საკომისიო %",
      "statusDistribution": "სტატუსების განაწილება",
      "sourceDistribution": "წყაროების განაწილება",
      "status": "სტატუსი",
      "source": "წყარო",
      "count": "რაოდენობა",
      "revenue": "შემოსავალი",
      "noData": "შეძენების მონაცემები არ არის",
      "statuses": {
        "active": "აქტიური",
        "used": "გამოყენებული",
        "cancelled": "გაუქმებული"
      }
    }
  },
  "validation": {
    "required": "ველის შევსება სავალდებულოა"
  },
  "dashboard": {
    "title": "დაშბორდი",
    "totalRevenue": "მთლიანი შემოსავალი",
    "todayRevenue": "დღევანდელი შემოსავალი",
    "services": "სერვისები",
    "products": "პროდუქცია",
    "averageTicket": "საშუალო ჩეკი",
    "bookings": "ჯავშნები",
    "totalBookings": "სულ ჯავშნები",
    "completedBookings": "დასრულებული",
    "canceledBookings": "გაუქმებული",
    "noShowBookings": "არ გამოცხადდა",
    "pendingBookings": "მოლოდინში",
    "inProgressBookings": "მიმდინარე",
    "occupancy": "დატვირთულობა",
    "employeeOccupancy": "თანამშრომლები",
    "roomOccupancy": "ოთახები",
    "combinedOccupancy": "საერთო",
    "today": "დღეს",
    "week": "კვირა",
    "month": "თვე",
    "availableSlots": "თავისუფალი დროები",
    "todaySlots": "დღევანდელი",
    "tomorrowSlots": "ხვალინდელი",
    "noAvailableSlots": "თავისუფალი დრო არ არის",
    "minutes": "წუთი",
    "clientStats": "კლიენტების სტატისტიკა",
    "topVisitors": "ტოპ ვიზიტორები",
    "topSpenders": "ტოპ გადამხდელები",
    "newClients": "ახალი კლიენტები",
    "returningClients": "დაბრუნებული კლიენტები",
    "clientName": "კლიენტი",
    "visitCount": "ვიზიტები",
    "totalSpent": "დახარჯული",
    "revenue": "შემოსავალი",
    "count": "რაოდენობა"
  },
  "ehr": {
    "successfullySaved": "წარმატებით შეინახა",
    "saveFailed": "შენახვა ვერ მოხერხდა",
    "errorSending": "ეჰრ-ზე გაგზავნა ვერ მოხერხდა",
    "successfullySent": "წარმატებით გაიგზავნა ეჰრ-ზე",
    "ambulatoryCard": {
      "title": "ამბულატორიული მომართვის ბარათი",
      "subtitle": "მცირე ბარათი | ამბულატორიული ბარათი",
      "copyEpisodeData": "სხვა ეპიზოდის მონაცემების კოპირება",
      "copyEpisodeModal": {
        "title": "სხვა ეპიზოდის მონაცემების კოპირება",
        "selectEpisode": "აირჩიეთ ეპიზოდი",
        "chooseSections": "აირჩიეთ კოპირებადი მონაცემები",
        "noEpisodes": "ამ პაციენტს სხვა ეპიზოდი არ აქვს",
        "copyButton": "კოპირება",
        "backButton": "უკან",
        "cancelButton": "გაუქმება",
        "copiedToast": "მონაცემები დაკოპირებულია. გადახედეთ და დააჭირეთ შენახვას.",
        "loadError": "ეპიზოდის ჩატვირთვა ვერ მოხერხდა",
        "columns": {
          "date": "თარიღი",
          "ehrNo": "ცნობის ნომერი",
          "doctor": "ექიმი"
        },
        "sections": {
          "diagnoses": "დიაგნოზები",
          "narrative": "კლინიკური აღწერა",
          "recommendations": "რეკომენდაციები",
          "prescriptions": "დანიშნულებები (eRx)",
          "insurance": "სადაზღვევო / სამუშაო"
        }
      },
      "printForm100": "ფორმა 100-ის ბეჭდვა",
      "printPrescription": "დანიშნულების ბეჭდვა",
      "printInformedConsent": "ინფორმირებული თანხმობის ბეჭდვა",
      "smsVerification": "სმს ვერიფიკაცია",
      "uploadDocument": "დოკუმენტის ატვირთვა",
      "actions": "მოქმედებები",
      "comingSoon": "მალე დაემატება",
      "noPrescriptions": "დანიშნულებები არ არის შევსებული",
      "noInformedConsent": "ინფორმირებული თანხმობა არ არის შევსებული",
      "savingInProgress": "მიმდინარეობს ანკეტის შენახვა",
      "validationError": "გთხოვთ შეავსოთ სავალდებულო ველები",
      "characters": "სიმბოლო",
      "personalNumberLength": "პირადი ნომერი უნდა იყოს 11 სიმბოლო",
      "requiredField": "სავალდებულო ველი",
      "sendToEhr": "გადაგზავნა",
      "save": "შენახვა",
      "whereSent": "სად იგზავნება ცნობა",
      "form100Number": "ფორმა 100-ის ნომერი",
      "lastName": "გვარი",
      "firstName": "სახელი",
      "fatherName": "მამის სახელი",
      "episodeNumber": "ეპიზოდის ნომერი",
      "gender": "სქესი",
      "birthDateAge": "დაბადების თარიღი/ასაკი",
      "maritalStatus": "ოჯახური მდგომარეობა",
      "disabilityStatus": "შესაძლებლობის შეზღუდვის სტატუსი",
      "personalNumber": "პირადი ნომერი",
      "country": "ქვეყანა",
      "selectCountry": "აირჩიეთ ქვეყანა",
      "city": "ქალაქი",
      "selectCity": "აირჩიეთ ქალაქი",
      "placeOfResidence": "საცხოვრებელი ადგილი",
      "cityDistrict": "ქალაქი/რაიონი",
      "address": "მისამართი",
      "phone": "ტელეფონი",
      "employmentStatus": "დასაქმების სტატუსი",
      "education": "განათლება",
      "workplaceProfession": "სამუშაო ადგილი, პროფესია, თანამდებობა",
      "insuranceCompany": "სადაზღვევო კომპანია",
      "fundingSources": "დაფინანსების წყაროები",
      "caseNumber": "შემთხვევის ნომერი/ ქისის ნომერი",
      "patientAdmissionDate": "პაციენტის შემოსვლის თარიღი და დრო",
      "ambulatoryReferral": "ა) ამბულატორიაში მიმართვის",
      "episodeEndDate": "ეპიზოდის დასრულების თარიღი და დრო",
      "bloodGroupRh": "სისხლის ჯგუფი/ Rh-ფაქტორი",
      "ehrConsent": "თანხმობას ვაცხადებ EHR პორტალზე მონაცემების დაფარვა/გაზიარების შესახებ",
      "visibilityStatus": "დაფარვა/გაზიარების სტატუსი",
      "section9": "9. დასკვნა ჯანმრთელობის მდგომარეობის შესახებ ან სრული დიაგნოზი (ძირითადი დაავადება, თანმხლები დაავადებები, გართულებები)",
      "diagnosisFirstTime": "დიაგნოზი დასმულია სიცოცხლეში პირველად",
      "pleaseSelect": "გთხოვთ აირჩიოთ",
      "primaryDiseaseIcd": "ძირითადი დაავადება/ICD/",
      "selectIcdCode": "აირჩიეთ ICD კოდი",
      "diagnosisDate": "დიაგნოზის თარიღი",
      "character": "ხასიათი",
      "doctorClarification": "ექიმის მიერ დაზუსტება",
      "complicationsIcd": "ძირითადი დაავადების გართულება (გართულებები)/ICD/",
      "icdCode": "ICD კოდი",
      "clarification": "დაზუსტება",
      "accompanyingDiseaseIcd": "თანმხლები დაავადება /ICD/",
      "section10_11": "10. გადატანილი დაავადებები",
      "section10_11_sub": "11. მოკლე ანამნეზი",
      "complaintsIcpc": "ჩივილები/ICPC/",
      "patientComplainsIcpc": "პაციენტი უჩივის /ICPC/",
      "complaintName": "ჩივილის დასახელება",
      "year": "წელი",
      "complaints": "ჩივილები",
      "anamnesis": "ანამნეზი",
      "pastDiseases": "გადატანილი დაავადებები",
      "pregnancyCount": "ორსულობის რაოდენობები",
      "deliveryCount": "მშობიარობის რაოდენობები",
      "fillData": "შეავსეთ მონაცემები",
      "addService": "ჩატარებული დიაგნოსტიკური გამოკვლევები და კონსულტაციების დამატება",
      "section12": "12. ჩატარებული დიაგნოსტიკური გამოკვლევები და კონსულტაციები",
      "comment": "კომენტარი",
      "unspecified": "განუსაზღვრელი",
      "clinicalDiagnosticStudies": "კლინიკურ დიაგნოსტიკური კვლევები",
      "labStudies": "ლაბორატორიული გამოკვლევები",
      "surgeries": "ქირურგიული ჩარევები",
      "consultations": "კონსულტაციები",
      "otherActivity": "თანმხლები აქტივობა",
      "transfusion": "ტრანსფუზია",
      "anesthesia": "ანესთეზია",
      "operationProtocol": "ოპერაციის ოქმი",
      "prescriptionTreatment": "დანიშნული მკურნალობა",
      "bloodComponent": "სისხლის კომპონენტი",
      "protocolNo": "ოქმის ნომერი",
      "protocolText": "ოქმის ტექსტი",
      "drug": "მედიკამენტი",
      "dosage": "დოზირება",
      "laboratory": "ლაბორატორია",
      "text": "ტექსტი",
      "consultationsTable": "კონსულტაციები",
      "specialty": "სპეციალობა",
      "doctor": "ექიმი",
      "deleteConfirm": "წაშლა?",
      "section13": "13. ავადმყოფობის მიმდინარეობა",
      "episodeType": "ეპიზოდის ტიპი",
      "episodeResult": "ეპიზოდის შედეგი",
      "section14": "14. ჩატარებული მკურნალობა",
      "conditionAtReferral": "15. მდგომარეობა გაგზავნისას",
      "selectCondition": "აირჩიეთ მდგომარეობა",
      "conditionAtDischarge": "16. მდგომარეობა გაწერისას",
      "section17": "17. მიეცა რეკომენდაცია/დანიშნულება",
      "instrumentalStudiesNcsp": "ინსტრუმენტული კვლევები /NSCP/",
      "ncspCode": "NSCP კოდი",
      "date": "თარიღი",
      "labStudiesLab": "ლაბორატორიული გამოკვლევები /LAB/",
      "labCode": "ლაბორატორიული კოდი",
      "consultationsAmbulatory": "კონსულტაციები ამბულატორიაში",
      "specialtyField": "სპეციალობა",
      "deadline": "ვადა",
      "otherRecommendations": "სხვა რეკომენდაციები",
      "adviceInstruction": "რჩევა/დარიგება",
      "prescription": "დანიშნულება",
      "uploadToPortal": "პორტალზე ატვირთვა",
      "sent": "გაგზავნილია",
      "notSent": "გაუგზავნელია",
      "error": "შეცდომა",
      "sending": "იგზავნება...",
      "sendToPortal": "გაგზავნა",
      "prescriptionSent": "დანიშნულება გაიგზავნა",
      "prescriptionCancelled": "დანიშნულება გაუქმდა",
      "cancelFailed": "გაუქმება ვერ მოხერხდა",
      "savePrescriptionFirst": "ჯერ შეინახეთ დანიშნულება",
      "addPrescriptionTooltip": "დანიშნულების დამატება",
      "searchMedicineTooltip": "მედიკამენტის ძებნა",
      "sendToPortalTooltip": "დანიშნულების გაგზავნა ე-რეცეპტის პორტალზე",
      "deletePrescriptionTooltip": "დანიშნულების წაშლა",
      "medicine": "მედიკამენტი",
      "search": "ძებნა",
      "tradeForm": "სავაჭრო ფორმა",
      "quantity": "რაოდენობა",
      "usageRule": "მიღების წესი",
      "prescriptionValidity": "ვადა",
      "prescriptionRecommendation": "დანიშნულება/რეკომენდაცია",
      "attendingDoctor": "მკურნალი ექიმი (სახელი)",
      "selectDoctor": "აირჩიეთ ექიმი",
      "create": "შექმნა",
      "maritalStatusOptions": {
        "married": "დაქორწინებული",
        "cohabiting": "თანაცხოვრებაში მყოფი",
        "single": "დასაოჯახებელი",
        "divorced": "განქორწინებული",
        "widowed": "ქვრივი"
      },
      "disabilityOptions": {
        "none": "არ აქვს გამოხატული",
        "severe": "მკვეთრად გამოხატული",
        "significant": "მნიშვნელოვნად გამოხატული",
        "moderate": "ზომიერად გამოხატული"
      },
      "countryOptions": {
        "georgia": "საქართველო",
        "other": "სხვა"
      },
      "residenceOptions": {
        "city": "ქალაქი/რაიონი",
        "village": "სოფელი"
      },
      "cityOptions": {
        "tbilisi": "თბილისი",
        "kutaisi": "ქუთაისი",
        "batumi": "ბათუმი"
      },
      "employmentOptions": {
        "employed": "დასაქმებული",
        "unemployed": "უმუშევარი",
        "student": "სტუდენტი/მოსწავლე",
        "retired": "პენსიონერი",
        "disabled": "შშმ პირი",
        "minor": "არასრულწლოვანი",
        "military": "ჯარისკაცი",
        "other": "სხვა"
      },
      "educationOptions": {
        "unknown": "უცნობია",
        "primary": "დაწყებითი",
        "secondary": "საშუალო",
        "higher": "უმაღლესი",
        "vocational": "პროფესიული"
      },
      "fundingOptions": {
        "self": "თვითდაფინანსება",
        "universal": "საყოველთაო ჯანდაცვა",
        "private": "კერძო დაზღვევა"
      },
      "yesNoOptions": {
        "yes": "კი",
        "no": "არა",
        "unknown": "უცნობია"
      },
      "isGenericOptions": {
        "onlyGeneric": "მხოლოდ გენერიკი",
        "genericAndTrade": "გენერიკი და სავაჭრო",
        "onlyTrade": "მხოლოდ სავაჭრო"
      }
    },
    "patients": {
      "status": "სტატუსი",
      "bookingDate": "ჩაწერის თარიღი",
      "user": "მომხმარებელი",
      "mobile": "მობილური",
      "employee": "თანამშრომელი",
      "startTime": "დაწყ. დრო",
      "endTime": "დასრ. დრო",
      "service": "სერვისი",
      "room": "ოთახი",
      "personalNumber": "პირადი ნომერი",
      "view": "ნახვა",
      "ambulatoryCard": "ამბულატორიული ბარათი",
      "smallAmbulatoryCard": "მცირე ამბულატორიული ბარათი"
    },
    "confirmSend": "დარწმუნებული ხართ, რომ გსურთ გადაგზავნა?"
  },
  "visitComments": {
    "tabTitle": "კომენტარები",
    "noComments": "კომენტარები არ მოიძებნა",
    "placeholder": "დაწერეთ კომენტარი...",
    "selectBooking": "მიბმა ჯავშანზე",
    "selectService": "მიბმა სერვისზე",
    "fromDescription": "აღწერიდან",
    "deleteConfirm": "კომენტარის წაშლა?",
    "commentsLabel": "კომენტარი",
    "pinned": "დაპინული",
    "pin": "კომენტარის დაპინვა",
    "unpin": "კომენტარის ამოპინვა"
  },
  "templateEditor": {
    "insertField": "ველის ჩასმა",
    "text": "ტექსტი",
    "checkbox": "ჩეკბოქსი",
    "select": "არჩევანი",
    "apiSelect": "API არჩევანი",
    "signature": "ხელმოწერა",
    "table": "ცხრილი",
    "backToList": "სიაში დაბრუნება",
    "templateName": "შაბლონის სახელი",
    "importDocx": ".docx ფაილის ატვირთვა",
    "importWord": "Word ატვირთვა",
    "save": "შენახვა",
    "previewTooltip": "შაბლონის გადახედვა და შევსება",
    "fillPreview": "შევსება / გადახედვა",
    "date": "თარიღი",
    "number": "რიცხვი",
    "textarea": "ტექსტის არე",
    "image": "სურათი",
    "calculated": "გამოთვლა",
    "autoFill": "ავტო-შევსება",
    "mirror": "კოპირება",
    "tooltips": {
      "text": "ტექსტური ველის ჩასმა",
      "checkbox": "ჩეკბოქსის ჩასმა",
      "select": "სტატიკური ვარიანტების ჩამოსაშლელის ჩასმა",
      "apiSelect": "API ვარიანტების ჩამოსაშლელის ჩასმა",
      "signature": "ხელმოწერის ველის ჩასმა",
      "table": "დინამიური ცხრილის ჩასმა",
      "date": "თარიღის ველის ჩასმა",
      "number": "რიცხვის ველის ჩასმა",
      "textarea": "მრავალხაზიანი ტექსტის ველის ჩასმა",
      "image": "სურათის/ფაილის ატვირთვის ველის ჩასმა",
      "calculated": "გამოთვლის ველის ჩასმა",
      "autoFill": "ავტო-შევსების ველის ჩასმა (პაციენტი, ექიმი, თარიღი)",
      "mirror": "კოპირების ველის ჩასმა (ველის მნიშვნელობის დუბლირება)"
    }
  },
  "servicePackages": {
    "title": "სერვის პაკეტები",
    "active": "აქტიური",
    "inactive": "არააქტიური",
    "days": "დღე",
    "servicesCount": "სერვისი",
    "columns": {
      "name": "დასახელება",
      "price": "ფასი",
      "validity": "ვადა",
      "services": "სერვისები",
      "status": "სტატუსი",
      "actions": "მოქმედებები"
    },
    "buttons": {
      "purchases": "შეძენები",
      "create": "შექმნა",
      "sell": "გაყიდვა",
      "cancel": "გაუქმება",
      "details": "დეტალები"
    },
    "filters": {
      "search": "ძიება...",
      "status": "სტატუსი",
      "all": "ყველა",
      "receivedGifts": "მიღებული საჩუქრები",
      "givenGifts": "გაჩუქებული",
      "ownPurchases": "საკუთარი"
    },
    "status": {
      "ACTIVE": "აქტიური",
      "USED": "გამოყენებული",
      "CANCELLED": "გაუქმებული",
      "EXPIRED": "ვადაგასული"
    },
    "lifecycle": {
      "new": "ახალი",
      "partiallyUsed": "ნაწილობრივ გამოყენებული",
      "fullyUsed": "სრულად გამოყენებული",
      "cancelled": "გაუქმებული",
      "expired": "ვადაგასული"
    },
    "form": {
      "createTitle": "პაკეტის შექმნა",
      "editTitle": "პაკეტის რედაქტირება",
      "basicInfo": "ძირითადი ინფორმაცია",
      "name": "დასახელება",
      "namePlaceholder": "პაკეტის სახელი",
      "price": "ფასი",
      "validityDays": "მოქმედების ვადა (დღეები)",
      "isActive": "აქტიური",
      "description": "აღწერა",
      "descriptionPlaceholder": "პაკეტის აღწერა",
      "servicesTitle": "შემავალი სერვისები",
      "addService": "სერვისის დამატება",
      "noServices": "სერვისები არ არის დამატებული",
      "selectService": "აირჩიეთ სერვისი",
      "quantity": "რაოდენობა",
      "originalPrice": "ორიგინალი ფასი",
      "discountPercent": "ფასდაკლება %",
      "discountedPrice": "ფასდაკლებული ფასი",
      "totalOriginal": "ჯამი ორიგინალი",
      "discount": "ფასდაკლება",
      "packageTotal": "პაკეტის ფასი",
      "itemsSum": "სერვისების ჯამი",
      "useItemsSum": "ჯამზე დაბრუნება",
      "serviceName": "სერვისის სახელი"
    },
    "view": {
      "title": "პაკეტის დეტალები",
      "details": "დეტალები",
      "includedServices": "შემავალი სერვისები",
      "subtotal": "ქვეჯამი",
      "recentPurchases": "ბოლო შეძენები"
    },
    "purchases": {
      "title": "შეძენების ისტორია",
      "package": "პაკეტი",
      "customer": "მომხმარებელი",
      "owner": "მფლობელი",
      "status": "სტატუსი",
      "lifecycle": "ცხოვრების ციკლი",
      "usage": "გამოყენება",
      "price": "ფასი",
      "validUntil": "მოქმედებს",
      "empty": "შეძენები არ მოიძებნა",
      "filterStatus": "სტატუსით ფილტრი",
      "filterPackage": "პაკეტით ფილტრი",
      "filterCustomer": "მომხმარებლით ფილტრი",
      "searchPlaceholder": "ძებნა სახელით ან ტელეფონით",
      "emptyFiltered": "ფილტრის შესაბამისი შენაძენი არ მოიძებნა",
      "emptyNone": "შენაძენები ჯერ არ არის",
      "editedBadge": "რედაქტირებული",
      "giftFrom": "საჩუქარი —",
      "giftTo": "აჩუქა —"
    },
    "sellModal": {
      "title": "პაკეტის გაყიდვა",
      "customer": "მომხმარებელი",
      "searchCustomer": "მომხმარებლის ძიება...",
      "paymentMethod": "გადახდის მეთოდი",
      "paidAmount": "გადახდილი თანხა",
      "comment": "კომენტარი",
      "commentPlaceholder": "კომენტარი (არაა სავალდებულო)",
      "paymentSumMismatch": "გადასახდელი თანხა უნდა ემთხვეოდეს პაკეტის ფასს"
    },
    "editModal": {
      "displayName": "სახელი",
      "validUntil": "მოქმედების ვადა",
      "comment": "კომენტარი",
      "items": "სერვისები",
      "service": "სერვისი",
      "quantity": "რაოდენობა",
      "originalPrice": "ორიგინალი ფასი",
      "discountedPrice": "ფასდაკლებული ფასი",
      "consumed": "გამოყენებული",
      "addItem": "სერვისის დამატება",
      "added": "სერვისის დამატება",
      "removed": "სერვისის წაშლა",
      "history": "რედაქტირების ისტორია",
      "noHistory": "რედაქტირების ისტორია არ არსებობს",
      "reason": "რედაქტირების მიზეზი",
      "reasonText": "მიზეზის ტექსტი",
      "balanceChange": "ბალანსი იცვლება",
      "amountToCollect": "გადასახდელი თანხა",
      "fullHistory": "სრული ისტორია",
      "priceRoleDisabled": "ფასის შეცვლის უფლება მხოლოდ ადმინისტრატორს ან მენეჯერს აქვს",
      "futureBookingConflictTitle": "მომავლის ჯავშნებთან კონფლიქტი",
      "futureBookingConflictBookings": "ჯავშნები",
      "futureBookingConflictConfirm": "მაინც შეცვლა",
      "settlementBalance": "ბალანსი",
      "settlementCash": "სალარო",
      "settlementNone": "ფინანსური ოპერაციის გარეშე",
      "chargeCollect": "გადახდა",
      "refundLabel": "თანხის დაბრუნება",
      "customer": "მომხმარებელი",
      "customerBalance": "მიმდინარე ბალანსი",
      "settlementCommentPlaceholder": "კომენტარი დაბრუნება/გადახდაზე",
      "expiredPackageTitle": "ვადაგასული პაკეტი",
      "expiredPackageContent": "გამოყენებული პაკეტი ვადაგასულია. გსურთ კავშირის დასრულება?",
      "expiredPackageConfirm": "გაგრძელება",
      "saleDate": "გაყიდვის თარიღი",
      "soldBy": "გამყიდველი",
      "validity": "მოქმედების პერიოდი",
      "totalPaid": "გადახდილი",
      "payment": "გადახდა",
      "payCash": "ნაღდი",
      "payCard": "ბარათი",
      "payBalance": "ბალანსი",
      "payBank": "გადარიცხვა",
      "payConsignation": "კონსიგნაცია",
      "remaining": "დარჩენილი",
      "totalServices": "სერვისები",
      "totalQuantity": "სულ რაოდენობა",
      "totalOriginal": "ორიგინალი ჯამი",
      "totalDiscounted": "ფასდაკლებული ჯამი",
      "total": "სულ"
    },
    "history": {
      "title": "პაკეტის ისტორია",
      "when": "თარიღი",
      "kind": "ტიპი",
      "who": "ვინ",
      "details": "დეტალები",
      "usage": "გამოყენება",
      "kinds": {
        "audit": "ცვლილება",
        "adjustment": "კორექცია",
        "usage": "გამოყენება",
        "purchase": "შეძენა"
      }
    },
    "confirm": {
      "delete": "ნამდვილად გსურთ პაკეტის წაშლა?",
      "cancel": "ნამდვილად გსურთ შეძენის გაუქმება?",
      "cancelDescription": "გაუქმების შემდეგ მომხმარებელი ვეღარ გამოიყენებს დარჩენილ სერვისებს."
    },
    "messages": {
      "loadError": "პაკეტის ჩატვირთვა ვერ მოხერხდა",
      "created": "პაკეტი წარმატებით შეიქმნა",
      "createError": "პაკეტის შექმნა ვერ მოხერხდა",
      "updated": "პაკეტი წარმატებით განახლდა",
      "updateError": "პაკეტის განახლება ვერ მოხერხდა",
      "deleted": "პაკეტი წარმატებით წაიშალა",
      "deleteError": "პაკეტის წაშლა ვერ მოხერხდა",
      "sold": "პაკეტი წარმატებით გაიყიდა",
      "sellError": "პაკეტის გაყიდვა ვერ მოხერხდა",
      "cancelled": "შეძენა გაუქმდა",
      "cancelError": "შეძენის გაუქმება ვერ მოხერხდა",
      "editError": "რედაქტირების შეცდომა",
      "refunded": "თანხა დაბრუნდა"
    },
    "operations": {
      "title": "ოპერაციები",
      "source": "წყარო",
      "amount": "თანხა"
    },
    "refund": {
      "used": "გამოყენებული",
      "typeLabel": "დაბრუნების ტიპი",
      "type": {
        "full": "სრული თანხის დაბრუნება",
        "remaining": "დარჩენილი ღირებულების დაბრუნება"
      },
      "methodLabel": "დაბრუნების მეთოდი",
      "method": {
        "balance": "მომხმარებლის ბალანსზე",
        "none": "ფინანსური ოპერაციის გარეშე",
        "cashbox": "სალაროს გასავალში"
      },
      "commentLabel": "მიზეზი (არასავალდებულო)",
      "commentPlaceholder": "მიუთითეთ დაბრუნების მიზეზი",
      "fullyUsed": "სრულად გამოყენებული პაკეტის გაუქმება შეუძლებელია",
      "refundable": "დასაბრუნებელი ღირებულება",
      "moneyBack": "დასაბრუნებელი თანხა",
      "voidedDebt": "ჩამოწერილი დავალიანება",
      "confirm": "დაბრუნების დადასტურება",
      "settlementLabel": "დაბრუნების გატარება",
      "settlement": {
        "today": "დღევანდელ სალაროზე",
        "saleDate": "გაყიდვის დღის სალაროზე"
      },
      "settlementHint": "აირჩიეთ, რომელი დღის სალაროდან გავიდეს თანხა. თუ გაყიდვის დღის სალარო დახურულია, ის თავიდან გადაითვლება."
    }
  },
  "nps": {
    "title": "შეფასება",
    "question": "გთხოვთ შეფასოთ, 0-დან 10-მდე, რამდენად გაუწევთ რეკომენდაციას ჩვენს მომსახურებას მეგობართან?",
    "notLikely": "ნაკლებად სავარაუდო",
    "veryLikely": "აუცილებლად",
    "commentPlaceholder": "გთხოვთ დაწეროთ კომენტარი (არასავალდებულო)",
    "submit": "გაგზავნა",
    "thankYou": "მადლობა თქვენი შეფასებისთვის!",
    "error": "შეფასების გაგზავნა ვერ მოხერხდა, სცადეთ ხელახლა"
  },
  "EVENT_DESC": {
    "BOOKED": "კლიენტი იღებს ჯავშნის დადასტურებას.",
    "COMPLETED": "კლიენტი იღებს შეტყობინებას ვიზიტის დასრულების შემდეგ.",
    "BOOKING_UPDATE": "კლიენტი შეიტყობს, რომ ჯავშანი შეიცვალა.",
    "BOOKING_DELETED": "კლიენტი შეიტყობს ჯავშნის გაუქმების შესახებ.",
    "BOOKING_REMINDER": "კლიენტი იღებს შეხსენებას ვიზიტამდე.",
    "PERIODIC_REMINDER": "კლიენტს ვახსენებთ, რომ ისევ ჩაეწეროს.",
    "ONLINE_BOOKING_INCOME": "კლიენტი იღებს ონლაინ ჯავშნის დადასტურებას.",
    "ONLINE_BOOKING_CANCEL": "კლიენტი შეიტყობს, რომ ონლაინ ჯავშანი გაუქმდა.",
    "VERIFICATION_SMS": "კლიენტი იღებს კოდსა და ბმულს დასადასტურებლად.",
    "OFFER_EXPIRY_WARNING": "მყიდველი შეიტყობს, რომ ვაუჩერს ვადა ეწურება.",
    "OFFER_PURCHASE_CONFIRMATION": "მყიდველი იღებს ვაუჩერის შეძენის დადასტურებას.",
    "OFFER_MERCHANT_NOTIFICATION": "თქვენი გუნდი შეიტყობს ვაუჩერის გაყიდვის შესახებ.",
    "PACKAGE_PURCHASE_CONFIRMATION": "მყიდველი იღებს პაკეტის შეძენის დადასტურებას.",
    "PACKAGE_USAGE": "მყიდველი შეიტყობს, რომ პაკეტიდან ერთი სერვისი გამოიყენა.",
    "PACKAGE_BATCH_USAGE": "მყიდველი შეიტყობს, რომ ერთ ვიზიტში რამდენიმე სერვისი გამოიყენა.",
    "PACKAGE_EXPIRED": "მყიდველი შეიტყობს, რომ პაკეტს ვადა გაუვიდა.",
    "PACKAGE_EXPIRY_WARNING": "მყიდველი შეიტყობს, რომ პაკეტს ვადა ეწურება.",
    "INVOICE_GENERATED": "სალონი იღებს შეტყობინებას ინვოისის შექმნისას.",
    "EMPLOYEE_PASSWORD_RESET": "თანამშრომელი იღებს ახალ მონაცემებს შესასვლელად.",
    "USER_PASSWORD_RESET": "მომხმარებელი იღებს ახალ მონაცემებს შესასვლელად."
  },
  "KEYWORD": {
    "code": "კოდი",
    "customerName": "მომხმარებლის სახელი",
    "date": "თარიღი",
    "daysBeforeExpiry": "დღეები ვადის ამოწურვამდე",
    "expiryDate": "ვადის ამოწურვის თარიღი",
    "firstName": "სახელი",
    "invoiceId": "ინვოისის ნომერი",
    "link": "ბმული",
    "offerName": "ვაუჩერის დასახელება",
    "organizationName": "ორგანიზაცია",
    "packageName": "პაკეტის დასახელება",
    "password": "პაროლი",
    "positionName": "სპეციალისტი",
    "price": "ფასი",
    "remaining": "დარჩენილი სერვისები",
    "serviceName": "სერვისი",
    "serviceNames": "სერვისები",
    "source": "წყარო",
    "time": "დრო",
    "totalPrice": "ჯამური თანხა",
    "username": "მომხმარებელი",
    "validFrom": "მოქმედების დაწყება",
    "validTo": "მოქმედების დასრულება",
    "validUntil": "მოქმედების ვადა"
  },
  "warehouse": {
    "products": {
      "addProduct/edit": "პროდუქტის დამატება/რედაქტირება",
      "updateHistory": "პროდუქტის განახლების ისტორია",
      "updateProduct": "პროდუქტის განახლება",
      "stockAccounting": "მარაგის აღრიცხვა",
      "addProvider/edit": "მომწოდებლის დამატება/რედაქტირება",
      "addEditCategory": "კატეგორიის დამატება/რედაქტირება",
      "barcodeAlready": "ბარკოდი უკვე არსებობს ბაზაში",
      "title": "პროდუქტები",
      "column": {
        "barcode": "ბარკოდი",
        "productCode": "პროდუქტის კოდი",
        "title": "დასახელება",
        "category": "კატეგორია",
        "provider": "მომწოდებელი",
        "quantity": "რაოდენობა",
        "grammInEach": "გრამი ცალში",
        "receivingPrice": "მისაღები ფასი",
        "admissionPrice(average)": "მისაღები ფასი(საშუალო)",
        "salePrice": "გასაყიდი ფასი",
        "sumTotal": "ჯამი",
        "sumTotal(gram)": "ჯამი(გრამი)",
        "dateOfPurchase": "შეძენის თარიღი",
        "validUntil": "ვარგისია",
        "dateOfUpdate": "განახლების თარიღი",
        "createdBy": "ვინ შექმნა",
        "comment": "კომენტარი",
        "stockAccounting": "მარაგის აღრიცხვა",
        "currentBalance": "მიმდინარე ბალანსი",
        "changeInStock": "მარაგების ცვლილება",
        "created": "შექმნილი",
        "legalForm": "სამართლებრივი ფორმა",
        "identification": "საიდენტიფიკაციო #",
        "phoneNumber": "ტელეფონი",
        "information": "ინფორმაცია"
      },
      "form": {
        "barcode": "ბარკოდი",
        "productCode": "პროდუქტის კოდი",
        "title": "დასახელება",
        "category": "კატეგორია",
        "provider": "მომწოდებელი",
        "quantity": "რაოდენობა",
        "grammInEach": "გრამი ცალში",
        "receivingPrice": "მისაღები ფასი",
        "admissionPrice(average)": "მისაღები ფასი(საშუალო)",
        "salePrice": "გასაყიდი ფასი",
        "sumTotal": "ჯამი",
        "Balance(grams)": "ნაშთი(გრამი)",
        "dateOfPurchase": "შეძენის თარიღი",
        "validUntil": "ვარგისია",
        "comment": "კომენტარი",
        "averagePrice": "საშუალო ფასი",
        "expenseProcessing": "გასავალში გატარება",
        "selectDate": "აირჩიეთ თარიღი",
        "accountingDate": "აღრიცხვის თარიღი",
        "responsiblePerson": "პასუხისმგებელი პირი",
        "gram": "გრამი",
        "productCategory": "პროდუქტის კატეგორია",
        "legalForm": "სამართლებრივი ფორმა",
        "identification": "საიდენტიფიკაციო #",
        "phoneNumber": "ტელეფონი",
        "information": "ინფორმაცია"
      }
    },
    "categories": {
      "title": "კატეგორიები"
    },
    "Providers": {
      "title": "მომწოდებლები"
    },
    "list": {
      "title": "საწყობები",
      "create": "საწყობის შექმნა"
    },
    "columns": {
      "name": "სახელი",
      "type": "ტიპი",
      "address": "მისამართი",
      "status": "სტატუსი",
      "actions": "მოქმედებები"
    },
    "types": {
      "MAIN": "მთავარი",
      "SECONDARY": "მეორეული",
      "TRANSIT": "ტრანზიტი"
    },
    "default": "ძირითადი",
    "active": "აქტიური",
    "inactive": "არააქტიური",
    "setDefault": "ძირითადად დაყენება",
    "confirm": {
      "delete": "ნამდვილად გსურთ საწყობის წაშლა?"
    },
    "messages": {
      "setDefault": "საწყობი დაყენდა ძირითადად",
      "setDefaultError": "ძირითადად დაყენება ვერ მოხერხდა",
      "deleted": "საწყობი წაიშალა",
      "deleteError": "საწყობის წაშლა ვერ მოხერხდა",
      "loadError": "საწყობის ჩატვირთვა ვერ მოხერხდა",
      "created": "საწყობი წარმატებით შეიქმნა",
      "createError": "საწყობის შექმნა ვერ მოხერხდა",
      "updated": "საწყობი წარმატებით განახლდა",
      "updateError": "საწყობის განახლება ვერ მოხერხდა"
    },
    "form": {
      "createTitle": "საწყობის შექმნა",
      "editTitle": "საწყობის რედაქტირება",
      "basicInfo": "ძირითადი ინფორმაცია",
      "name": "სახელი",
      "namePlaceholder": "საწყობის სახელი",
      "type": "ტიპი",
      "typePlaceholder": "აირჩიეთ ტიპი",
      "address": "მისამართი",
      "addressPlaceholder": "საწყობის მისამართი",
      "description": "აღწერა",
      "descriptionPlaceholder": "საწყობის აღწერა",
      "isDefault": "ძირითადი საწყობი",
      "isActive": "აქტიური"
    },
    "tabs": {
      "stock": "მარაგი",
      "movements": "მოძრაობა"
    },
    "stock": {
      "title": "მარაგები",
      "selectWarehouse": "საწყობის არჩევა",
      "product": "პროდუქტი",
      "category": "კატეგორია",
      "distributor": "მომწოდებელი",
      "quantity": "რაოდენობა",
      "grAmount": "გრამი",
      "avgCost": "საშ. თვითღირებულება",
      "sellPrice": "გასაყიდი ფასი",
      "totalValue": "ჯამური ღირებულება",
      "search": "პროდუქტის ძებნა...",
      "viewMovements": "მოძრაობის ნახვა",
      "lowStock": "დაბალი მარაგი"
    },
    "movements": {
      "date": "თარიღი",
      "product": "პროდუქტი",
      "type": "ტიპი",
      "quantity": "რაოდენობა",
      "balance": "ნაშთი",
      "notes": "შენიშვნა"
    },
    "movementTypes": {
      "RECEIVING": "მიღება",
      "SALE_DEDUCTION": "გაყიდვა",
      "SALE_RETURN": "გაყიდვის დაბრუნება",
      "TRANSFER_OUT": "ტრანსფერი (გასვლა)",
      "TRANSFER_IN": "ტრანსფერი (შემოსვლა)",
      "ADJUSTMENT": "კორექტირება",
      "SERVICE_CONSUMPTION": "სერვისის მოხმარება",
      "SERVICE_RETURN": "სერვისის დაბრუნება",
      "COUNT_CORRECTION": "ინვენტარიზაცია",
      "WRITE_OFF": "ჩამოწერა",
      "SUPPLIER_RETURN": "მომწოდებელზე დაბრუნება",
      "INITIAL_MIGRATION": "საწყისი მიგრაცია"
    },
    "adjustment": {
      "title": "მარაგის კორექტირება",
      "type": "კორექტირების ტიპი",
      "newQuantity": "ახალი რაოდენობა",
      "newGrAmount": "ახალი გრამი",
      "reason": "მიზეზი",
      "reasonPlaceholder": "კორექტირების მიზეზი"
    }
  },
  "realization": {
    "operationCompleted": "ოპერაცია შესრულებულია",
    "search": {
      "user": "მომხმარებელი",
      "realizationType": "რეალიზაციის ტიპი",
      "withBarcode": "ბარკოდით მოძიება",
      "searchProduct": "პროდუქტის მოძიება"
    },
    "form": {
      "card": "ბარათის #",
      "firstname": "სახელი",
      "name": "დასახელება",
      "lastname": "გვარი",
      "phoneNumber": "ტელეფონის ნომერი",
      "idNumber": "პირადი ნომერი",
      "gender": "სქესი",
      "female": "ქალი",
      "male": "კაცი",
      "dateOfBirth": "დაბადების თარიღი",
      "chooseDate": "აირჩიეთ თარიღი",
      "country": "ქვეყანა",
      "city": "ქალაქი",
      "address": "მისამართი",
      "workingPlace": "სამუშაო ადგილი",
      "createTitle": "ახალი საწყობის შექმნა",
      "editTitle": "საწყობის რედაქტირება",
      "basicInfo": "ძირითადი ინფორმაცია",
      "namePlaceholder": "შეიყვანეთ საწყობის დასახელება",
      "type": "ტიპი",
      "typePlaceholder": "აირჩიეთ ტიპი",
      "addressPlaceholder": "შეიყვანეთ მისამართი",
      "description": "აღწერა",
      "descriptionPlaceholder": "შეიყვანეთ აღწერა",
      "isDefault": "ნაგულისხმევი",
      "isActive": "აქტიური"
    },
    "categoryDetail": {
      "provider": "მომწოდებელი",
      "price": "ფასი",
      "quantity": "რაოდენობა",
      "grammInEach": "გრამი ცალში",
      "gramsTotal": "გრამი სულ"
    },
    "category": "კატეგორია",
    "sumTotal": "ჯამი",
    "gel": "ლარი",
    "quantity": "რაოდენობა",
    "piece": "ცალი",
    "gram": "გრამი",
    "paymentMethod": "გადახდის მეთოდი",
    "balance": "ბალანსი",
    "available": "ხელმისაწვდომი",
    "cash": "ნაღდი",
    "card": "საბანკო ბარათი",
    "exchange": "ბარტერი",
    "consignment": "კონსიგნაცია",
    "pay": "გადახდა",
    "comment": "კომენტარი",
    "specifyComment": "მიუთითეთ კომენტარი",
    "paymentWithCash": "ნაღდი ანგარიშსწორება",
    "BankCard": "საბანკო ბარათი",
    "cashViaBank": "ნაღდი + საბანკო",
    "sell": "გაყიდვა",
    "spend": "გახარჯვა",
    "productOutStock": "პროდუქტი არ არის მარაგში",
    "createUser": "მომხმარებლის შექმნა",
    "price": "ფასი",
    "discount": "ფასდაკლების %",
    "withDiscount": "ფასდაკლებით",
    "employee": "თანამშრომელი",
    "addEmployee/edit": "თანამშრომლის დამატება/რედაქტირება",
    "percent": "პროცენტი",
    "salary": "ხელფასი",
    "list": {
      "title": "საწყობები",
      "create": "საწყობის შექმნა"
    },
    "columns": {
      "name": "დასახელება",
      "type": "ტიპი",
      "address": "მისამართი",
      "status": "სტატუსი",
      "actions": "მოქმედებები"
    },
    "types": {
      "MAIN": "მთავარი",
      "SECONDARY": "დამხმარე",
      "TRANSIT": "სატრანზიტო"
    },
    "default": "ნაგულისხმევი",
    "active": "აქტიური",
    "inactive": "არააქტიური",
    "setDefault": "ნაგულისხმევად დაყენება",
    "confirm": {
      "delete": "ნამდვილად გსურთ საწყობის წაშლა?"
    },
    "messages": {
      "created": "საწყობი წარმატებით შეიქმნა",
      "updated": "საწყობი წარმატებით განახლდა",
      "deleted": "საწყობი წარმატებით წაიშალა",
      "setDefault": "ნაგულისხმევი საწყობი განახლდა",
      "loadError": "საწყობის ჩატვირთვა ვერ მოხერხდა",
      "createError": "საწყობის შექმნა ვერ მოხერხდა",
      "updateError": "საწყობის განახლება ვერ მოხერხდა",
      "deleteError": "საწყობის წაშლა ვერ მოხერხდა",
      "setDefaultError": "ნაგულისხმევი საწყობის დაყენება ვერ მოხერხდა"
    },
    "tabs": {
      "stock": "მარაგი",
      "movements": "მოძრაობები"
    },
    "stock": {
      "title": "მარაგები",
      "selectWarehouse": "აირჩიეთ საწყობი",
      "search": "პროდუქტის ძებნა...",
      "product": "პროდუქტი",
      "category": "კატეგორია",
      "quantity": "რაოდ.",
      "grAmount": "გრამი",
      "avgCost": "საშ. ფასი",
      "sellPrice": "გასაყიდი",
      "totalValue": "ღირებულება",
      "viewMovements": "მოძრაობების ნახვა",
      "lowStock": "დაბალი მარაგი"
    },
    "movements": {
      "title": "მარაგის მოძრაობა",
      "date": "თარიღი",
      "product": "პროდუქტი",
      "type": "ტიპი",
      "quantity": "რაოდენობა",
      "grAmount": "გრამი",
      "balance": "ბალანსი",
      "unitCost": "ერთ. ფასი",
      "reference": "მითითება",
      "performer": "შემსრულებელი",
      "notes": "შენიშვნა"
    },
    "movementTypes": {
      "RECEIVING": "მიღება",
      "SALE_DEDUCTION": "გაყიდვა",
      "SALE_RETURN": "გაყიდვის დაბრუნება",
      "TRANSFER_OUT": "ტრანსფერი (გასვლა)",
      "TRANSFER_IN": "ტრანსფერი (შემოსვლა)",
      "ADJUSTMENT": "კორექტირება",
      "SERVICE_CONSUMPTION": "სერვისის მოხმარება",
      "SERVICE_RETURN": "სერვისის დაბრუნება",
      "COUNT_CORRECTION": "ინვენტარიზაცია",
      "INITIAL_MIGRATION": "საწყისი მიგრაცია",
      "WRITE_OFF": "ჩამოწერა",
      "SUPPLIER_RETURN": "მომწოდებელზე დაბრუნება"
    },
    "adjustment": {
      "title": "მარაგის კორექტირება",
      "product": "პროდუქტი",
      "currentQty": "მიმდინარე რაოდენობა",
      "currentGr": "მიმდინარე გრამი",
      "type": "კორექტირების ტიპი",
      "newQty": "ახალი რაოდენობა",
      "newGr": "ახალი გრამი",
      "reason": "მიზეზი",
      "reasonPlaceholder": "მიუთითეთ კორექტირების მიზეზი",
      "types": {
        "COUNT": "დათვლა",
        "DAMAGE": "დაზიანება",
        "LOSS": "დაკარგვა",
        "EXPIRY": "ვადის გასვლა",
        "RETURN": "დაბრუნება",
        "OTHER": "სხვა"
      }
    }
  },
  "schedule": {
    "vacationRange": "შვებულება (დიაპაზონი)",
    "vacationApply": "დამატება",
    "vacationConflict": "დიაპაზონში არსებობს {{count}} კონფლიქტი. მაინც გავაგრძელოთ?",
    "vacationSaved": "შვებულება დაემატა",
    "vacationPickRange": "აირჩიეთ პერიოდი",
    "clearAll": "განრიგის გასუფთავება",
    "clearConfirmTitle": "ნამდვილად გსურთ თანამშრომლის სამუშაო განრიგის სრულად წაშლა?",
    "clearConfirmBody": "თანამშრომლის მთელი სამუშაო განრიგი წაიშლება.",
    "clearWarnBookings": "ყურადღება: თანამშრომელს აქვს {{count}} დაჯავშნილი ვიზიტი — განრიგის წაშლის შემდეგ ისინი დარჩება განრიგის გარეშე.",
    "cleared": "განრიგი გასუფთავდა",
    "clearWhat": "რა წავშალოთ?",
    "clearFromToday": "იშლება მხოლოდ დღევანდელი დღიდან (წარსული რჩება)",
    "clearWillRemove": "წაიშლება {{count}} ჩანაწერი",
    "leaveType": "ტიპი",
    "period": "პერიოდი",
    "conflictTitle": "დიაპაზონში აღმოჩენილია კონფლიქტები",
    "conflictBookings": "ჯავშნები",
    "conflictLeave": "არსებული არასამუშაო დღეები",
    "conflictProceed": "მაინც გავაგრძელოთ?",
    "startDate": "დაწყების თარიღი",
    "endDate": "დასრულების თარიღი",
    "applyOn": "აირჩიეთ დღეები",
    "workingHours": "სამუშაო საათები",
    "perDayHours": "ინდივიდუალური საათები (არასავალდებულო)",
    "addBreak": "შესვენების დამატება",
    "breaksAllDays": "შესვენებები (ყველა დღე)",
    "save": "შენახვა",
    "endAfterStart": "დასრულება უნდა იყოს დაწყების შემდეგ",
    "statusLabel": "სტატუსი",
    "statusRequired": "სტატუსის მითითება სავალდებულოა",
    "weekday": {
      "0": "კვი",
      "1": "ორშ",
      "2": "სამ",
      "3": "ოთხ",
      "4": "ხუთ",
      "5": "პარ",
      "6": "შაბ"
    },
    "break": {
      "LUNCH": "ლანჩი",
      "COFFEE": "ყავა",
      "PERSONAL": "პირადი"
    },
    "createSchedule": "განრიგის შექმნა",
    "addVacation": "შვებულების დამატება",
    "addDay": "დღის დამატება",
    "logs": "ისტორია",
    "cancel": "გაუქმება",
    "multiTitle": "მრავალდღიანი განრიგი",
    "editDay": "დღის რედაქტირება",
    "auditTitle": "ცვლილებების ისტორია",
    "status": {
      "SCHEDULED": "დაგეგმილი",
      "DAY_OFF": "დასვენება",
      "SICK_LEAVE": "ბიულეტენი",
      "VACATION": "შვებულება"
    }
  },
  "scheduleOverview": {
    "title": "თანამშრომლების გრაფიკი",
    "employee": "თანამშრომელი",
    "searchPlaceholder": "ძებნა სახელით",
    "positionAll": "ყველა პოზიცია",
    "today": "დღეს",
    "oneMonth": "1 თვე",
    "nMonths": "{{count}} თვე",
    "unscheduledDivider": "გრაფიკის გარეშე",
    "unscheduledCount": "{{count}} თანამშრომელი გრაფიკის გარეშე",
    "rowActions": "მოქმედებები",
    "rowActionHours": "სამუშაო საათები (პერიოდი)",
    "rowActionLeave": "შვებულების დამატება",
    "rowActionClear": "გრაფიკის გასუფთავება",
    "noEmployees": "თანამშრომელი ვერ მოიძებნა",
    "error": "გრაფიკის ჩატვირთვა ვერ მოხერხდა",
    "retry": "თავიდან ცდა"
  },
  "procedures": {
    "hub": {
      "overview": "მიმოხილვა",
      "employees": "თანამშრომლები",
      "category": "კატეგორია",
      "colour": "ფერი",
      "type": "ტიპი",
      "price": "ფასი",
      "discountPrice": "ფასდაკლებული ფასი",
      "duration": "ხანგრძლივობა",
      "vat": "დღგ",
      "maxParallel": "მაქს. პარალელური ჯავშანი",
      "onlineBooking": "ონლაინ ჯავშანი",
      "boundEmployees": "დაკავშირებული თანამშრომელი",
      "missingParameters": "ხელფასის ორმაგი პირობა",
      "selectAll": "ყველას მონიშვნა",
      "percent": "%",
      "noParameters": "პარამეტრები არ არის",
      "saved": "შენახულია",
      "saveFailed": "შენახვა ვერ მოხერხდა",
      "fillAllFields": "მონიშნულ თანამშრომლებს შეავსეთ ფასი, დრო და ხელფასის ერთი პირობა — პროცენტი ან ფიქსირებული, არა ორივე.",
      "save": "შენახვა",
      "loadProcedureFailed": "პროცედურის დეტალების ჩატვირთვა ვერ მოხერხდა.",
      "loadEmployeesFailed": "თანამშრომლების ჩატვირთვა ვერ მოხერხდა.",
      "loadBindingsFailed": "თანამშრომლების პარამეტრების ჩატვირთვა ვერ მოხერხდა.",
      "noneSelected": "შენახვამდე მონიშნეთ მინიმუმ ერთი თანამშრომელი.",
      "futureBookings": "{{count}} მომავალი ჯავშანი",
      "willUnbind": "მოიხსნება {{count}} თანამშრომელი",
      "confirmUnbindTitle": "თანამშრომლის მოხსნა",
      "confirmUnbindOk": "მოხსნა",
      "confirmUnbindCancel": "გაუქმება",
      "confirmUnbindNote": "არსებული ჯავშნები არ წაიშლება. მოხსნის შემდეგ ეს პროცედურა ამ თანამშრომლებზე ახალ ჯავშნებში აღარ შემოთავაზდება.",
      "fixedSalary": "ფიქსირებული",
      "searchEmployee": "თანამშრომლის ძებნა",
      "defaultsLegend": "ღია ფერით ნაჩვენებია ნაგულისხმევი მნიშვნელობა — დააჭირე, თუ ამ თანამშრომელს სხვა უნდა დაუწესო.",
      "useDefault": "ნაგულისხმევზე დაბრუნება",
      "overrideHint": "დააჭირე ამ თანამშრომლისთვის სხვა მნიშვნელობის მისათითებლად",
      "addEmployee": "თანამშრომლის დამატება",
      "noEmployeesYet": "ამ სერვისზე თანამშრომელი ჯერ არ არის დამატებული.",
      "sharedParams": "საერთო პარამეტრები",
      "applyToSelected": "მონიშნულებზე გავრცელება",
      "sharedApplied": "პარამეტრები გავრცელდა {{count}} თანამშრომელზე",
      "addAll": "ყველას დამატება",
      "allAdded": "დაემატა {{count}} თანამშრომელი"
    }
  },
  "employee360": {
    "tab": "360",
    "loadFailed": "მონაცემები ვერ ჩაიტვირთა",
    "retry": "თავიდან ცდა",
    "scheduledDays": "ნამუშევარი დღეები",
    "custom": {
      "from": "დაწყება",
      "to": "დასრულება"
    },
    "period": {
      "TODAY": "დღეს",
      "YESTERDAY": "გუშინ",
      "THIS_WEEK": "მიმდინარე კვირა",
      "LAST_WEEK": "წინა კვირა",
      "THIS_MONTH": "მიმდინარე თვე",
      "LAST_MONTH": "წინა თვე",
      "THIS_YEAR": "მიმდინარე წელი",
      "CUSTOM": "პერიოდი"
    },
    "kpi": {
      "revenue": "შემოტანილი თანხა",
      "cost": "დარიცხული ხელფასი",
      "netProfit": "მოგება",
      "margin": "მოგების მარჟა",
      "serviceEarned": "მომსახურებიდან",
      "productEarned": "პროდუქტებიდან",
      "salaryPaid": "გაცემული ხელფასი",
      "revenuePerWorkedDay": "საშუალო დღიური შემოსავალი"
    },
    "countUnit": {
      "visits": "ვიზიტები",
      "bookings": "ჯავშნები",
      "services": "სერვისები"
    },
    "counts": {
      "total": "სულ",
      "completed": "დასრულებული",
      "upcoming": "შესასრულებელი",
      "cancelled": "გაუქმებული",
      "noShow": "არ გამოცხადდა"
    },
    "hourlyLoad": "საათობრივი დატვირთვა",
    "topServices": "ტოპ სერვისები",
    "topServicesColumns": {
      "name": "დასახელება",
      "count": "რაოდენობა",
      "revenue": "შემოსავალი"
    },
    "noData": "მონაცემები არ არის"
  },
  "visit": {
    "missing": {
      "customer": "აირჩიეთ მომხმარებელი",
      "date": "მიუთითეთ თარიღი",
      "startTime": "მიუთითეთ დაწყების დრო",
      "endTime": "მიუთითეთ დასრულების დრო",
      "unknown": "ჯავშნის შესანახად ყველა სავალდებულო ველი უნდა იყოს შევსებული"
    }
  }
}
